export default {
  "messages": {
    "payment_terms": "Termini di pagamento:",
    "primary_contact": "Contatto primario:",
    "outstanding_invoices": "Fatture insolute",
    "invoice": "Fattura n.",
    "bill_date": "Data fattura fornitore",
    "due_date": "Data di scadenza",
    "days_past_due": "I giorni passati",
    "balance_due": "Saldo dovuto",
    "status": "Stato",
    "actions": "Azioni",
    "draft": "Progetto",
    "view": "Visualizza",
    "no_outstanding_posted_bills_for_this_supplier": "Nessun bollette postate eccezionale per questo fornitore.",
    "close": "Chiudi",
    "pay_selected_bills": "Paga le fatture selezionate",
    "payment_date": "Data di pagamento",
    "payment_method": "Metodo di pagamento",
    "select_method": "Selezionare il metodo",
    "bank_account": "Conto bancario",
    "select_bank_account": "Selezionare il conto bancario",
    "bank_account_required_for_bank_payments": "Conto bancario richiesto per i pagamenti bancari.",
    "reference_memo": "Riferimento / Memo",
    "pay_full_balances": "Paga i conti completi",
    "supplier": "Fornitore",
    "amount_to_pay": "Importo da pagare",
    "no_bills_selected": "Nessuna fattura fornitore selezionata.",
    "total_to_pay": "Totale della retribuzione",
    "cancel": "Annulla",
    "bill_details": "Dettagli di Bill",
    "loading_bill_details": "Caricamento dettagli di fattura...",
    "description": "Descrizione",
    "qty": "Q",
    "unit_price": "Prezzo unitario",
    "amount": "Importo",
    "no_line_items_recorded": "Nessun elemento di linea registrato.",
    "reference": "Riferimento",
    "method": "Metodo",
    "allocated": "Allocato",
    "no_allocations_recorded": "Nessuna assegnazione registrata.",
    "no_bill_found": "Nessun conto trovato.",
    "vendor": "Venditore",
    "search_suppliers": "Fornitori di ricerca...",
    "loading_suppliers": "Fornitori di carico...",
    "no_suppliers_found": "Nessun fornitore trovato.",
    "vendor_is_required": "Il venditore è richiesto.",
    "vendor_invoice": "Fatturato del venditore",
    "invoice_number_is_required": "Il numero di fattura è richiesto.",
    "show_all_account_types": "Mostra tutti i tipi di account",
    "loading_accounts": "Conti di carico...",
    "loading_dimensions": "Dimensioni di carico...",
    "loading_tax_codes": "Caricamento dei codici fiscali...",
    "tax_codes_failed_to_load_defaulting_to_no_tax": "I codici fiscali non sono riusciti a caricare.",
    "tax_code": "Codice fiscale",
    "gl_account": "Conto di contabilità generale",
    "dimension": "Dimensione",
    "no_tax": "Nessuna tassa",
    "tax": "Imposta",
    "select_account": "Selezionare account",
    "no_dimension": "Nessuna dimensione",
    "add_at_least_one_line_with_an_amount": "Aggiungere almeno una linea con un importo.",
    "add_line": "Aggiungere la linea",
    "total": "Totale",
    "notes": "Note",
    "optional_notes": "Note opzionali",
    "saving": "Salvataggio…",
    "record_ap_payment": "Registrazione AP pagamento",
    "payment_amount": "Importo di pagamento",
    "paid_date": "Data di pagamento",
    "apply": "Applica",
    "allocate": "Alloca",
    "draft_2": "Bozza",
    "allocated_total": "Totale assegnato",
    "unapplied_amount": "Importo non applicato",
    "recording": "Registrazione...",
    "record_payment": "Pagamento record",
    "from": "Da",
    "to": "A",
    "generate": "Generazione",
    "opening_balance": "Bilancia di apertura",
    "closing_balance": "Bilancia di chiusura",
    "bill": "Bill Bill.",
    "no_bills_found_for_this_period": "Nessuna fattura trovata per questo periodo.",
    "no_payments_found_for_this_period": "Nessun pagamento trovato per questo periodo.",
    "select_a_date_range_to_generate_a_statement": "Selezionare un intervallo di date per generare una dichiarazione.",
    "employee": "Dipendenti",
    "unassigned": "Non assegnato",
    "retry": "Riprova",
    "generating": "Generando...",
    "generated": "Generazione",
    "sending": "Invio…",
    "privana_assist": "Privana Assistente",
    "warning": "avvertimento",
    "employees": "Dipendenti",
    "rate": "Tasso",
    "calendar": "Calendario",
    "team_member": "Membro del team",
    "creating": "Creare...",
    "saving_2": "Salvataggio…",
    "cancel_close": "Annullare / Chiudere",
    "save_changes": "Salvare le modifiche",
    "profile": "Profilo",
    "pending": "in attesa",
    "currency": "Valuta",
    "tax_code_2": "Codice fiscale",
    "audit_trail": "Registro di audit",
    "system": "Sistema",
    "account": "Conto",
    "debit": "Debito",
    "credit": "Credito",
    "preview": "Anteprima",
    "status_filter": "Filtro di stato",
    "all_statuses": "Tutti gli stati",
    "submit": "Inviare",
    "approve": "Approvo",
    "reject": "Rifiuti",
    "save_draft": "Salvare il progetto",
    "loading": "Caricamento…",
    "adjustments": "Aggiustazioni",
    "working": "Lavorare...",
    "posted": "Contabilizzato",
    "next_step": "Prossimo passo",
    "publishing": "Pubblicazione...",
    "hide": "Nascondi",
    "audit_trail_2": "Sentiero di Audit",
    "needs_review": "Bisogno recensione",
    "configured": "Configurato",
    "default": "Predefinito",
    "edit": "Modifica",
    "active": "attivo",
    "archived": "archiviato",
    "manual": "Manuale",
    "priority": "Priorità:",
    "review": "Recensione",
    "suppliers": "Fornitori",
    "payroll": "Pagamenti",
    "statement": "Dichiarazione",
    "void": "Annullato",
    "date": "Data",
    "manage": "Gestisci",
    "payment_amount_2": "Importo di pagamento",
    "select_gl_account": "Selezionare account GL",
    "set_as_default": "Impostare come predefinito",
    "name": "Nome",
    "save": "Salva",
    "bank_reconciliation": "Riconciliazione",
    "refresh": "Aggiorna",
    "all_status": "Tutti gli stati",
    "unmatched": "Senza eguali",
    "reviewed_unmatched": "Recensito (Unmatched)",
    "matched": "Abbinamento",
    "disputed": "Disputato",
    "all": "Tutti",
    "reviewed": "Recensione",
    "unreviewed": "Non rivisto",
    "bank_reconciliation_settings": "Impostazioni di riconciliazione bancaria",
    "edit_bank_accounts": "Modificare i conti bancari",
    "upload_statement_csv": "Dichiarazione di carico (CSV )",
    "matched_transactions": "Transazioni abbinate",
    "automatch_rate": "Tasso di arresto automatico",
    "reconciliation_session": "Sessione di riconciliazione",
    "not_ready": "Non pronto.",
    "reviewed_unmatched_2": "Recensito, senza pari",
    "statement_period": "Periodo di validità",
    "staff": "Personale",
    "bank_transactions": "Transazioni bancarie",
    "mark_reviewed": "Mark ha recensito",
    "mark_unreviewed": "Mark non rivisto",
    "select_all_transactions": "Seleziona tutte le transazioni",
    "match_confidence": "Fiducia di corrispondenza",
    "find_match": "Trova corrispondenza",
    "upload_statement_csv_2": "Dichiarazione di caricamento CSV",
    "choose_csv_file": "Scegliere il file CSV",
    "first_row_is_header": "Prima fila è intestazione",
    "strip_currency_symbols": "Simboli di valuta della striscia",
    "parsing_csv": "Analisi CSV…",
    "date_column": "Data colonna *",
    "select_column": "Seleziona la colonna",
    "description_column": "Descrizione colonna *",
    "amount_signed": "Importo (firmato)",
    "debit_column": "Colonna di rilevamento",
    "credit_column": "Colonna di credito",
    "reference_column": "Colonna di riferimento",
    "date_format": "Formato della data",
    "select_format": "Seleziona il formato",
    "running_balance_column": "Colonna del bilanciamento in esecuzione",
    "direction": "Direzione",
    "date_range": "Intervallo di date",
    "total_inflows": "Flussi totali",
    "total_outflows": "Flussi totali",
    "force_import_duplicates": "duplicati di importazione della forza",
    "continue": "Continua",
    "import": "Importazioni",
    "view_details": "Visualizza dettagli",
    "actual": "Attualità",
    "budget": "Bilancio",
    "difference": "Variazione",
    "department": "Dipartimento",
    "variance": "Variazione",
    "chart_of_accounts": "Grafico dei conti",
    "manage_account_codes_used_in_the_general_ledger": "Gestisci i codici degli account utilizzati nel registro generale.",
    "back_to_general_ledger": "Torna al Generale Ledger",
    "new_account": "Nuovo account",
    "search_by_code_or_name": "Ricerca per codice o nome",
    "code": "Codice",
    "type": "Tipo",
    "no_accounts_found": "Nessun conto trovato.",
    "activate": "Attivare",
    "deactivate": "Disattivare",
    "define_the_account_code_and_defaults_for_this_gl_account": "Definire il codice dell'account e le impostazioni predefinite per questo account GL.",
    "account_code": "Codice contabile",
    "account_name": "Nome del conto",
    "subtype": "Sottotipo",
    "optional": "Facoltativo",
    "inactive_accounts_are_hidden_by_default": "I conti inattivi sono nascosti per impostazione predefinita.",
    "manager": "Responsabile",
    "create": "Creare",
    "update": "Aggiornamento",
    "credit_amount": "Importo del credito",
    "reason": "Motivazione",
    "refund": "Rimborso",
    "billing_adjustment": "Regolazione di fatturazione",
    "courtesy_credit": "Credito di cortesia",
    "billing_error": "Errore di fatturazione",
    "promotional_credit": "Credito promozionale",
    "detailed_description_of_the_credit": "Descrizione dettagliata del credito...",
    "issue_credit": "Fascicolo di credito",
    "dimensions": "Dimensioni",
    "manage_reporting_dimensions_for_revenue_and_expenses": "Gestire le dimensioni di segnalazione per le entrate e le spese.",
    "new_dimension": "Nuova dimensione",
    "no_dimensions_found": "Nessuna dimensione trovata.",
    "define_the_code_and_name_used_for_reporting_dimensions": "Definire il codice e il nome utilizzato per le dimensioni di segnalazione.",
    "type_optional": "Tipo (opzionale)",
    "inactive_dimensions_are_hidden_by_default": "Le dimensioni inattive sono nascoste per impostazione predefinita.",
    "create_report": "Creare un report",
    "report_name": "Nome del rapporto",
    "report_type": "Tipo di relazione",
    "profit_loss": "Conto economico",
    "balance_sheet": "Foglio di equilibrio",
    "trial_balance": "Equilibrio di prova",
    "ap_aging": "Scadenzario fornitori",
    "ar_aging": "Scadenzario clienti",
    "budget_vs_actual": "Bilancio contro Attualità",
    "format": "Formato",
    "select_budget": "Seleziona budget",
    "budget_version": "Versione di bilancio",
    "select_version": "Selezionare la versione",
    "date_range_2": "Gamma di data",
    "start_date": "Data di inizio",
    "end_date": "Data di fine",
    "granularity": "Granularità",
    "category": "Categoria",
    "schedule_this_report": "Pianificare questa relazione",
    "frequency": "Frequenza",
    "daily": "Quotidiano",
    "weekly": "Settimanale",
    "quarterly": "Trimestrale",
    "delivery": "Consegna",
    "privana_inbox": "Privana Posta in arrivo",
    "email": "E-mail",
    "save_report": "Salvare il rapporto",
    "saved_scheduled_reports": "Rapporti salvati e programmati",
    "next_run": "Prossima corsa",
    "run_now": "Correte ora",
    "download": "Scarica",
    "no_data_available_for_the_selected_range": "Nessun dato disponibile per l'intervallo selezionato.",
    "no_rows_returned_for_this_report_scope": "Nessuna riga restituita per questo campo di applicazione del rapporto.",
    "no_eligible_allocations_found": "Non sono state trovate assegnazioni ammissibili.",
    "select": "Seleziona",
    "counterparty": "Contropartita",
    "match": "Abbinamento",
    "match_full": "Abbinamento completo",
    "over_allocated": "Oltre allo stanziamento",
    "recommended": "Consigliato",
    "member": "Socio",
    "no_match_items_selected": "Nessun elemento di corrispondenza selezionato.",
    "clear_match": "Corrispondenza chiara",
    "save_match": "Salvare la partita",
    "close_checklist": "Chiudere la lista di controllo",
    "no_tasks_configured": "Nessuna attività configurata.",
    "staff_2": "personale",
    "save_notes": "Salvare le note",
    "view_period_events": "Visualizza gli eventi di periodo",
    "no_events_recorded_for_this_period_yet": "Nessun evento registrato per questo periodo ancora.",
    "period_actions": "Azioni periodiche",
    "this_period_cannot_be_closed_yet": "Questo periodo non può ancora essere chiuso.",
    "close_reason_optional": "Chiudere la ragione (opzionale)",
    "close_month": "Chiudi Mese",
    "lock_reason_optional": "Motivo di bloccaggio (opzionale)",
    "required_tasks_incomplete": "Compiti richiesti incompleti",
    "complete_required_tasks_or_provide_an_override_reason_to_lock": "Completo compiti richiesti o fornire una ragione di override per bloccare questo periodo.",
    "override_reason_required_to_lock": "Motivo di override (richiesto per bloccare)",
    "override_lock": "Sostituisci e blocca",
    "unlock_reason_required": "Sbloccare la ragione (richiesto)",
    "reopen_reason_required": "Riaprire la ragione (richiesto)",
    "close_pack_snapshot": "Indossando una cinghia Istantanea",
    "no_snapshots_have_been_run": "Non sono state eseguite istantanee.",
    "view_report": "Visualizza relazione",
    "no_activity_recorded_for_this_period": "Nessuna attività registrata per questo periodo.",
    "this_trial_balance_contains_no_posted_journal_activity_for_the": "Questo bilancio di prova non contiene attività di giornale postate per il periodo selezionato.",
    "total_debits": "Debiti totali",
    "total_credits": "Crediti totali",
    "periods": "Periodi",
    "monitor_closelock_status_by_fiscal_period": "Monitorare lo stato di chiusura/bloccaggio per periodo fiscale.",
    "checklist": "Lista di controllo",
    "closed": "Chiuso",
    "locked": "Bloccato",
    "loading_periods": "Periodi di caricamento...",
    "no_periods_exist_for_this_year": "Non esistono periodi per quest'anno.",
    "blocked_by_earlier_periods": "Bloccato da periodi precedenti",
    "general_ledger_settings": "Impostazioni generali Ledger",
    "monthend_configuration": "Configurazione Mese-End",
    "general_ledger": "Generale Ledger",
    "search_by_account_memo": "Cerca per conto, memo...",
    "close_periods_permission_required": "Permesso dei periodi di chiusura",
    "memo": "Memoria",
    "loading_entries": "Caricamento in corso...",
    "no_general_ledger_entries_found": "Nessun registro generale trovato.",
    "view_periods": "Periodo di visita",
    "loading_invoice": "Caricamento in corso...",
    "revenue_was_posted_by_the_operational_source_transactions_before_invoicing": "I ricavi sono stati pubblicati dalle operazioni di fonte operativa prima della fatturazione.",
    "gl_posted_via_source_transactions": "GL postato tramite le transazioni di origine",
    "posted_to_gl": "Pubblicato in GL",
    "post_to_gl": "Post a GL",
    "message": "—",
    "billed_to": "Fatturato a:",
    "issue_date": "Data di pubblicazione:",
    "due_date_2": "Data di arrivo:",
    "quantity": "Quantità",
    "search_gl_accounts": "Cerca i conti GL...",
    "no_gl_account": "Nessun conto GL",
    "select_dimension": "Seleziona la dimensione",
    "search_dimensions": "Dimensioni di ricerca...",
    "loading_chart_of_accounts": "Carico dei conti...",
    "subtotal": "Totale parziale:",
    "tax_2": "Tassa:",
    "total_2": "Totale:",
    "payments": "Pagamenti:",
    "balance_due_2": "Bilancia Due:",
    "tax_codes_required": "Codici fiscali richiesti",
    "these_taxable_invoice_lines_do_not_have_a_tax_code": "Queste linee di fattura imponibili non hanno un codice fiscale selezionato.",
    "invoice_line": "Linea di fatturazione",
    "one_or_more_taxable_invoice_lines_need_a_tax_code": "Una o più linee di fattura imponibili hanno bisogno di un codice fiscale prima di inviare.",
    "review_invoice_lines": "Linee di fatturazione recensione",
    "tax_code_gl_mapping_required": "Codice fiscale GL mappatura richiesta",
    "this_invoice_cannot_be_posted_to_the_general_ledger_because": "Questa fattura non può essere postata al General Ledger perché questi codici fiscali sono mancanti di un Conto di uscita VAT GL. Vai alle Impostazioni Club → Contabilità → Codici fiscali per impostare l'Estratto VAT GL Account.",
    "line": "linea",
    "lines": "linee",
    "one_or_more_taxable_invoice_lines_use_tax_codes_without": "Una o più linee di fattura imponibili utilizzano i codici fiscali senza un account di output VAT GL.",
    "fix_tax_code_mappings": "Fissare le mappe del codice fiscale",
    "accounting_settings_required": "Impostazioni di contabilità richieste",
    "to_post_this_invoice_complete_the_missing_accounting_defaults": "Per inviare questa fattura, completare i di default mancanti della contabilità.",
    "accounting_settings_are_incomplete": "Le impostazioni di contabilità sono incomplete.",
    "not_now": "Non ora.",
    "configure_accounting_settings": "Configurare Impostazioni accounting",
    "accounting_settings": "Impostazioni di contabilità",
    "set_the_default_gl_accounts_used_when_posting_invoices": "Impostare gli account GL predefiniti utilizzati durante la pubblicazione delle fatture.",
    "ar_control_account": "Account di controllo di AR",
    "select_an_account": "Selezionare un account",
    "required_to_post_invoices": "Richiesto di inviare fatture.",
    "default_revenue_account": "Account delle entrate predefinite",
    "required_when_invoice_lines_are_missing_gl_accounts": "Richiesto quando le linee di fattura sono mancanti conti GL.",
    "vat_control_account_optional": "VAT Conto di controllo (opzionale)",
    "required_when_vat_is_applied": "Richiesto quando VAT è applicato.",
    "create_manual_invoice": "Crea fattura manuale",
    "search_member_name_or": "Nome del socio di ricerca o #",
    "issue_date_2": "Data di pubblicazione",
    "amounts_are": "Gli importi sono",
    "exclusive_of_tax": "Esclusiva delle imposte",
    "inclusive_of_tax": "Incluso l'imposta",
    "choose_how_unit_prices_are_entered_on_this_invoice": "Scegliere come i prezzi unitari sono inseriti in questa fattura.",
    "line_items": "Elementi di linea",
    "loading_categories": "Le categorie di carico...",
    "price": "Prezzo",
    "select_tax_code": "Seleziona il codice fiscale",
    "tax_exempt": "Esenzione fiscale",
    "tax_codes_ignored_when_no_tax_is_selected": "Codici fiscali ignorati quando “Nessuna tassa” è selezionata.",
    "not_effective_for_issue_date": "Non efficace per Data di emissione.",
    "select_category": "Seleziona la categoria",
    "no_category": "Nessuna categoria",
    "add_item": "Aggiungi articolo",
    "internal_notes_or_comments_for_the_member": "Note interne o commenti per il socio...",
    "save_draft_invoice": "Risparmiare la fattura",
    "club_name": "Nome del club",
    "club_address": "Indirizzo del Club",
    "invoice_2": "Fattura",
    "bill_to": "Fatturare a",
    "subtotal_2": "Subtotale",
    "amount_due": "Importo dovuto",
    "invoice_preview": "Anteprima fattura",
    "member_invoicing": "Fatturato socio",
    "search_member_or_invoice": "Socio di ricerca o fattura",
    "paid_credited": "Pagato / Credito",
    "no_invoices_found_for_this_club": "Nessuna fattura trovata per questo club.",
    "transactions": "Transazioni",
    "payment": "Pagamento",
    "pos_sale": "Vendita POS",
    "issued": "Fascicolo",
    "refunded": "Rimborsato",
    "auto_allocate": "Auto allocazione",
    "status_2": "Stato:",
    "reason_2": "Motivo:",
    "yes": "Sì",
    "no": "No",
    "record_member_payment": "Pagamento dei record",
    "unable_to_resolve_a_member_account": "Non è possibile risolvere un account socio.",
    "resolving_member_account": "Risolvere l'account...",
    "received_date": "Data di ricezione",
    "use_pos_cash_float": "Utilizzare POS cash float",
    "apply_to_invoices": "Applicare sulle fatture",
    "less_allocated": "Meno stanziamenti assegnati",
    "remaining_unapplied": "Restare non applicati",
    "allocate_later_leave_as_credit": "Alloca in seguito (lascia a credito)",
    "open_balance": "Equilibrio aperto",
    "allocation": "Allocazione",
    "no_open_invoices_to_allocate": "Nessuna fattura aperta da assegnare.",
    "club_logo": "Logo del club",
    "unit": "Unità",
    "loading_events": "Caricamento eventi...",
    "search_staff": "Ricerca personale...",
    "type_at_least_2_characters_to_search": "Digita almeno 2 caratteri per cercare.",
    "searching": "Ricerca…",
    "no_staff_found": "Nessun personale trovato.",
    "order": "Ordinanza",
    "any": "qualsiasi",
    "location": "Luogo",
    "new": "Nuovo",
    "credit_card": "Carta di credito",
    "cash": "Contanti",
    "tax_rate": "Tasso d'imposta (%)",
    "date_2": "Data:",
    "other": "Altro",
    "bank_transfer": "Bonifico bancario",
    "check": "Verifica",
    "autopay": "Pagamento automatico",
    "reference_number": "Numero di riferimento",
    "check_number_transaction_id_etc": "Numero di controllo, ID transazione, ecc.",
    "additional_payment_notes": "Ulteriori note di pagamento...",
    "pending_2": "In attesa",
    "member_name": "Nome socio",
    "net": "Rete di rete",
    "record_receivable_payment": "Pagamento creditizio record",
    "debtor": "Debitore:",
    "unlabelled_debtor": "Debitore non bilanciato",
    "description_2": "Descrizione:",
    "outstanding": "Eccellente:",
    "previous": "Precedente",
    "next": "Avanti",
    "outstanding_2": "Insoluto",
    "paid": "Pagato",
    "source": "Fonte:",
    "confirm": "Conferma",
    "recipient": "Recipiente",
    "pause": "Pausa",
    "resume": "Ripresa",
    "membership_type": "Tipo di iscrizione",
    "member_2": "socio",
    "group": "Gruppo",
    "groups": "Gruppi",
    "item": "Articolo",
    "items": "Articolo",
    "scheduled": "programmato",
    "card": "Carta di carta",
    "open": "aperto",
    "year": "Anno",
    "select_member": "Seleziona socio",
    "loading_members": "soci di carico...",
    "annual": "Annuale",
    "payment_terms_2": "Termini di pagamento",
    "label": "Etichetta",
    "effective_from": "Efficace da",
    "select_tax_code_2": "Selezionare il codice fiscale",
    "no_tax_code": "Nessun codice fiscale",
    "yearend_assistant": "Assistente anno dopo anno",
    "payroll_trend": "Tendenza del tasso di crescita",
    "payroll_sections": "Sezioni di pagamento",
    "loading_payroll_data": "Caricamento dati paghe...",
    "payroll_data_could_not_be_loaded": "I dati di paghe non potrebbero essere caricati.",
    "no_payroll_records_yet_defaults_are_ready_for_configuration": "Nessuna registrazione paghe per il momento. I valori predefiniti sono pronti per la configurazione.",
    "payroll_documents": "Documenti di pagamento",
    "payroll_setup_wizard": "Procedura guidata per l'installazione di paghe",
    "current_payroll_cycle": "Ciclo di paghe attuale",
    "journal_preview": "Anteprima del giornale",
    "current_payroll_run": "Corrente di paghe",
    "review_payroll": "Recensione paghe",
    "payroll_command_centre": "Centro di comando paghe",
    "no_current_payroll_run": "Nessuna corrente di paghe",
    "create_the_next_payroll_run_to_review_employees_timesheets_blockers": "Creare il prossimo paghe eseguire per rivedere i dipendenti, i fogli di tempo, i bloccanti, le approvazioni, gli ingressi legali e la contabilità in un unico spazio di lavoro guidato.",
    "create_next_payroll_run": "Creare il prossimo paghe run",
    "payroll_progress": "Progressi del paghe",
    "payroll_readiness": "Soddisfazione dei redditi",
    "ready": "Pronto",
    "open_details_and_actions": "Aprire dettagli e azioni",
    "privana_assist_will_show_next_actions_when_backend_readiness_checks": "Privana Assist mostrerà le prossime azioni quando i controlli di prontezza backend trovano qualcosa da rivedere.",
    "no_payroll_trend_data_yet": "Nessun dato di tendenza paghe ancora",
    "department_split_by_gross_pay": "Dipartimento diviso per retribuzione lorda",
    "no_department_weighting_yet": "Nessun peso di reparto ancora",
    "payroll_blockers": "Blocchi di pagamento",
    "open_payroll_run": "Aprire il paghe",
    "no_blockers_found_this_readiness_tile_is_clear": "Nessun blocco rilevato. Questo riquadro di preparazione non presenta problemi.",
    "manage_staff_pay_readiness_with_employeefirst_cards": "Gestisci la disponibilità del personale con le prime carte dei dipendenti.",
    "search_employees": "Ricerca di dipendenti",
    "add_employee": "Aggiungi Dipendenti",
    "payroll_employee_actions": "Azioni per i dipendenti",
    "departments": "Dipartimenti",
    "bank": "✓ Banca",
    "tax_3": "✓ Tassa",
    "pension": "✓ Pensione",
    "no_employees_found": "Nessun dipendente trovato",
    "archive": "Archivia",
    "drop_employees_here": "Getta i dipendenti qui",
    "done": "Fine",
    "people_operations": "Operazioni di persone",
    "organise_payroll_by_department": "Organizzare il libro paga per dipartimento",
    "drag_employee_cards_into_teams_or_use_accessible_move_selectors": "Trascinare le schede dei dipendenti in team o utilizzare i selettori di movimento accessibili.",
    "loading_departments": "Dipartimenti di carico...",
    "search_department_employees": "Dipendenti del dipartimento di ricerca",
    "search_people_role_department": "Ricerca di persone, ruolo, dipartimento",
    "new_department_name": "Nuovo nome di reparto",
    "new_department": "Nuovo dipartimento",
    "department_colour": "Colore del reparto",
    "staff_link": "Link per il personale",
    "staff_member": "Membro del personale",
    "search_staff_2": "Ricerca personale",
    "search_by_name_email_job_title_or_department": "Cerca per nome, e-mail, titolo di lavoro, o dipartimento",
    "clear": "Cancella",
    "employment_details": "Dettagli dell'occupazione",
    "pay_setup": "Impostazione di pagamento",
    "payroll_calculation_rules_for_contractors_will_be_configured_later_this": "Le regole di calcolo paghe per gli appaltatori saranno configurate in seguito; questa configurazione dei dipendenti memorizza solo il tasso di default.",
    "readiness_setup": "Impostazione della disponibilità",
    "payment_details": "Dettagli di pagamento",
    "save_payment_details_first_then_mark_them_verified_once_checked": "Salvare prima i dettagli del pagamento, quindi contrassegnarli verificati una volta verificato.",
    "update_verification": "Verifica dell'aggiornamento",
    "no_active_payment_details_saved": "Nessun dettaglio di pagamento attivo salvato.",
    "enter_full_details_once_existing_sensitive_values_are_never_prefilled": "Inserire i dettagli completi una volta. I valori sensibili esistenti non sono mai pre-riempiti quando si sostituisce.",
    "cancel_payment_edit": "Annullare la modifica del pagamento",
    "discard_edits": "Eliminare le modifiche",
    "edit_profile": "Modifica profilo",
    "mark_on_hold": "Mark on Hold",
    "mark_active": "Segno attivo",
    "payroll_profile_review": "Recensione del profilo di paghe",
    "edit_mode": "Modifica della modalità",
    "view_mode": "Modalità di visualizzazione",
    "loading_profile_detail": "Caricamento dei dettagli del profilo...",
    "pay_rate_details": "Paga & Tasso Dettagli",
    "effective_from_2": "Efficace da",
    "effective_to": "Efficace",
    "active_rate": "Tasso di attivazione",
    "tax_ni_readiness": "Tassa / Provvidenza NI",
    "ni_number_last4_only": "NI numero ultimo4 solo",
    "privana_stores_ni_reference_last4_only_full_ni_numbers_are": "Privana negozi NI di riferimento last4 solo. I numeri NI completi non sono memorizzati qui.",
    "pension_2": "Pensione",
    "provider": "Fornitore",
    "scheme_reference": "Riferimento dello schema",
    "employee_contribution_rate": "Tassi di contributo dei dipendenti",
    "employer_contribution_rate": "Tasso di contributo del datore di lavoro",
    "employer_cost_setup": "Impostazione dei costi del datore di lavoro",
    "employer_pension_rate": "Tasso di pensione di invalidità",
    "fixed_employer_contribution_override": "Sovraccarico del contributo del datore di lavoro fisso",
    "manual_employer_adjustment_override": "Sovraccarico di regolazione manuale del datore di lavoro",
    "manual_adjustment_reason": "Motivo di regolazione manuale",
    "no_audit_history_yet": "Non c'e' ancora la storia dell'audit.",
    "close_modal": "Chiudere modal",
    "finance_preview": "Anteprima finanza",
    "finance_preview_ready": "Anteprima di finanza pronto",
    "this_payroll_stays_approved_until_it_is_posted_to_accounting": "Questo libro paga rimane approvato fino a quando non è pubblicato in contabilità.",
    "posting_this_payroll_will": "Inviare questo libro paga sarà:",
    "link_this_payroll_run_to_a_general_ledger_journal": "Collegare questo libro paga eseguito su un giornale generale Ledger",
    "create_outstanding_payroll_hmrc_pension_and_other_payable_obligations": "Creare un libro paga in sospeso, HMRC, pensione e altri obblighi a pagamento",
    "hmrc_payroll_liability_components": "Componenti di responsabilità HMRC paghe",
    "memo_mapping_key": "Memo / mappatura chiave",
    "prepare_finance_preview_after_approval": "Preparare l'anteprima di finanza dopo l'approvazione.",
    "payroll_calendar_filter": "Filtro di calendario paghe",
    "all_calendars": "Tutti i calendari",
    "department_filter": "Filtro di reparto",
    "department_id": "Dipartimento id",
    "period_filter": "Filtro di periodo",
    "all_payroll_periods": "Tutti i periodi di pagamento",
    "search_timesheets": "Scheda tecnica di ricerca",
    "search_employee": "Dipendente di ricerca",
    "new_timesheet": "Nuovo Timesheet",
    "import_timesheets": "Importa i fogli di tempo",
    "timesheets": "Schede temporali",
    "loading_timesheets": "Caricamento di fogli di tempo...",
    "open_2": "Apri",
    "reopen": "Riaprire",
    "timesheet_lines": "Linee del foglio di tempo",
    "remove_line": "Rimuovi la linea",
    "create_timesheet": "Crea un foglio di tempo",
    "timesheets_are_created_against_payroll_periods_generated_from_payroll_calendar": "I fogli di tempo vengono creati contro i periodi di paghe generati dalle regole di paghe Calendar.",
    "no_open_payroll_periods_exist_for_this_calendar_go_to": "Non esistono periodi di paghe aperti per questo calendario. Vai a Impostazioni paghe → Calendari di paghe e fai clic su Periodi di Generazione.",
    "import_drafts": "Importa bozze",
    "all_periods": "Tutti i periodi",
    "search_run_name": "Nome dell'esecuzione",
    "new_payroll_run": "Nuovo paghe Run",
    "loading_payroll_runs": "Caricamento paghe corre...",
    "resolve_blockers_before_approval": "Risolvere i bloccanti prima dell'approvazione",
    "no_payroll_runs_yet": "Nessun paghe funziona ancora",
    "statutory_source": "Fonte legale",
    "statutory_payroll_inputs": "Indagini sui redditi",
    "enter_the_providersupplied_statutory_values_for_each_employee_in_this": "Immettere i valori di legge forniti dal fornitore per ogni dipendente in questo paghe run.",
    "privana_uses_these_employeelevel_values_to_calculate_net_pay_hmrc": "Privana utilizza questi valori a livello dei dipendenti per calcolare la retribuzione netta, le passività HMRC, la compensazione dei salari, i documenti e le buste paga future.",
    "pension_values_come_from_privana_pension_settings_only_paye_employee": "I valori pensionistici provengono da Privana impostazioni pensionistiche. Solo PAYE, Dipendente NI, e Datore di lavoro NI sono entrati qui.",
    "payroll_was_recalculated_after_statutory_inputs_were_saved_review_and": "paghe è stato ricalcolato dopo che gli input legali sono stati salvati. Revisione e rientro dei valori statutari.",
    "previous_statutory_values_are_stale_and_are_not_being_used": "I valori legali precedenti sono stanti e non vengono utilizzati.",
    "optional_sourcereference": "Fonte/riferimento facoltativo",
    "optional_reference_eg_payroll_provider_report_name_or_accountant_email": "Riferimento facoltativo, ad esempio nome del rapporto del fornitore di paghe o e-mail del ragioniere.",
    "import_csv_coming_soon": "Importazione CSV — Presto in arrivo",
    "review_required": "Recensione richiesta",
    "postedlocked_state_statutory_inputs_are_readonly_postedlocked_runs_show_readonly": "Pubblicato / sbloccato stato: gli input legali sono di sola lettura. Pubblicato / sbloccato run mostra righe di sola lettura.",
    "save_statutory_inputs": "Salvare gli ingressi legali",
    "reset_unsaved_changes": "Ripristinare le modifiche non rilevate",
    "create_payroll_run": "Creare paghe Run",
    "payroll_runs_collect_fixed_salary_profiles_approved_timesheets_and_hybrid": "paghe Runs raccolgono profili salariali fissi, fogli di tempo approvati e regolazioni ibride per il periodo di paghe selezionato.",
    "include_fixed_salary_profiles": "Includere profili salariali fissi",
    "include_timesheetdriven_employees": "Includi i dipendenti a tempo determinato",
    "include_hybrid_profiles": "Includere profili ibridi",
    "roll_back_stage": "Fase posteriore rotolo",
    "recalculate_payroll": "Calcolo del libro paga",
    "posted_to_accounting": "Pubblicato in Contabilità",
    "fix_mappings": "Risolvere le mappature",
    "multiple_payroll_journals_were_detected_for_this_payroll_run_review": "Sono stati rilevati più diari paghe per questo paghe run. Recensione prima del pagamento.",
    "approval_blockers": "Approvazione e bloccaggio",
    "opencreate_timesheet": "Aprire/Creare Timesheet",
    "no_blockers_found_payroll_can_move_to_the_next_available": "Nessun blocco trovato. paghe può passare al passo successivo disponibile.",
    "publish_payslips_to_staff_portal": "Pubblicare payslips al portale del personale?",
    "this_will_make_individual_payslips_available_only_to_staff_included": "Questo renderà i singoli payslips disponibili solo al personale incluso in questo paghe run.",
    "each_staff_member_will_only_be_able_to_view_and": "Ogni membro del personale sarà in grado di visualizzare e scaricare il proprio payslip.",
    "employee_breakdown": "Ripartizione dei dipendenti",
    "no_employee_lines_have_been_calculated_yet": "Non sono ancora state calcolate le linee dei dipendenti.",
    "payroll_liabilities": "Passività dei pagamenti",
    "approvals_pending": "Approvazioni in sospeso",
    "timesheets_waiting": "Timesheets in attesa",
    "payroll_runs_waiting": "paghe corre in attesa",
    "this_item_needs_a_backendlinked_action_before_it_can_be": "Questo articolo ha bisogno di un'azione backend-linked prima che possa essere aperto qui.",
    "approvals_clear": "Approvazioni chiare",
    "payroll_liabilities_and_payment_obligations_created_from_payroll_are_shown": "Le passività del libro paga e gli obblighi di pagamento creati dal libro paga sono mostrati qui. Anteprima-solo gli elementi non hanno creato i pagamenti o spostato i soldi.",
    "no_payroll_liabilities_yet": "Nessuna passività del libro paga",
    "loading_payroll_settings": "Caricamento delle impostazioni paghe...",
    "payroll_calendars": "Calendario dei pagamenti",
    "please_retry": "Per favore, riprovate.",
    "add_calendar": "Aggiungi il calendario",
    "payroll_calendars_generate_payroll_periods_timesheets_and_payroll_runs_then": "I calendari paghe generano i periodi di paghe. I fogli di tempo e le rune paghe usano quei periodi generati.",
    "loading_payroll_calendars": "Caricamento dei calendari paghe...",
    "unable_to_load_payroll_calendars": "Non è possibile caricare i calendari paghe.",
    "no_payroll_calendars_yet_create_one_to_define_pay_cycles": "Nessun calendario paghe ancora. Creare uno per definire i cicli di pagamento.",
    "generate_periods": "Generare i periodi",
    "set_default": "Impostare il valore predefinito",
    "weekly_2": "settimanale settimanale",
    "fortnightly": "pernottamenti",
    "monthly": "mensile",
    "quarterly_2": "trimestrale",
    "paused": "in pausa",
    "is_default": "Di default",
    "next_payroll_periods": "Prossimi periodi di paga",
    "save_calendar_to_preview_generated_periods": "Salva il calendario per visualizzare in anteprima i periodi generati.",
    "pay_rules": "Regole di pagamento",
    "timesheet_rules": "Regole del foglio di tempo",
    "payroll_setup_policy_centre": "paghe setup & policy center",
    "payroll_jurisdiction": "Giurisdizione paghe",
    "unable_to_determine_payroll_jurisdiction_automatically_please_check_your_club": "⁇  Incapace di determinare automaticamente la giurisdizione del libro paga. Si prega di controllare l'indirizzo del club in Impostazioni Club.",
    "refresh_detection": "Rilevamento di rifiuti",
    "open_club_settings": "Impostazioni Open Club",
    "advanced_payroll_settings": "Impostazioni paghe avanzate",
    "for_payroll_specialists_accountants_and_privana_support_these_fields_expose": "Per gli specialisti del libro paga, i contabili e il supporto di Privana. Questi campi espongono modalità di calcolo interno, soglie, tassi, chiavi di mappatura, impostazioni della giurisdizione e regolazioni dei costi del datore di lavoro avanzate.",
    "auto_enrolment_enabled": "Iscrizione automatica abilitata",
    "overtime_enabled": "Attivato il tempo libero",
    "custom": "Personalizzato",
    "standard_hourly_rate": "Tariffa oraria standard",
    "time_and_a_half_15x": "Tempo e mezzo (1,5x)",
    "double_time_20x": "Doppia ora (2.0x)",
    "reset_to_suggested_setting": "Ripristino dell'impostazione suggerita",
    "advanced_employer_cost_adjustments": "Aggiustazioni avanzate dei costi del datore di lavoro",
    "accountantlevel_employer_cost_overrides_collapsed_inside_advanced_payroll_settings_for": "Il datore di lavoro di livello contabile costa overrides. Collapsed all'interno Impostazioni di paghe avanzate per gli utenti del club di tutti i giorni.",
    "per_run": "Per correre",
    "monthly_2": "Mensile",
    "annual_prorated": "Proiezione annuale",
    "save_payroll_policies": "Salvare le politiche di paghe",
    "privana_assist_controls": "Privana Assist Controlli",
    "permissions_preview": "Anteprima delle autorizzazioni",
    "role_assignment_will_use_privana_module_permissions_this_preview_does": "L'assegnazione del ruolo utilizzerà Privana autorizzazioni del modulo. Questa anteprima non cambia ancora le autorizzazioni.",
    "loading_todays_accounting_queue": "Caricamento della coda contabile di oggi...",
    "today_workspace": "Oggi spazio di lavoro",
    "accounting_today": "Contabilità — Oggi",
    "financial_operations_overview_for_today": "Panoramica delle operazioni finanziarie per oggi.",
    "no_urgent_financial_actions_today": "Oggi non ci sono azioni finanziarie urgenti.",
    "search_payee_source_or_description": "Cerca payee, fonte, o descrizione...",
    "pay_selected": "Paga Selezionata",
    "add_bill": "Aggiungi Bill",
    "all_payables": "Tutti i pagamenti",
    "tax_pension": "Tasse e Pensioni",
    "refunds": "Rimborsi",
    "other_liabilities": "Altre responsabilità",
    "ap_ageing": "Scadenzario fornitori",
    "unified_payable_ledger": "Unificato payable ledger",
    "source_type": "Tipo di sorgente",
    "payee": "Pagamenti",
    "module": "Modulo",
    "gl_mapping": "Mappatura di gL",
    "original_amount": "Importo originale",
    "outstanding_amount": "Importo eccezionale",
    "due_date_run": "Data / Esegui",
    "payment_status": "Stato di pagamento",
    "loading_payables": "Caricamento payables...",
    "no_payables_found": "Nessun pagamento trovato.",
    "view_source": "Visualizza sorgente",
    "recent_ap_payments": "Pagamenti AP recenti",
    "unapplied": "Non applichi",
    "loading_payments": "Pagamenti di carico...",
    "no_payments_recorded": "Nessun pagamento registrato.",
    "current": "Attuale",
    "totals": "Totale",
    "no_ageing_balances_to_display": "Nessun bilanciamento di invecchiamento da visualizzare.",
    "manage_payment_allocations": "Gestire le assegnazioni di pagamento",
    "current_allocations": "Stanziamenti correnti",
    "unapply_selected": "Non applichi selezionati",
    "unapply_all": "Non appellare tutto",
    "reallocate_across_bills": "Realizzare attraverso le fatture",
    "no_open_bills_available_for_reallocation": "Non sono disponibili bollette aperte per la ricollocazione.",
    "reallocation_total": "Totale di destinazione",
    "apply_reallocation": "Applicare la locazione",
    "refund_payment": "Pagamento del rimborso",
    "refund_amount": "Importo del rimborso",
    "refund_method": "Metodo di rimborso",
    "refund_date": "Data di rimborso",
    "bank_account_required_for_bank_refunds": "Conto bancario richiesto per i rimborsi bancari.",
    "issue_refund": "Rimborso",
    "add_bank_account": "Aggiungi conto bancario",
    "bank_name": "Nome della banca",
    "eg_harbor_credit_union": "es. Harbor Credit Union",
    "account_name_friendly_label": "Nome account (etichetta amichevole)",
    "eg_operating_checking": "ad es. Controllo Operativo",
    "account_number": "Numero di conto",
    "enter_account_number": "Inserisci il numero dell'account",
    "eg_usd": "es. USD",
    "linked_gl_account_required": "Linked conto GL (richiesto)",
    "no_gl_accounts_available": "Nessun account GL disponibile.",
    "bank_accounts": "Conti bancari",
    "bank_2": "Banca",
    "linked_gl_account": "Linked conto GL",
    "no_bank_accounts_available": "Nessun conto bancario disponibile.",
    "loading_bank_accounts": "Caricamento conti bancari...",
    "search_transactions": "Operazioni di ricerca...",
    "income_vs_budget": "Reddito vs Budget",
    "actual_vs_budget": "Effettivo vs Bilancio",
    "expenses_vs_budget": "Spese vs Budget",
    "income_trend": "Tendenza del reddito",
    "expense_trend": "Tendenza delle spese",
    "monthly_performance": "Prestazioni mensili",
    "period": "Periodo",
    "of_budget": "% del bilancio",
    "department_breakdown": "Ripartizione del dipartimento",
    "variance_2": "Variazione %",
    "gl_accounts": "Account gl",
    "no_gl_detail_available": "Nessun dettaglio GL disponibile.",
    "inactive": "Inattivo",
    "eg_4000": "es. 4000",
    "eg_membership_dues": "ad es. Membership Dues",
    "cost_centers_departmental_accounting": "Centri di costo e contabilità dipartimentale",
    "track_spending_and_budgets_by_department_and_cost_center": "Tracciare spese e budget per reparto e centro di costo",
    "new_cost_center": "Nuovo centro di costo",
    "total_cost_centers": "Totale Centri di Costo",
    "annual_budget": "Bilancio annuale",
    "ytd_spending": "YTD Spendere",
    "budget_variance": "Variazione di bilancio",
    "department_spending_vs_budget": "Spese del Dipartimento contro il bilancio",
    "budget_utilization_by_department": "Utilizzazione del bilancio da parte del Dipartimento",
    "cost_centers": "Centri di costo",
    "all_departments": "Tutti i Dipartimenti",
    "budget_utilization": "Utilizzazione del bilancio",
    "cost_center_name": "Nome del centro di costo",
    "eg_fb001": "ad esempio, FB001",
    "manager_name": "Nome del Manager",
    "eg_department": "ad es. Dipartimento",
    "eg_fnb": "es. FNB",
    "eg_food_beverage": "per esempio Food & Beverage",
    "fiscal_year": "Anno fiscale",
    "customize_invoice": "Personalizza la fattura",
    "edit_invoicespecific_presentation_settings_only": "Modificare solo le impostazioni di presentazione specifiche della fattura.",
    "billing_email_optional": "E-mail di fatturazione (opzionale)",
    "leave_blank_to_use_club_default_in_preview": "Lascia vuoto per usare il club predefinito in anteprima",
    "billing_phone_optional": "Telefono di fatturazione (opzionale)",
    "accent_hex_color": "Colore HEX acuto",
    "footer_note": "Nota del piè di pagina",
    "eg_thank_you_for_your_business": "ad esempio, grazie per il vostro business!",
    "download_test_pdf": "Scarica la prova PDF",
    "paid_via_direct_payment": "Pagamento tramite pagamento diretto",
    "unbilled": "Incandescente",
    "apply_credit": "Applicare il credito",
    "refund_credit": "Credito di rimborso",
    "available_credit_notes": "Note di credito disponibili",
    "available_credit": "Credito disponibile",
    "current_balance": "Saldo attuale",
    "open_invoices": "Fatture aperte",
    "last_payment": "Ultimo pagamento",
    "statements": "Dichiarazioni",
    "loading_transactions": "Caricamento delle transazioni...",
    "billing_run": "Ciclo di fatturazione",
    "balance": "Bilancio",
    "details": "Dettagli",
    "no_transactions_recorded": "Nessuna transazione registrata.",
    "view_audit_trail": "Visualizzare il percorso di audit",
    "reallocate": "Rialloca",
    "refund_payment_2": "Pagamento del rimborso",
    "view_credit_note": "Visualizza la nota di credito",
    "view_invoice": "Visualizza Fattura",
    "create_credit_note": "Creare una nota di credito",
    "no_open_invoices": "Nessuna fattura aperta.",
    "no_invoices_in_this_range": "Nessuna fattura in questo range.",
    "no_payments_in_this_range": "Nessun pagamento in questo range.",
    "select_a_date_range_to_view_a_statement": "Selezionare un intervallo di date per visualizzare una dichiarazione.",
    "credit_payment": "Pagamento del credito",
    "select_a_payment": "Seleziona un pagamento",
    "no_open_invoices_available": "Non sono disponibili fatture aperte.",
    "remaining_credit": "Credito rimanente",
    "use_refund_payment_to_reverse_a_receipt_or_payment_allocation": "Utilizzare il pagamento di rimborso per invertire una ricevuta o l'allocazione di pagamento. Utilizzare la nota di credito per ridurre un valore di fattura.",
    "select_invoice": "Selezionare la fattura",
    "credit_note_detail": "Dettaglio note di credito",
    "total_ar": "Totale crediti verso clienti",
    "inactive_accounts": "Conti inattivi",
    "active_accounts": "Conti attivi",
    "accounts_in_credit": "Conti in Credito",
    "search_members": "I soci della ricerca...",
    "filter_by_status": "Filtra per stato",
    "all_statuses_2": "Tutti gli stati",
    "member_accounts": "Conti soci",
    "credit_limit": "Limite di credito",
    "credit_balance": "Bilancia di credito",
    "loading_member_accounts": "Caricamento dei conti...",
    "no_member_accounts_found": "Nessun account socio trovato.",
    "your_logo": "Il tuo logo",
    "billed_to_2": "Fatturato a",
    "loading_current_period": "Caricamento in corso...",
    "no_periods_exist_for_this_fiscal_year_yet_generate_periods": "Non esistono ancora periodi per quest'anno fiscale. Generare periodi per iniziare fine mese.",
    "go_to_periods": "Vai a Periodi",
    "no_completed_months_to_close_yet": "Nessun mese completato per chiudere ancora.",
    "select_a_period_to_continue_the_month_close_workflow": "Selezionare un periodo per continuare il flusso di lavoro chiuso mese.",
    "loading_checklist": "Caricamento checklist...",
    "action_blocked": "Azione bloccata",
    "override_reason_required_to_closelock": "Motivo override (richiesto per chiudere/bloccare)",
    "clear_staff_selection": "Selezione del personale chiara",
    "configure_monthend_checklist_templates_exception_policies_and_locking_rules": "Configurare i modelli della lista di controllo di fine mese, le politiche di eccezione e le regole di blocco.",
    "you_have_viewonly_access_editing_is_disabled_for_this_configuration": "Hai accesso solo alla vista. La modifica è disabilitata per questa configurazione.",
    "task_templates": "Modelli di attività",
    "define_the_checklist_items_required_to_close_a_period": "Definire gli elementi della lista di controllo necessari per chiudere un periodo.",
    "add_task": "Aggiungi attività",
    "task": "Compiti",
    "no_task_templates_configured": "Nessun modello di attività configurato.",
    "task_name": "Nome dell'attività",
    "exception_policies": "Politiche di eccezione",
    "define_who_can_post_or_delete_entries_during_locked_periods": "Definire chi può inviare o cancellare le voci durante i periodi bloccati.",
    "add_policy": "Aggiungi criterio",
    "source_module": "Modulo di origine",
    "optional_limit_this_exception_to_entries_created_by_a_specific": "Facoltativo: limitare questa eccezione alle voci create da un modulo specifico. Lasciare come qualsiasi da applicare a tutti i moduli.",
    "entry_class": "Classe di ammissione",
    "entry_class_describes_what_type_of_journal_entry_this_exception": "La classe di ammissione descrive il tipo di voce della rivista a cui si applica questa eccezione (normale, regolare, inversione, year_end, accrual). Lasciare come qualsiasi da applicare a tutti.",
    "allow_post": "Consentire Post",
    "allow_delete": "Consentire di eliminare",
    "no_exception_policies_configured": "Nessuna politica di eccezione configurata.",
    "locking_rules": "Regole di bloccaggio",
    "locking_rules_configuration_coming_soon": "La configurazione delle regole di blocco viene presto.",
    "todays_sales": "Vendite di oggi",
    "transactions_today": "Transazioni oggi",
    "avg_transaction": "Transazione di Avg",
    "refunds_today": "Rimborsi oggi",
    "all_locations": "Tutte le posizioni",
    "new_sale": "Nuova vendita",
    "point_of_sale_transactions": "Punto di vendita Transazioni",
    "transaction_id": "ID di transazione",
    "datetime": "Data/ora",
    "refunds_returns": "Rimborsi & Resi",
    "refund_id": "ID rimborso",
    "original_transaction": "Transazione originale",
    "member_optional": "socio (opzionale)",
    "select_member_or_leave_blank_for_walkin": "Selezionare socio o lasciare vuoto per il walk-in",
    "debit_card": "Scheda di debito",
    "gift_card": "Carta regalo",
    "comp": "Omaggio",
    "items_2": "Articoli",
    "item_name": "Nome dell'oggetto",
    "tip_amount": "Quantità di punta",
    "transaction_notes": "Note di transazione...",
    "process_refund": "Rimborso di processo",
    "refund_amount_2": "Importo del rimborso",
    "refund_method_2": "Metodo di rimborso",
    "account_credit": "Credito",
    "reason_for_refund": "Motivo di rimborso",
    "customer_request": "Richiesta del cliente",
    "service_issue": "Problema del servizio",
    "cancellation": "Cancellazione",
    "error_correction": "Correzione di errore",
    "refund_reason_or_notes": "Rimborso o note...",
    "total_processed": "Totale processato",
    "failed": "Non riuscito",
    "processing_fees": "Tasse di lavorazione",
    "search_payments": "Pagamenti di ricerca...",
    "completed": "Completato",
    "invoice_optional": "Fattura (opzionale)",
    "select_invoice_to_pay": "Selezionare la fattura per pagare",
    "additional_notes": "Note aggiuntive...",
    "recent_payments": "Pagamenti recenti",
    "payment_id": "ID pagamento",
    "fee": "A pagamento",
    "no_payments_found": "Nessun pagamento trovato",
    "total_receivables": "Totale crediti",
    "outstanding_receivables": "Crediti eccezionali",
    "nonmember_debtors": "Debitori non soci",
    "all_receivables": "Tutti i crediti",
    "charges": "Spese",
    "billing_status": "Stato di fatturazione",
    "no_charges_found": "Nessuna accusa trovata.",
    "receivable_detail": "Dettaglio creditizio",
    "debtor_2": "Deboratore",
    "original": "Originale",
    "source_invoice": "Fonte e fatturazione",
    "accounting_metadata": "Metadati contabili",
    "settlement_pos_gl_audit": "Insediamento, pos & gl audit",
    "payment_records": "Registrazioni di pagamento",
    "payment_allocations": "Stanziamenti di pagamento",
    "taxvat_breakdown": "Tasse/ VAT Ripartizione",
    "gl_journal_lines": "Linee di giornale gl",
    "invoice_line_items": "Linea di fatturazione",
    "go_to_source": "Vai alla fonte",
    "clear_search": "Cancella la ricerca",
    "search_by_invoice_or_memberdebtor_name": "Ricerca per fattura o nome socio/debtor...",
    "no_matching_invoices": "Nessuna fattura corrispondente.",
    "use_a_credit_note_to_reduce_the_invoice_value_after": "Utilizzare una nota di credito per ridurre il valore della fattura dopo l'emissione. Utilizzare il pagamento di rimborso solo per restituire un pagamento senza modificare il valore della fattura.",
    "billing_adjustment_2": "Regolazione di fatturazione",
    "goodwillservice_issue": "Problema di buona volontà/servizio",
    "event_cancellation": "Cancellazione eventi",
    "membership_adjustment": "Adeguamento degli Stati soci",
    "gross_amount": "Importo lordo",
    "post_credit_note_immediately": "Posta nota di credito immediatamente",
    "enrolment_list": "Elenco iscrizioni",
    "billing_runs": "Cicli di fatturazione",
    "recurring_billing_settings": "Impostazioni di fatturazione ricorrenti",
    "billing_cutoff_day_of_month": "Billing cut-off giorno del mese",
    "billing_runs_include_eligible_unbilled_items_up_to_and_including": "Le piste di fatturazione includono oggetti non accessibili fino a e compreso il giorno di cut-off selezionato.",
    "autoemail_recurring_invoices": "Fatture auto-email ricorrenti",
    "invoices_generated_from_recurring_billing_are_emailed_to_members_at": "Le fatture generate dalla fatturazione ricorrente sono inviate via email ai soci alle ore 9:00 del locale fuso orario del club.",
    "generate_invoices": "Generare le fatture",
    "send_invoice": "Invia fattura",
    "statement_total": "Dichiarazione Totale",
    "current_period": "Periodo attuale",
    "this_will_generate_the_members_invoice_and_email_it_immediately": "Questo genererà la fattura del socio e la e-mail immediatamente.",
    "the_invoice_will_then_appear_in_invoicing_for": "La fattura verrà quindi visualizzata in fatturazione per:",
    "payment_tracking": "monitoraggio dei pagamenti",
    "overdue_management": "gestione indebita",
    "future_account_administration": "amministrazione del conto futuro",
    "some_items_are_not_mapped_to_accounts": "Alcuni elementi non sono mappati ai conti",
    "unmapped_items_will_not_be_included_in_invoices_unless_you": "Gli articoli non mappati non saranno inclusi nelle fatture a meno che non si fissino le loro mappe contabili.",
    "go_to_gl_mapping": "Vai a GL Mapping",
    "continue_anyway": "Continua a leggere",
    "membership_dues_enrollment": "Abbonamento Due iscrizioni",
    "accountingonly_enrollment_and_operations_for_recurring_membership_dues": "Iscrizioni contabili e operazioni per i debiti di appartenenza ricorrenti.",
    "enroll_member": "Iscrittore",
    "active_recurring_dues_enrollments": "Iscrizioni di due titoli ricorrenti attive",
    "enrollment": "Iscrizioni",
    "enrolled": "Iscritti",
    "not_enrolled": "Non iscritti",
    "membership_type_2": "Tipo di iscrizione",
    "enroll_selected": "Iscrizione Selezionata",
    "generate_invoices_for_selected": "Generare Fatture per Selezionati",
    "next_run_date": "Prossima data di esecuzione",
    "latest_invoice": "Ultimi fatturati",
    "recurring_status": "Stato ricorrente",
    "generate_invoice_now": "Generare la fattura ora",
    "run_date": "Data di uscita",
    "invoices": "Fatture",
    "total_billed": "Totale fatturato",
    "skipped_warnings": "Ignorati / Avvisi",
    "view_preview": "Visualizza Anteprima",
    "generate_run": "Generare la corsa",
    "view_invoices": "Visualizza le fatture",
    "record_payments": "Pagamenti record",
    "loading_billing_runs": "Caricamento in corso...",
    "no_billing_runs_yet": "Non c'e' ancora nessuna fattura.",
    "billing_run_detail": "Dettaglio del ciclo di fatturazione",
    "charge": "Carico",
    "generate_billing_run": "Genera la fatturazione?",
    "this_will_create_draft_invoices_for_the_selected_recurring_billing": "Ciò creerà delle fatture di bozza per il periodo di fatturazione ricorrente selezionato. Le fatture di progetto rimangono non inviate nel registro generale fino a quando non saranno finalizzate o pubblicate.",
    "statement_preview": "Anteprima della dichiarazione",
    "loading_statement_preview": "Anteprima della dichiarazione di caricamento...",
    "dues": "Due",
    "billing_email": "E-mail di fatturazione",
    "ready_to_bill": "✓ Pronto a Bill",
    "nothing_to_bill": "Niente a Bill",
    "current_statement": "Dichiarazione attuale",
    "future_billing": "Il futuro Billing",
    "billing_history": "Fatturazione della storia",
    "preview_invoice": "Anteprima Fattura",
    "coming_soon": "Arrivo presto",
    "autopay_coming_soon": "Auto-Pay: Arrivo presto",
    "statement_preview_summary": "Sintesi della dichiarazione",
    "only_billable_outstanding_items_that_would_be_included_if_generated": "Solo oggetti fatturabili, eccezionali che sarebbero inclusi se generati ora.",
    "no_charges_are_currently_scheduled_for_the_next_statement": "Attualmente non sono previsti oneri per la prossima dichiarazione.",
    "charges_included": "Spese incluse",
    "paid_settled_voided_and_directly_settled_sales_are_excluded": "Sono escluse le vendite pagate, liquidate, vuote e liquidate direttamente.",
    "projected": "Progetto",
    "charge_actions": "Azioni di pagamento",
    "edit_charge_coming_soon": "Edit Charge — Prossimamente",
    "exclude_this_run": "Escludere questa corsa",
    "move_to_future_billing_run": "Spostarsi in Futuro Billing Run",
    "make_complimentary_coming_soon": "Fare il Complimentary — Arrivo presto",
    "split_billing_coming_soon": "Fatturazione divisa — Presto in arrivo",
    "add_note_coming_soon": "Aggiungi nota — Cominciando presto",
    "scheduled_2": "Programmato",
    "future_charge_actions": "Azioni di carica future",
    "change_billing_run": "Cambiare Billing Run",
    "no_future_scheduled_charges_found": "Nessun costo programmato futuro trovato.",
    "source_2": "Fonte",
    "no_previous_billing_periods_found": "Nessun precedente periodo di fatturazione trovato.",
    "loading_invoice_preview": "Caricamento in anteprima della fattura...",
    "direct_debit": "Debito diretto",
    "charge_source": "Fonte di carica",
    "source_type_2": "Tipo di origine",
    "sale_number": "Numero di vendita",
    "choose_which_billing_run_this_charge_should_appear_in": "Scegliere in quale fatturazione eseguire questa carica dovrebbe apparire.",
    "current_billing_run": "Corrente corsa di fatturazione",
    "billing_runs_2": "Cicli di fatturazione",
    "custom_2": "Personale...",
    "choose_a_later_billing_run": "Scegli un'ultima corsa di fatturazione",
    "month": "Mese",
    "custom_billing_month": "mese di fatturazione personalizzato",
    "custom_billing_year": "Anno di fatturazione personalizzato",
    "enroll_member_in_membership_dues": "Iscriversi Iscritto in Membership Dues",
    "dues_start_date": "Data di inizio dei risultati",
    "dues_amount": "Importo delle quote",
    "choose_frequency": "Scegli la frequenza",
    "recurring_state": "Stato ricorrente",
    "paused_2": "In pausa",
    "autoemail_invoices": "Fatture di posta elettronica automatica",
    "enroll": "Iscriversi",
    "manage_revenue_payroll_and_future_accounting_mappings_used_by_privana": "Gestisci entrate, paghe e future mappature contabili utilizzate da Privana motori di postazione. Configurare come l'attività operativa mappa nel General Ledger.",
    "show_historical_mappings": "Visualizza mappature storiche",
    "add_mapping": "Aggiungi mappatura",
    "revenue_mappings": "Mapping delle entrate",
    "existing_revenue_mapping_rules_used_by_invoice_and_receivables_posting": "Regole di mappatura dei ricavi esistenti utilizzate per fattura e crediti postazione.",
    "loading_gl_mappings": "Caricamento di mappe GL...",
    "key": "Chiave chiave",
    "no_revenue_mappings_yet": "Non ho ancora mappato i ricavi.",
    "payroll_journal_mappings": "Pagamenti del giornale del salario",
    "payroll_posting_rules_used_when_payroll_journals_are_generated": "Regole di pubblicazione paghe utilizzate quando le riviste paghe sono generate.",
    "mapping_key": "Chiave di mappatura",
    "debit_account": "Account di destinazione",
    "credit_account": "Conto di credito",
    "effective_to_2": "Efficace a",
    "no_payroll_journal_mappings_yet_use_accounting_refresh_defaults_to": "Nessuna mappatura del giornale paghe per il momento. Usa Aggiorna valori predefiniti in Contabilità per ripristinarli.",
    "payroll_control_accounts": "Account di controllo paghe",
    "payroll_liability_and_clearing_accounts_used_by_payroll_posting_and": "Responsabilità e liquidazione dei conti utilizzati da paghe postazione e payables handoff.",
    "account_purpose": "Oggetto dell'account",
    "no_payroll_control_accounts_yet_use_accounting_refresh_defaults_to": "Non sono ancora presenti account di controllo paghe. Utilizzare Accounting Refresh Defaults per riparare i default.",
    "refresh_accounting_defaults": "Rifiutare le impostazioni predefinite della contabilità?",
    "this_creates_any_missing_default_accounts_tax_codes_dimensions_revenue": "Questo crea qualsiasi account di default mancante, codici fiscali, dimensioni, mappature delle entrate, e mappature del libro paga solo per le transazioni future. Le fatture e le riviste storiche non sono cambiate.",
    "preparing_your_clubs_accounting_defaults": "Preparare i difetti contabili del tuo club",
    "were_checking_the_chart_of_accounts_tax_codes_dimensions_revenue": "Stiamo controllando il grafico dei conti, i codici fiscali, le dimensioni, le mapping delle entrate e le mapping del libro paga così le spese future post cleanly. Le fatture e le riviste storiche sono lasciate intatte.",
    "search_tax_codes": "Codici fiscali di ricerca...",
    "no_tax_codes_found": "Nessun codice fiscale trovato.",
    "no_fiscal_years_are_available_yet": "Non sono ancora disponibili anni fiscali.",
    "select_fiscal_year": "Seleziona l'anno fiscale",
    "select_a_fiscal_year_to_review_yearend_status": "Selezionare un anno fiscale per rivedere lo stato di fine anno.",
    "loading_yearend_status": "Caricamento stato di fine anno...",
    "some_modulespecific_checks_were_skipped_because_those_modules_are_not": "Alcuni controlli specifici del modulo sono stati saltati perché quei moduli non sono abilitati o non hanno alcuna attività per questo club.",
    "close_fiscal_year": "Chiudere l'anno fiscale",
    "confirm_close": "Confermare da vicino",
    "processing": "Elaborazione...",
    "submit_payment": "Invia pagamento",
    "draft_bill": "Progetto di legge",
    "edit_bill": "Modifica di Bill",
    "create_bill": "Creare Bill",
    "save_bill": "Salvare Bill",
    "people": "Persone",
    "share": "Condividi",
    "payroll_number": "Numero di paghe",
    "employment_type": "Tipo di occupazione",
    "job_title": "Titolo del lavoro",
    "start_year": "Anno di inizio",
    "start_month": "Inizio Mese",
    "start_day": "Giorno di inizio",
    "pay_type": "Tipo di pagamento",
    "payroll_method": "Metodo di pagamento",
    "payroll_calendar": "Calendario dei pagamenti",
    "bank_readiness": "Prontezza della banca",
    "taxni_readiness": "Prontezza fiscale/NI",
    "pension_status": "Stato della pensione",
    "payment_details_2": "Dati di pagamento",
    "account_type": "Tipo di conto",
    "scheme": "Schema",
    "account_holder": "Titolare del conto",
    "sort_code": "Ordina il codice",
    "reference_last4": "Riferimento last4",
    "verification_status": "Stato di verifica",
    "last_updated": "Ultimo aggiornamento",
    "set_verification_status": "Imposta lo stato di verifica",
    "current_rate": "Tasso attuale",
    "payroll_status": "Stato di pagamento",
    "readiness_status": "Stato di prontezza",
    "tax_status": "Stato fiscale",
    "pension_status_2": "Stato della pensione",
    "last_paid": "Ultimo pagamento",
    "rate_wording": "Tasso di formulazione",
    "active_rate_status": "Stato della frequenza attiva",
    "tax_and_ni_details": "Tasse e dettagli NI",
    "tax_status_2": "Stato fiscale",
    "ni_last4": "Ultimi 4 caratteri del numero di previdenza nazionale",
    "employee_contribution": "Contributo dei dipendenti",
    "employer_contribution": "Contributo del datore di lavoro",
    "pension_enrolled_status": "Pensione stato iscritta",
    "gb_employer_ni_status": "GB Employer NI stato",
    "gross_pay": "Paga lorda",
    "net_pay": "Pagamenti netti",
    "employer_costs": "Costi salariali",
    "total_payroll_cost": "Costo totale del libro paga",
    "total_debits_2": "Addebiti totali",
    "total_credits_2": "Crediti totali",
    "payroll_period": "Periodo di pagamento",
    "sourcereference": "Fonte/riferimento",
    "saved_at": "Salvataggio a",
    "saved_by": "Salvataggio da",
    "hmrc_total": "HMRC totale",
    "employee_ni": "Dipendenti NI",
    "employer_ni": "Datore di lavoro NI",
    "source_reference": "Fonte / riferimento",
    "net_staff_payments": "Pagamenti netti del personale",
    "total_cost_to_club": "Costo totale per club",
    "payroll_calendar_2": "Calendario dei pagamenti",
    "run_name": "Nome della corsa",
    "period_rule": "Regola del periodo",
    "generation_horizon_months": "Mesi dell'orizzonte della generazione",
    "pay_date_rule": "Regola della data di pagamento",
    "day_of_month": "Giorno del mese",
    "days_after_period_end": "Giorni dopo la fine del periodo",
    "approval_deadline_days": "Giorni di scadenza dell'approvazione",
    "timesheet_cutoff_rule": "Regola di taglio del foglio di tempo",
    "cutoff_days": "Giorni di taglio",
    "overtime_multiplier": "Moltiplicatore straordinario",
    "default_currency": "Moneta predefinita",
    "timesheet_rounding_mode": "Modalità di arrotondamento del foglio di tempo",
    "calculation_source": "Fonte di calcolo",
    "pension_provider": "Fornitore di pensione",
    "employee_contribution_2": "Contributo dei dipendenti %",
    "employer_contribution_2": "Contributo dei datori di lavoro %",
    "handled_by": "Gestito da",
    "internal_calculation_mode": "Modalità di calcolo interno",
    "liability_mapping_key": "Chiave di mappatura della responsabilità",
    "expense_mapping_key": "Chiave di mappatura dell'appendice",
    "jurisdiction_key": "Chiave di giurisdizione",
    "frequency_basis": "Base di frequenza",
    "variance_threshold_percent": "Soglia di variazione percentuale",
    "post": "Contabilizza",
    "debit_gl_account": "Ritiro account GL",
    "credit_gl_account": "Credito GL Account",
    "balance_due_3": "Bilancia dovuta:",
    "issue_credit_memo": "Fascicolo di credito Memo -",
    "save_gl_coding": "Salva GL Coding",
    "tax_amount": "Importo fiscale",
    "account_2": "Conto:",
    "applied": "Applicato:",
    "record_payment_2": "Pagamento record -",
    "wire": "Filo metallico",
    "partially_paid": "A pagamento parziale",
    "overdue": "Scaduto",
    "posting_blocked": "Postazione bloccata",
    "this_date_falls_in_a_locked_or_closed_period_change": "Questa data cade in un periodo chiuso o chiuso. Cambiare la data o richiedere uno sblocco.",
    "posting_failed": "Posta fallita",
    "failed_to_post_invoice_to_the_general_ledger": "Non è riuscito a inviare la fattura al registro generale.",
    "failed_to_load_accounting_settings": "Non è riuscito a caricare le impostazioni di contabilità.",
    "unable_to_save_accounting_settings_check_the_account_selections_and": "Non è possibile salvare le impostazioni contabili. Controllare le selezioni dell'account e riprovare.",
    "ar_control_account_not_set": "AR Conto di controllo non impostato",
    "default_revenue_account_not_set": "Conto di ricavi predefinito non impostato",
    "vat_control_account_not_set": "VAT conto di controllo non impostato",
    "unable_to_save_line_gl_coding_please_try_again": "Non è in grado di salvare la linea GL codifica. Si prega di riprovare.",
    "one_or_more_selected_tax_codes_arent_effective_for_the": "Uno o più codici fiscali selezionati non sono efficaci per la data di emissione della fattura. Aggiorna la data di emissione o scegli un altro codice fiscale.",
    "some_tax_codes_were_not_effective_for_the_selected_issue": "Alcuni codici fiscali non erano efficaci per la data di emissione selezionata e sono stati cancellati.",
    "cannot_save_no_club_context": "Non si può salvare: nessun contesto del club.",
    "failed_to_save_invoice": "Non è riuscito a salvare la fattura.",
    "unable_to_record_payment": "Incapace di registrare il pagamento.",
    "finalized": "Finalizzato",
    "finalize_reconciliation": "Finalizzare la riconciliazione",
    "detected_format": "Formato rilevato:",
    "save_account": "Salvare il conto",
    "save_dimension": "Salva dimensione",
    "report": "Relazione",
    "as_of": "Al",
    "confidence": "Confidenza",
    "remaining_to_match": "Rimanendo in corrispondenza:",
    "required_tasks": "Compiti richiesti",
    "required": "richiesto",
    "optional_2": "opzionale",
    "paye_income_tax": "Tassa di reddito PAYE:",
    "employee_national_insurance": "Assicurazione nazionale dei dipendenti:",
    "employer_national_insurance": "Assicurazione nazionale del datore di lavoro:",
    "hmrc_total_2": "HMRC totale:",
    "add_adjustment_scaffold_is_ready_for_a_later_payroll_calculation": "Aggiungete l'impalcatura di regolazione è pronta per un passaggio successivo di calcolo del libro paga.",
    "finance_details": "dettagli finanziari",
    "enabled": "abilitata",
    "cost_center": "Centro dei costi",
    "we_hit_a_snag_rendering_this_report_preview": "Abbiamo colpito uno snag rendendo questa anteprima del rapporto.",
    "try_running_the_report_again_or_adjust_the_date_range": "Prova a eseguire nuovamente il report o a regolare l'intervallo di date. Se il problema persiste, contatta il supporto.",
    "fiscal_month": "Mese fiscale",
    "direct_payment_via_member_portal": "Pagamento diretto tramite Portale socio",
    "month_close": "Chiudere mese",
    "pos_transaction": "Transazione punto vendita",
    "transaction": "Transazione",
    "billable": "Fatturabile",
    "recurring_billing_only_activates_when_a_positive_dues_amount_and": "La fatturazione ricorrente si attiva solo quando viene fornita una quantità e una frequenza di due positivi. Le impostazioni predefinite del tipo di iscrizione vengono utilizzate dal backend quando disponibili; altrimenti sono necessari i valori inseriti qui.",
    "accounting_refresh_defaults": "Rifiuti di default",
    "save_mapping": "Salva la mappatura",
    "all_types": "Tutti i tipi",
    "asset": "Benefici",
    "liability": "Affidabilità",
    "equity": "Equità",
    "revenue": "Ricavi",
    "expense": "Spesa",
    "active_only": "Solo attivo",
    "active_inactive": "Attivo + Inattivo",
    "selected_vendor": "Fornitore selezionato",
    "select_a_vendor": "Seleziona un fornitore",
    "supplier_statement": "Dichiarazione del fornitore",
    "collect": "Collezioni",
    "outstanding_revenue_requiring_attention": "Entrate straordinarie che richiedono attenzione",
    "overdue_member_balances": "Bilancia dei soci in ritardo",
    "review_balances": "Bilanci di bilancio",
    "due_this_week": "A causa di questa settimana",
    "open_receivables": "Crediti aperti",
    "credit_balances_unapplied_cash": "Saldi a credito e incassi non allocati",
    "view_accounts": "Visualizza gli account",
    "items_that_need_to_be_posted_into_the_books": "Articoli che devono essere pubblicati nei libri",
    "awaiting_posting": "Risveglio posting",
    "open_queue": "Aprire la coda",
    "invoices_awaiting_posting": "Fatture in attesa di posting",
    "review_invoices": "Esame delle fatture",
    "ap_bills_awaiting_posting": "Fatture fornitori in attesa di contabilizzazione",
    "review_bills": "Fatture di revisione",
    "posting_exceptions": "Eccezioni di pubblicazione",
    "review_exceptions": "Eccezioni di revisione",
    "pay": "Paga",
    "supplier_obligations_coming_due": "Obblighi del fornitore in arrivo",
    "overdue_supplier_bills": "Fatture del fornitore in ritardo",
    "review_overdue": "Recensione in ritardo",
    "due_today": "Due oggi",
    "open_due_today": "Aperto da oggi",
    "review_schedule": "Calendario delle recensioni",
    "reconcile": "Riconciliare",
    "bank_and_control_items_needing_review": "Banca e elementi di controllo che necessitano di revisione",
    "unmatched_transactions": "Operazioni ineguagliabili",
    "reviewed_but_unmatched": "Recensito ma ineguagliabile",
    "continue_review": "Continua a leggere",
    "bank_accounts_unreconciled_this_period": "Conti bancari non riconciliati in questo periodo",
    "close_controls": "Chiudere / Controlli",
    "periodend_tasks_and_blockers": "Attività e blocchi di fine periodo",
    "ar_posting_incomplete": "A/R incompleto",
    "ap_posting_incomplete": "A/P postazione incompleta",
    "resolve_items": "Risolvere gli articoli",
    "bank_reconciliation_incomplete": "Riconciliazione della Banca",
    "open_reconciliation": "Aprire la riconciliazione",
    "monthclose_blockers": "Blocchi mensili",
    "view_blockers": "Visualizza i blocchi",
    "receivables_outstanding": "Crediti eccezionali",
    "supplier_bills_due": "Le bollette del fornitore dovute",
    "posting_issues": "Problemi di pubblicazione",
    "last_updated_time": "Ultimo aggiornamento {time}",
    "record_payment_for_member": "Pagamento record per {member}",
    "issue_credit_memo_for_member": "Memo di credito di emissione per {member}",
    "invoice_number": "Fattura {number}",
    "on_hold": "Aspetta.",
    "any_3": "Qualsiasi",
    "all_categories": "Tutti i gruppi",
    "invoiced": "Fatturato",
    "all_departments_2": "Tutti i dipartimenti",
    "awaiting_approval": "Approvazione in attesa",
    "exceptions": "Eccezioni",
    "accommodation": "Alloggio",
    "normal": "Normale",
    "warning_2": "Avvertenza",
    "import_failed_2": "Importazione fallita",
    "submit_for_approval": "Inviare per approvazione",
    "approval_status": "Stato di approvazione",
    "error_2": "Errore",
    "events": "Eventi",
    "facilities": "Servizi",
    "golf": "Golf",
    "racquet": "Racchetta",
    "please_try_again": "Riprova.",
    "benefits": "Prestazioni",
    "bulk_update_failed": "Aggiornamento Bulk fallito",
    "membership": "Iscrizione",
    "accounting": "Contabilità",
    "expenses": "Spese",
    "spa": "Centro benessere",
    "fitness": "Fitness",
    "payables": "Sovvenzioni",
    "activities": "Attività",
    "pay_date": "Data di pagamento",
    "front_desk": "Reception",
    "club": "Club Club",
    "company": "Società",
    "your_changes_have_been_saved": "Le tue modifiche sono state salvate.",
    "display_name": "Nome dell'esposizione",
    "spa_wellness": "Spa e benessere",
    "missing": "Mancato",
    "please_refresh_and_try_again": "Si prega di rinfrescare e riprovare.",
    "download_pdf": "Scarica PDF",
    "invalid_date": "Data non valida",
    "supplier_not_found": "Fornitore non trovato.",
    "unable_to_load_supplier_ageing_detail": "In grado di caricare i dettagli di invecchiamento del fornitore.",
    "cheque": "Assegno",
    "select_a_bank_account_for_bank_payments": "Selezionare un conto bancario per i pagamenti bancari.",
    "fix_payment_amounts_before_submitting": "Fissare gli importi di pagamento prima della presentazione.",
    "batch_payment_recorded": "Pagamento in batch registrato.",
    "missing_accounting_defaults": "Mancano i predefiniti contabili.",
    "set_ap_control_and_payment_accounts_before_posting": "Impostare il controllo AP e i conti di pagamento prima di inviare.",
    "failed_to_pay_selected_bills": "Non ha pagato le bollette selezionate.",
    "failed_to_save_bill": "Non e' riuscito a salvare il conto.",
    "enter_a_valid_payment_amount": "Inserisci un importo di pagamento valido.",
    "payment_amount_must_cover_allocations": "L'importo del pagamento deve coprire le assegnazioni.",
    "fix_allocation_amounts_before_submitting": "Fissare gli importi di allocazione prima della presentazione.",
    "failed_to_record_payment": "Non ha registrato il pagamento.",
    "no_open_bills_found": "Nessuna fattura fornitore aperta trovata.",
    "select_a_vendor_to_view_open_bills": "Selezionare un fornitore per visualizzare le bollette aperte.",
    "loading_4": "Caricamento…",
    "gross_payroll": "Reddito lordo",
    "latest_payroll_total": "Ultimo paghe totale",
    "no_payroll_yet": "Nessun libro paga ancora",
    "monthly_variance": "Variazione mensile",
    "run_another_month_to_compare": "Eseguire un altro mese per confrontare",
    "higher_than_previous_month": "Più alto del mese precedente",
    "lower_than_previous_month": "Inferiore al mese precedente",
    "highest_department_weighting": "Pesatura di reparto più alta",
    "add_departments_to_compare": "Aggiungi reparti per confrontare",
    "not_required_for_run": "Non richiesto per la corsa",
    "employee_did_not_work": "I dipendenti non hanno funzionato",
    "employee_will_be_paid_base_salary_only": "I dipendenti saranno pagati solo lo stipendio base.",
    "employee_will_be_included_as_0_pay_only_after_you": "I dipendenti saranno inclusi come £0 paga solo dopo aver confermato che non hanno funzionato.",
    "review_before_payroll_can_proceed": "Recensione prima che il libro paga possa procedere.",
    "dashboard": "Pannello di controllo",
    "payroll_runs": "Esecuzioni di paghe",
    "approvals": "Approvazioni",
    "liabilities": "Passività",
    "settings": "Impostazioni",
    "annual_salary": "Salari annuali",
    "gross_annual_salary_before_deductions": "Lo stipendio annuale lordo prima delle deduzioni.",
    "hourly_rate": "Tasso orario",
    "standard_hourly_rate_before_overtime": "Tariffa oraria standard prima degli straordinari.",
    "casual_hourly_rate": "Tasso orario casuale",
    "default_casual_hourly_rate": "Tasso orario casuale predefinito.",
    "contractor_rate": "Tasso contrattuale",
    "default_contractor_rate_confirm_whether_this_is_hourly_or_dayrate": "Tasso di appalto predefinito. Confermare se questo è oraria o day-rate prima che il calcolo paghe sia abilitato.",
    "awaiting_approval_2": "Approvazione del risveglio",
    "approved_2": "Approvazione",
    "bacs_payment_file": "File di pagamento BACS",
    "nacha_payment_file": "NACHA File di pagamento",
    "sepa_payment_file": "Sepa file di pagamento",
    "bank_payment_file_csv": "Banca di pagamento File CSV",
    "download_csv": "Scarica CSV",
    "blocked_statutory_values_stale": "Bloccato: stallo dei valori stali",
    "blocked_employeelevel_statutory_values_required": "Bloccato: i valori di legge del livello dei dipendenti richiesti",
    "regenerate_pdf_required": "Rigenerare PDF richiesto",
    "ready_to_generate": "Pronti a generare",
    "payroll_summary_report": "paghe Rapporto sommario",
    "grosstonet_summary_report": "Rapporto di sintesi lord-to-Net",
    "employee_breakdown_summary": "Riepilogo dei dipendenti",
    "pension_contributions_summary": "Riepilogo dei contributi pensione",
    "hmrc_summary_report": "HMRC Rapporto riassuntivo",
    "final_payslips": "Pagamenti finali",
    "csv_summary_exports_and_printable_final_payslips_the_bank_payment": "CSV esportazioni sommarie e payslip finali stampabili. Il file di pagamento in banca è un artefatto di esportazione/validazione solo e mai si muove denaro.",
    "generate_payroll_documents": "Generare documenti paghe",
    "blocked": "Bloccato",
    "not_generated_yet": "Non generato ancora",
    "generate_employeespecific_final_payslip_snapshots_before_publishing": "Generare istantanee di payslip per dipendenti specifici prima di pubblicare.",
    "send_via_portal": "Invia tramite portale",
    "complete_once_to_make_payroll_clubready": "Una volta completa per fare paghe club-ready.",
    "confirm_country": "Paese di conferma",
    "choose_payroll_provider": "Scegli paghe Provider",
    "confirm_pension_provider": "Confermare il Fornitore di Pensioni",
    "verify_payroll_calendar": "Verifica il calendario dei pagamenti",
    "backenddriven_finance_control_workspace_for_the_active_payroll_run": "Backend-driven finanza controllo spazio di lavoro per il paghe attivo corsa.",
    "current_run_name": "Nome corrente",
    "pay_period": "Periodo di pagamento",
    "approval_deadline": "Termine per l'approvazione",
    "target_payment_date": "Data di pagamento",
    "posting_readiness": "Postare la prontezza",
    "recommendation_create_or_calculate_the_current_payroll_run_before_approval": "Raccomandazione: creare o calcolare l'attuale paghe eseguito prima dell'approvazione.",
    "insight_employee_readiness_timesheet_approvals_blockers_and_journal_preview_are": "Insight: prontezza dei dipendenti, approvazioni del foglio di tempo, bloccanti e anteprima della rivista sono caricati da dati paghe backend.",
    "plainenglish_checks_based_on_actual_payroll_data": "Controlli Plain-English basati sui dati reali del libro paga.",
    "payroll_mapping": "Mapping paghe",
    "preview_only_balanced_journal_lines_appear_after_payroll_approvalpost_preview": "Solo l'anteprima. Linee di giornale bilanciate appaiono dopo l'approvazione paghe / anteprima post.",
    "no_journal_preview_yet": "Nessuna anteprima del diario",
    "create_or_calculate_a_payroll_run": "Creare o calcolare un run paghe",
    "employees_ready": "Dipendenti pronti",
    "bank_details": "Dettagli della banca",
    "tax_details": "Dettagli fiscali",
    "approved_timesheets": "Schede di tempo approvate",
    "blockers": "Blocchi",
    "current_payroll": "Pagamenti correnti",
    "period_not_set": "Periodo non impostato",
    "gross_pay_2": "Paga lorda",
    "net_preview": "Anteprima della rete",
    "employer_costs_2": "Costi dei datori di lavoro",
    "total_payroll_cost_2": "Costo totale del paghe",
    "where_this_run_is_and_what_happens_next": "Dov'e' questa corsa e cosa succede dopo.",
    "backend_checks_that_determine_whether_payroll_can_move_forward": "Controlli di backend che determinano se il libro paga può andare avanti.",
    "needs_attention_2": "Necessità di attenzione",
    "no_payroll_trend_data_yet_complete_your_first_payroll_run": "Nessun paghe dati di tendenza ancora. Completa il tuo primo paghe run per iniziare a costruire paghe insights.",
    "latest_payroll_weighting_by_employee_department_employer_costs_are_not": "Ultimi paghe ponderazione da parte del dipartimento dei dipendenti. I costi del datore di lavoro non sono ripartiti tra i dipartimenti in V1.",
    "calculate_payroll_with_employee_departments_to_unlock_department_weighting": "Calcola il libro paga con i dipartimenti dei dipendenti per sbloccare la ponderazione del dipartimento.",
    "open_payroll_settings": "Impostazioni paghe aperte",
    "open_statutory_payroll_inputs": "Ingressi salariali aperti statutari",
    "open_employee_payroll_profile": "Profilo del paghe del dipendente aperto",
    "readiness_details": "Dettagli di disponibilità",
    "review_this_payroll_readiness_item": "Rivedere questo articolo di prontezza libro paga.",
    "payroll_run": "Ciclo paghe",
    "fixed_salary": "Retributo fisso",
    "timesheet_required": "Scheda tecnica necessaria",
    "salary_timesheet_adjustments": "Rettifiche di insalata + timesheet",
    "paid_from_the_profile_rate_without_requiring_a_timesheet": "Pagato dalla velocità del profilo senza richiedere un foglio temporale.",
    "paid_from_approved_timesheet_hours_for_each_payroll_period": "Pagato dalle ore del foglio di tempo approvate per ogni periodo del libro paga.",
    "base_salary_comes_from_the_profile_rate_timesheets_capture_overtimeadjustments": "Lo stipendio base viene dal tasso di profilo; i fogli di tempo catturano il tempo straordinario / aggiustamenti.",
    "fixed_day_of_month": "Giorno fisso del mese",
    "last_day_of_month": "Ultimo giorno di mese",
    "last_working_day_of_month": "Ultimo giorno lavorativo del mese",
    "last_monday_of_month": "Ultimo lunedì del mese",
    "last_tuesday_of_month": "Lo scorso martedì del mese",
    "last_wednesday_of_month": "Mercoledì scorso del mese",
    "last_thursday_of_month": "Giovedì scorso del mese",
    "last_friday_of_month": "Lo scorso venerdì del mese",
    "missing_bank": "Banca mancante",
    "missing_tax": "Tassa mancante",
    "missing_pension": "Pensione scomparsa",
    "unnamed_employee": "Dipendente senza nome",
    "view_employee": "Visualizza i Dipendenti",
    "fix_details": "Fissare i dettagli",
    "add_an_employee_or_adjust_the_filters": "Aggiungere un dipendente o regolare i filtri.",
    "could_not_load_departments": "Non poteva caricare i dipartimenti",
    "could_not_move_employees_the_change_was_reverted": "Non poteva muovere i dipendenti, il cambiamento è stato annullato.",
    "enter_a_department_name_first": "Inserire un nome di reparto prima.",
    "could_not_create_department": "Non è possibile creare reparto",
    "move_people_here_to_remove_assignment": "Spostare le persone qui per rimuovere l'assegnazione.",
    "drag_people_here_or_use_the_selector": "Trascinare le persone qui o utilizzare il selettore.",
    "could_not_archive_department": "Non poteva archivio di reparto",
    "visual_payroll_team_management_avatarled_draganddrop_friendly_no_hierarchy": "Visual paghe team management — avatar-led, drag-and-drop amichevole, nessuna gerarchia.",
    "create_department": "Creare un reparto",
    "select_a_staff_member_before_creating_the_employee_setup": "Selezionare un membro del personale prima di creare l'impostazione del dipendente.",
    "choose_a_pay_type": "Scegli un tipo di pagamento.",
    "choose_a_payroll_status": "Scegli uno stato del libro paga.",
    "we_could_not_create_this_employee_payroll_setup_please_check": "Non abbiamo potuto creare questa configurazione del libro paga dei dipendenti. Si prega di controllare i dettagli e riprovare.",
    "create_employee": "Creare Dipendenti",
    "start_with_a_staff_record_then_configure_pay_and_readiness": "Iniziare con un record personale, quindi configurare le basi di pagamento e disponibilità.",
    "no_calendar": "Nessun calendario",
    "bank_payment_details_are_not_configured_for_this_club_jurisdiction": "I dati di pagamento della banca non sono ancora configurati per questa giurisdizione del club.",
    "account_holder_name": "Nome del titolare del conto",
    "payment_reference_optional": "Riferimento di pagamento (facoltativo)",
    "routing_number": "Numero di instradamento",
    "checking": "Controllo",
    "savings": "Risparmio",
    "privana_stores_payroll_payment_details_encrypted_full_details_are_never": "Privana negozi paghe dettagli di pagamento crittografati. I dettagli completi non vengono mai più visualizzati dopo il salvataggio.",
    "replacement_reason": "Motivo di sostituzione",
    "replace_payment_details": "Sostituisci i dettagli di pagamento",
    "add_payment_details": "Aggiungi dettagli di pagamento",
    "profile_detail_could_not_be_loaded": "Il dettaglio del profilo non poteva essere caricato.",
    "replacement_reason_is_required_when_replacing_payment_details": "La ragione di sostituzione è necessaria quando si sostituisce i dettagli di pagamento.",
    "payment_details_saved_review_the_refreshed_details_then_mark_them": "Dati di pagamento salvati. Verificare i dettagli rinfrescati, quindi contrassegnarli verificati una volta verificato.",
    "payroll_profile_changes_saved": "Il profilo di paghe cambia salvato.",
    "payment_verification_status_updated": "Stato di verifica del pagamento aggiornato.",
    "payment_verification_status_could_not_be_updated": "Lo stato di verifica del pagamento non potrebbe essere aggiornato.",
    "status_could_not_be_updated": "Lo stato non potrebbe essere aggiornato.",
    "payroll_number_pending": "Numero di paghe in sospeso",
    "no_active_rate": "Nessun tasso attivo",
    "not_paid_yet": "Non pagato ancora",
    "no_amount_configured": "Nessun importo configurato",
    "active_3": "Attivo",
    "not_active": "Non attivo",
    "amount_paid_according_to_the_selected_pay_type": "Importo pagato in base al tipo di pagamento selezionato.",
    "no_full_ni_number_stored": "Nessun numero completo di NI memorizzato.",
    "employeespecific_employer_cost_overrides_are_stored_in_pension_metadata": "I overrides dei costi del datore di lavoro specifici del dipendente sono memorizzati nei metadati della pensione.",
    "audit_event_recorded": "Evento di verifica registrato.",
    "no_records_yet": "Non ci sono ancora registrazioni.",
    "hmrcpaye_liability": "Hmrc/Responsabilità dei pagamenti",
    "hmrc_payroll_liability": "HMRC paghe Responsabilità",
    "journal_balanced": "Bilancio della Gazzetta",
    "journal_not_balanced": "Rivista non bilanciata",
    "employer_costs_currently_000": "Costi del datore di lavoro attualmente £0.00",
    "mapping_needed": "Mapping necessario",
    "could_not_load_timesheets": "Non è possibile caricare i fogli di tempo",
    "timesheet_action_failed": "Risultato dell'azione del foglio di tempo",
    "submitted_hours": "Orario di presentazione",
    "approved_hours": "Ore approvate",
    "overtime_hours": "Ore straordinarie",
    "missing_timesheets": "Schede tecniche mancanti",
    "pending_approvals": "Approvazioni in sospeso",
    "approved_timesheets_are_the_operational_input_layer_for_timesheetdriven_and": "I fogli di tempo approvati sono lo strato di input operativo per i dipendenti timesheet-driven e ibridi.",
    "regular_hours": "Ore regolari",
    "overtime": "Straordinari",
    "holiday": "Vacanza",
    "sick": "Si'.",
    "total_hours": "Ore totali",
    "none": "Nessuno",
    "could_not_load_timesheet": "Non è possibile caricare il timesheet",
    "could_not_save_draft": "Non si può salvare la bozza",
    "action_failed_2": "Azione fallita",
    "timesheet": "Scheda tecnica",
    "regular": "Regolare",
    "no_adjustments_yet": "Ancora nessun aggiustamento.",
    "could_not_create_timesheet": "Non è possibile creare un foglio di tempo",
    "this_timesheet_records_overtime_holiday_sick_training_or_extra_payable": "Questo foglio di tempo registra ore straordinarie, vacanze, malati, formazione, o ore extra pagabili. Lo stipendio fisso rimane controllato dalla configurazione di pagamento del dipendente.",
    "this_timesheet_records_payable_hours_for_the_selected_payroll_period": "Questo foglio di tempo registra ore pagabili per il periodo di paghe selezionato.",
    "create_a_draft_timesheet_for_a_generated_payroll_period": "Creare un foglio di tempo di bozza per un periodo di paghe generato.",
    "choose_employee": "Scegli il dipendente",
    "choose_payroll_period": "Scegli il periodo paghe",
    "import_support_is_ready_for_csvtimeclock_integrations_this_pass_creates": "Il supporto all'importazione è pronto per le integrazioni CSV /time-clock. Questo pass crea solo fogli di tempo del draft paghe.",
    "approve_payroll": "Approvo paghe",
    "prepare_finance_preview": "Preparare l'anteprima di finanza",
    "view_payroll": "Visualizza paghe",
    "open_payroll": "Pagamenti aperti",
    "could_not_load_payroll_runs": "Non è possibile caricare le operazioni di paghe",
    "gross": "Grosso",
    "net_preview_2": "Anteprima netta",
    "ready_4": "✓ Pronto",
    "create_a_run_from_an_open_payroll_period_to_start": "Creare una corsa da un periodo di paghe aperto per avviare la recensione paghe guidata.",
    "not_supplied": "Non fornito",
    "recorded_user": "utente registrato",
    "employeelevel_statutory_values_are_ready_for_payroll_documents_and_future": "I valori statutari a livello dei dipendenti sono pronti per i documenti del libro paga e le buste paga future.",
    "legacy_providersupplied_statutory_values_are_held_at_run_level_and": "I valori legali forniti dai fornitori di Legacy sono tenuti a livello di esecuzione e non sono payslips dei dipendenti.",
    "missing_paye": "Mancante PAYE",
    "missing_employee_ni": "Dipendenti mancanti NI",
    "missing_employer_ni": "Datore di lavoro mancante NI",
    "net_pay_below_zero": "Retribuzione netta sotto zero",
    "unsaved_changes_reset": "Ripristino delle modifiche non salvate.",
    "postedlocked_payroll_runs_are_readonly": "Pubblicato / sbloccato paghe funziona sono di sola lettura.",
    "complete_paye_employee_ni_and_employer_ni_for_every_employee": "PAYE completo, dipendente NI, e datore di lavoro NI per ogni dipendente prima di salvare.",
    "employee_statutory_payroll_inputs_saved": "Ingressi salariali a carico dei dipendenti salvati.",
    "payroll_rows_changed_refreshing_this_run_please_review_and_save": "Le righe dei paghe sono cambiate. Refreshing this run — si prega di rivedere e salvare di nuovo.",
    "could_not_save_statutory_payroll_inputs": "Non poteva salvare gli input legali del libro paga.",
    "paye_income_tax_2": "PAYE Imposta sul reddito",
    "employee_national_insurance_2": "Assicurazione nazionale dei lavoratori",
    "employer_national_insurance_2": "Assicurazione nazionale dei datori di lavoro",
    "employee_pension": "Pensione dei dipendenti",
    "other_employee_deductions": "Altre deduzioni dei dipendenti",
    "net_pay_2": "Rimborso netto",
    "total_employer_cost": "Costo totale del datore di lavoro",
    "invalid": "Non valido",
    "missing_inputs": "Ingressi mancanti",
    "complete_3": "Completo",
    "could_not_create_payroll_run": "Non è possibile creare paghe run",
    "create_a_payroll_run_from_a_generated_payroll_period": "Creare un paghe eseguito da un periodo di paghe generato.",
    "choose_calendar": "Scegli il calendario",
    "choose_open_generated_period": "Scegli il periodo generato aperto",
    "resolve_blockers": "Risolvere i bloccanti",
    "fix_payroll_blockers_before_submitting": "Fissare i blocchi paghe prima di presentare.",
    "enter_statutory_payroll_inputs": "Inserire ingressi paghe statutari",
    "enter_providersupplied_paye_employee_ni_and_employer_ni_for_each": "Immettere PAYE, Dipendente NI e Datore di lavoro NI per ogni dipendente prima dell'approvazione.",
    "calculate_payroll": "Calcola il libro paga",
    "approve_payroll_2": "Approvo paghe",
    "resolve_blockers_before_approval_2": "Risolvere i bloccanti prima dell'approvazione.",
    "prepare_finance_preview_2": "Preparare l'anteprima della finanza",
    "post_payroll_to_accounting": "Posta paga per la contabilità",
    "journal_not_balanced_review_the_finance_preview_before_posting": "Rivista non equilibrata. Verificare l'anteprima della finanza prima della pubblicazione.",
    "record_payroll_payment": "Registrazione pagamento",
    "lock_payroll": "Blocco paghe",
    "payroll_complete": "paghe completo",
    "this_payroll_run_is_complete": "Questa corsa paghe è completa.",
    "could_not_load_payroll_run": "Non poteva caricare paghe run",
    "enter_statutory_payroll_inputs_before_continuing": "Immettere ingressi paghe legali prima di continuare.",
    "payroll_has_already_been_posted_and_cannot_be_rolled_back": "paghe è già stato pubblicato e non può essere ripiegato indietro.",
    "payroll_finance_mappings_need_attention": "Le mappe di finanza di paghe hanno bisogno di attenzione.",
    "post_payroll_to_accounting_before_payment": "Posta paghe alla contabilità prima del pagamento.",
    "complete_finance_posting_payables_and_staff_payment_before_locking_payroll": "Completa finanza posting, payables, e il pagamento del personale prima di blocco paghe.",
    "this_payroll_run_is_not_ready_for_that_step": "Questa corsa paghe non è pronta per quel passo.",
    "payroll_finance_preview_is_not_balanced_yet": "paghe finanza anteprima non è ancora bilanciato.",
    "this_payroll_run_is_locked": "Questa corsa del libro paga e' bloccata.",
    "payroll_run_updated": "L'esecuzione di paghe è aggiornata.",
    "payroll_summary_reports_generated": "Rapporti di sintesi paghe generati.",
    "nowork_exception_recorded": "Nessuna eccezione di lavoro registrata.",
    "timesheetnotrequired_acknowledgement_recorded": "Rilevamento non richiesto del foglio temporale registrato.",
    "load_the_payroll_run_before_generating_reports": "Caricare il libro paga prima di generare report.",
    "payroll_run_2": "Ciclo paghe",
    "follow_the_guided_payroll_lifecycle_from_review_through_accounting_posting": "Seguire il ciclo di vita del libro paga guidato dalla revisione attraverso la pubblicazione contabile, i pagamenti in sospeso, il pagamento e la serratura.",
    "review_this_item_before_moving_payroll_forward": "Rivedere questo articolo prima di spostare paghe in avanti.",
    "open_payroll_settings_and_fix_finance_mappings": "Aprire Impostazioni paghe e correggere mappature di finanza.",
    "open_the_related_employee_timesheet_or_deduction_totals_and_update": "Aprire i relativi dipendenti, timesheet o totali di deduzione e aggiornare le informazioni mancanti.",
    "confirm_staff_portal_publishing_for_this_payroll_run": "Conferma il portale del personale che pubblica per questo paghe run.",
    "publish_payslips": "Pubblicare payslips",
    "employee_breakdown_uses_saved_employeelevel_statutory_inputs_ready_for_payslip": "La ripartizione dei dipendenti utilizza ingressi legali a livello dei dipendenti salvati. Ready For Payslip significa che i valori vengono catturati; i documenti payslip generati appaiono nei documenti paghe.",
    "legacy_runlevel_statutory_values_are_not_employee_payslips_final_payslips": "I valori di legge a livello di Legacy non sono i payslips dei dipendenti. I payslip finali richiedono i valori legali a livello dei dipendenti.",
    "pay_type_2": "Tipo di pagamento",
    "base_pay": "Paga di base",
    "regular_hours_2": "Ore regolari",
    "overtime_hours_2": "Ore straordinarie",
    "overtime_pay": "Rimborso straordinario",
    "deductions": "Deduzioni",
    "runlevel_only": "Livello di esecuzione solo",
    "included_in_run_summary": "Incluso nel riassunto in corso",
    "see_run_totals": "Vedi i totali di esecuzione",
    "no_work_this_period": "Nessun lavoro in questo periodo",
    "runlevel_statutory_values": "Valori di legge a livello di esecuzione",
    "show": "Mostra",
    "payable_created": "Payable creato",
    "no_payment_preview_yet": "Non c'è ancora l'anteprima di pagamento.",
    "approval": "Approvazione",
    "payroll_approval_required": "Richiesta di approvazione del paghe",
    "finance_admin": "Finanza / Admin",
    "no_due_date": "Nessuna scadenza",
    "no_linked_item_is_available_yet": "Non è ancora disponibile alcun elemento collegato.",
    "open_the_linked_payroll_item": "Aprire l'articolo del libro paga collegato.",
    "open_linked_item": "Elemento aperto collegato",
    "no_action_available": "Nessuna azione disponibile",
    "no_payroll_approvals_or_blocker_reviews_are_waiting": "Nessuna approvazione paghe o recensioni bloccanti sono in attesa.",
    "payroll_clearing": "Sgombero paghe",
    "benefits_and_other": "Benefici e altri",
    "payroll_obligation": "Obbligo di pagamento",
    "create_payment_coming_soon": "Creare il pagamento in arrivo",
    "preview_only": "Anteprima solo",
    "create_and_calculate_a_payroll_run_to_see_payroll_liability": "Creare e calcolare un paghe run per vedere le anteprime di responsabilità paghe.",
    "no_rounding": "Nessun arrotondamento",
    "round_to_nearest_5_minutes": "Rotondo a 5 minuti più vicini",
    "round_to_nearest_15_minutes": "Giro a 15 minuti più vicino",
    "round_up_to_nearest_15_minutes": "Giro fino a 15 minuti più vicino",
    "settings_saved": "Impostazioni salvate.",
    "unable_to_save_settings": "Non è possibile salvare le impostazioni.",
    "payroll_policies_saved": "Politiche di paghe salvate.",
    "unable_to_save_payroll_policies": "Incapace di salvare le politiche del libro paga.",
    "unable_to_refresh_payroll_rule_defaults": "Non è possibile aggiornare i default delle regole paghe.",
    "provider_supplied": "Fornitura del fornitore",
    "privana_records_statutory_payroll_outputs_supplied_by_your_accountant_payroll": "Privana registra le uscite legali del libro paga fornite dal suo contabile, dal suo ufficio paghe o dal software paghe.",
    "connected_payroll_engine": "Motore di pagamento collegato",
    "coming_soon_privana_will_receive_statutory_outputs_from_a_connected": "Presto — Privana riceverà uscite legali da un motore paghe collegato.",
    "checked_manually": "Controllato manualmente",
    "checked_by_a_person_before_approval": "Controllato da una persona prima dell'approvazione.",
    "privana_calculates": "Privana Calcola",
    "privana_calculates_this_when_configured": "Privana lo calcola quando configurato.",
    "handled_outside_privana": "Manico esterno Privana",
    "handled_outside_privana_final_totals_are_entered_manually": "Maneggiati al di fuori di Privana; i totali finali sono inseriti manualmente.",
    "not_used": "Non usato",
    "disabled": "Disabili.",
    "provider_supplied_values_are_entered_during_payroll_run_review": "Fornito fornitore — i valori sono inseriti durante la revisione del paghe run.",
    "statutory_values_change_every_payroll_run_so_they_are_entered": "I valori legali cambiano ogni paghe run, quindi sono inseriti nella schermata di revisione del paghe run, non nelle impostazioni.",
    "employer_pension_contributions": "Contributi pensionistici dei datori di lavoro",
    "clubfunded_workplace_pension_cost": "Costo pensionistico sul posto di lavoro finanziato dal Club.",
    "set_the_employer_pension_rate_privana_should_calculate_from_eligible": "Impostare il tasso di pensione del datore di lavoro Privana dovrebbe calcolare dalla retribuzione lorda ammissibile.",
    "fixed_employer_contributions": "Contributi fissi dei datori di lavoro",
    "flat_employer_contribution_per_run_when_your_club_uses_one": "Contributo del datore di lavoro piatto per corsa quando il vostro club utilizza uno.",
    "use_only_for_fixed_club_employer_costs_that_should_be": "Utilizzare solo per i costi fissi del datore di lavoro del club che dovrebbero essere aggiunti a ogni corsa del libro paga.",
    "manual_employer_cost_adjustments": "Regolamenti manuali dei costi del datore di lavoro",
    "auditable_manual_employer_cost_adjustment": "Regolazione dei costi del datore di lavoro manuale.",
    "use_for_reviewed_employer_costs_that_are_not_statutory_deductions": "Utilizzare per le spese di datore di lavoro riviste che non sono detrazioni legali o pensione.",
    "workplace_pension_scheme": "Scheme della pensione del posto di lavoro",
    "provider_employee_contribution_club_contribution_and_autoenrolment_settings": "Provider, il contributo dei dipendenti, il contributo del club e le impostazioni di auto-iscrizione.",
    "set_the_provider_and_contribution_percentages_your_club_uses_for": "Impostare il fornitore e le percentuali di contributo che il vostro club utilizza per l'auto-iscrizione.",
    "additional_pay_for_approved_overtime_hours": "Paga supplementare per le ore straordinarie approvate.",
    "use_the_multiplier_your_club_applies_when_approved_hours_are": "Utilizzare il moltiplicatore che il vostro club si applica quando le ore approvate sono lavorate al di là delle ore normali.",
    "holiday_pay": "Paga di vacanza",
    "paid_annual_leave": "Congedo annuale.",
    "choose_how_holiday_pay_is_handled_for_your_club_staff": "Scelga come la paga di vacanza è gestito per il vostro personale del club.",
    "sick_pay": "Paga infernale",
    "pay_for_approved_sickness_absence": "Paga per l'assenza di malattia approvata.",
    "choose_statutory_sick_pay_your_club_policy_or_manual_review": "Scelga la paga legale malata, la politica del club, o la revisione manuale.",
    "private_healthcare_car_allowances_and_other_benefits": "Assistenza sanitaria privata, indennità di autovettura e altre prestazioni.",
    "turn_this_on_only_if_your_club_tracks_employee_benefits": "Accendere questo solo se il vostro club traccia i benefici dei dipendenti in paghe.",
    "statutory_payroll": "Iscrizioni legali",
    "pension_benefits": "Pensione e vantaggi",
    "pay_policies": "Politiche di pagamento",
    "customised": "Personalizzato",
    "using_defaults": "Utilizzo di default",
    "disabled_2": "Disabilitato",
    "enabled_2": "Abilitato",
    "united_kingdom": "⁇  Regno Unito",
    "united_states": "⁇  Stati Uniti",
    "european_payroll_region": "⁇  Regione europea del libro paga",
    "payroll_jurisdiction_not_set": "Competenza paghe non impostata",
    "united_kingdom_payroll_rules": "Regole di paghe del Regno Unito",
    "united_states_payroll_rules": "Regole di paghe degli Stati Uniti",
    "european_payroll_rules": "Regole di pagamento europee",
    "payroll_rules": "Regole di pagamento",
    "payroll_calendar_saved": "Calendario paghe salvato.",
    "unable_to_save_payroll_calendar": "Incapace di salvare il calendario paghe.",
    "payroll_periods_generated_open_generated_periods_were_refreshed_locked_paid": "I periodi di paghe generati. I periodi aperti generati sono stati rinnovati; i periodi chiusi, pagati e chiusi sono stati conservati.",
    "payroll_calendar_updated": "Calendario paghe aggiornato.",
    "payroll_calendar_action_failed": "L'azione del calendario di paghe è fallita.",
    "unable_to_load_payroll_settings": "Non è possibile caricare le impostazioni del libro paga.",
    "payroll_calendars_define_how_privana_creates_payroll_periods_approval_deadlines": "paghe Calendars definisce come Privana crea periodi di paghe, scadenze di approvazione, ritaglio di fogli di tempo e date di pagamento.",
    "cycle_anchor_date": "Data di ancoraggio del ciclo",
    "first_period_anchor_preview_from": "Primo periodo di ancoraggio / anteprima da",
    "period_dates": "Date d'inizio",
    "timesheet_cutoff": "Taglio del foglio di tempo",
    "save_calendar": "Salva il calendario",
    "store_clublevel_policy_defaults_for_future_payroll_calculations": "Di default di politica di livello del club di memorizzare per i calcoli futuri del libro paga.",
    "holiday_pay_enabled": "Paga di vacanza abilitata",
    "sick_pay_enabled": "Sick pay abilitato",
    "sick_pay_requires_manager_review": "Sick pay richiede recensione manager",
    "save_pay_rules": "Salvare le regole di pagamento",
    "timesheet_rounding_controls_how_clockinout_times_are_normalised_before_payroll": "L'arrotondamento del foglio di tempo controlla come i tempi di clock-in/out sono normalizzati prima della recensione paghe.",
    "save_timesheet_rules": "Salvare le regole del foglio di tempo",
    "plainenglish_club_payroll_choices_privana_keeps_technical_engine_settings_tucked": "Plain-English club paghe scelte. Privana mantiene le impostazioni tecniche del motore nascosto a meno che il supporto non ne abbia bisogno.",
    "confirm_pension_scheme_defaults_and_staff_benefits_your_club_tracks": "Confermare i predefiniti del regime pensionistico e il personale beneficia le tue tracce del club.",
    "set_how_your_club_handles_overtime_holiday_pay_and_sickness": "Impostare come il vostro club gestisce gli straordinari, la retribuzione per le vacanze e l'assenza di malattia.",
    "coming_soon_privana_does_not_currently_connect_to_payroll_engines": " (Comando presto. Privana attualmente non si collega ai motori paghe per i calcoli legali.)",
    "benefits_enabled": "Vantaggi abilitati",
    "included_in_salary": "Incluso in Salario",
    "timesheet_based": "Scheda tecnica",
    "statutory_sick_pay": "Paga malattia legale",
    "club_policy": "Politica del Club",
    "these_controls_determine_which_payroll_checks_privana_assist_will_surface": "Questi controlli determinano quali assegni paga Privana Assist si esporrà durante la revisione del libro paga.",
    "variance_alerts": "Avvisi di variazione",
    "missing_data_checks": "Controllo dei dati mancanti",
    "duplicate_payment_detection": "Rilevamento di pagamento duplicato",
    "payroll_readiness_summary": "Sommario di disponibilità del libro paga",
    "save_privana_assist_controls": "Salva Privana Controlli di assistenza",
    "production_role_model_for_payroll_access": "Modello di ruolo di produzione per l'accesso paghe.",
    "payroll_admin": "Admin di paghe",
    "manage_payroll_settings": "Gestire le impostazioni di paghe",
    "create_payroll_runs": "Creare operazioni di paghe",
    "edit_employees": "Modifica dei dipendenti",
    "payroll_approver": "Approvo paghe",
    "approve_payroll_runs": "Approfondisci le operazioni di paghe",
    "approve_payroll_liabilities": "Approvo passività del libro paga",
    "view_journal_previews": "Visualizzare le anteprime del diario",
    "department_manager": "Responsabile del Dipartimento",
    "approve_timesheets": "Approva i fogli di tempo",
    "review_overtime": "Recensione overtime",
    "view_department_payroll_summaries": "Visualizzare i riassunti del servizio paghe",
    "read_only_2": "Leggi solo",
    "view_payroll_dashboard": "Visualizzare la dashboard paghe",
    "view_payroll_reports": "Visualizza i report dei paghe",
    "no_editing_rights": "Nessun diritto di modifica",
    "needs_finance": "Bisogno finanziario",
    "verified": "Verificato",
    "high": "Alto",
    "medium": "Medio",
    "ap_payment_recorded": "Pagamento AP registrato.",
    "12month_gross_payroll_with_monthly_variance": "Tasso lordo di 12 mesi con variazione mensile.",
    "a_department_with_this_name_already_exists": "Un dipartimento con questo nome esiste già.",
    "supplier_bill": "Fornitore di Bill",
    "part_paid": "Parte pagata",
    "ready_for_payment": "Pronto per il pagamento",
    "club_context_is_missing_select_a_club_to_view_payables": "Il contesto del club manca. Selezionare un club per visualizzare i payables.",
    "unable_to_load_accounts_payable_data": "Non è in grado di caricare i dati pagabili.",
    "source_navigation_unavailable_for_this_payable": "Navigazione di origine non disponibile per questo pagabile.",
    "add_at_least_one_bill_line_before_posting": "Aggiungere almeno una linea di fattura prima di inviare.",
    "unable_to_post_bill": "Incapace di pubblicare il disegno di legge.",
    "unable_to_void_bill": "Incapace di svuotare il conto.",
    "allocations_unapplied": "Allocations non applicati.",
    "unable_to_unapply_allocations": "Incapace di assegnare senza applichi.",
    "allocations_reallocated": "Allocations reallocata.",
    "unable_to_reallocate_payment": "Incapace di effettuare il pagamento.",
    "enter_a_valid_refund_amount": "Inserisci un importo di rimborso valido.",
    "refund_exceeds_available_amount": "Il rimborso supera l'importo disponibile.",
    "select_a_bank_account_for_bank_refunds": "Selezionare un conto bancario per i rimborsi bancari.",
    "refund_recorded": "Rimborso registrato.",
    "configure_ap_control_and_payment_accounts_before_refunding": "Configurare il controllo AP e i conti di pagamento prima del rimborso.",
    "unable_to_refund_payment": "Incapace di rimborsare il pagamento.",
    "total_payables": "Totale Pagamenti",
    "outstanding_payables": "Pagamenti eccezionali",
    "due_this_month": "A causa di questo mese",
    "supplier_payables": "Pagamenti del fornitore",
    "payroll_liabilities_2": "Passività",
    "accounts_payable": "Conti pagabili",
    "posting": "Postare...",
    "enter": "Inserisci",
    "missing_information": "Informazioni mancanti",
    "please_complete_all_required_fields_before_saving": "Si prega di completare tutti i campi richiesti prima di salvare.",
    "bank_account_added": "Conto bancario aggiunto",
    "the_bank_account_is_ready_for_reconciliation": "Il conto bancario è pronto per la riconciliazione.",
    "failed_to_add_bank_account": "Non è stato possibile aggiungere un conto bancario",
    "please_try_again_or_contact_support": "Si prega di provare di nuovo o il supporto di contatto.",
    "loading_gl_accounts": "Caricamento conti GL...",
    "save_bank_account": "Salvare il conto bancario",
    "failed_to_load_bank_accounts": "Non è riuscito a caricare conti bancari",
    "bank_account_updated": "Conto bancario aggiornato",
    "failed_to_update_bank_account": "Non è stato possibile aggiornare il conto bancario",
    "default_account_updated": "Aggiornamento dell'account predefinito",
    "this_bank_account_is_now_the_default": "Questo conto bancario è ora il default.",
    "failed_to_update_default": "Non è stato possibile aggiornare il default",
    "no_gl_accounts": "Nessun account GL",
    "update_failed": "Aggiornamento fallito",
    "unable_to_update_review_status": "Non è possibile aggiornare lo stato della recensione.",
    "marked_reviewed": "Rivisto Marked",
    "marked_unreviewed": "Contrassegnato inedito",
    "unable_to_update_review_status_for_selected_transactions": "Non è possibile aggiornare lo stato di revisione per le transazioni selezionate.",
    "missing_reconciliation_scope": "Mancanza del campo di riconciliazione",
    "refresh_summary_to_load_statement_scope_before_finalizing": "Riepilogo Refresh per il campo di applicazione della dichiarazione di carico prima di finalizzare.",
    "reconciliation_finalized": "Riconciliazione finalizzata",
    "this_account_period_is_now_marked_complete": "Questo periodo di conto è ora contrassegnato completo.",
    "unable_to_finalize": "Incapace di finalizzare",
    "resolve_all_unmatched_queues_before_finalizing": "Risolvere tutte le code ineguagliabili prima di finalizzare.",
    "ready_to_finalize": "Pronti a finalizzare",
    "mark_unreviewed_2": "Segno non visualizzato",
    "mark_reviewed_2": "Mark ha esaminato",
    "no_transactions_yet_upload_a_statement_to_get_started": "Nessuna transazione per il momento. Carica un estratto conto per iniziare.",
    "select_a_bank_account_to_view_transactions": "Selezionare un conto bancario per visualizzare le transazioni.",
    "no_bank_accounts_yet_use_the_settings_menu_to_add": "Nessun conto bancario per il momento. Usa il menu delle impostazioni per aggiungerne uno.",
    "autodetect": "Rileva automaticamente",
    "date_column_is_required": "La colonna della data è richiesta.",
    "description_column_is_required": "La colonna di descrizione è richiesta.",
    "provide_either_an_amount_column_or_a_debitcredit_column": "Fornire una colonna Importa o una colonna Debit/Credit.",
    "statement_imported": "Dichiarazione d'importazione",
    "unable_to_import_statement": "Incapace di importare la dichiarazione.",
    "back": "Indietro",
    "importing": "Importare...",
    "remaining": "Rimanere",
    "income": "Reddito",
    "income_ytd": "Reddito (YTD)",
    "expenses_ytd": "Spese (YTD)",
    "unable_to_load_chart_of_accounts": "Incapace di caricare il grafico dei conti.",
    "account_code_and_name_are_required": "Il codice e il nome dell'account sono richiesti.",
    "unable_to_save_account_changes": "Non è possibile salvare le modifiche dell'account.",
    "unable_to_update_account_status": "Non è possibile aggiornare lo stato dell'account.",
    "edit_account": "Modifica account",
    "unable_to_load_dimensions": "Incapace di caricare le dimensioni.",
    "dimension_code_and_name_are_required": "Il codice e il nome della dimensione sono richiesti.",
    "that_dimension_code_already_exists_choose_a_unique_code": "Quel codice di dimensione esiste già. Scegli un codice unico.",
    "unable_to_save_dimension_changes": "Incapace di salvare i cambiamenti di dimensione.",
    "unable_to_update_dimension_status": "Incapace di aggiornare lo stato della dimensione.",
    "edit_dimension": "Modifica Dimensione",
    "operating": "Funzionamento operativo",
    "capex": "Caps.",
    "this_fiscal_year": "L'anno fiscale",
    "custom_range": "Gamma personalizzata",
    "unable_to_load_reports": "Incapace di caricare i report",
    "missing_fields": "Campi mancanti",
    "please_enter_a_report_name_and_type": "Si prega di inserire un nome del rapporto e digitare.",
    "budget_required": "Bilancio richiesto",
    "select_a_budget_to_run_budget_vs_actual": "Selezionare un budget per eseguire Budget vs Actual.",
    "budget_version_required": "Versione di bilancio richiesta",
    "select_a_budget_version_to_run_budget_vs_actual": "Selezionare una versione di budget per eseguire Budget vs Actual.",
    "unable_to_save_report": "Incapace di salvare il report",
    "are_you_sure_you_want_to_delete_this_report": "Sei sicuro di voler eliminare questo rapporto?",
    "unable_to_delete_report": "Incapace di eliminare il report",
    "gl_account_code": "GL Codice Account",
    "gl_account_name": "GL Account Nome",
    "ytd_budget": "YTD Bilancio",
    "ytd_actual": "Consuntivo da inizio anno",
    "ytd_variance": "Variazione YTD",
    "ytd_variance_2": "Variazione YTD %",
    "pdf_export_not_available_yet_use_csv": "PDF esportazione non ancora disponibile. Usa CSV .",
    "xlsx_export_coming_soon_for_budget_vs_actual": "XLSX esportazione in arrivo per Budget vs Actual",
    "unable_to_download_report": "Incapace di scaricare il report",
    "unable_to_run_report": "Incapace di eseguire la relazione",
    "ondemand": "Su richiesta",
    "failed_to_load_matches": "Non caricate le partite",
    "unable_to_load_matching_candidates_please_try_again": "Non è possibile caricare i candidati corrispondenti. Si prega di riprovare.",
    "no_remaining_balance": "Nessun saldo rimanente",
    "reduce_another_match_amount_before_selecting_this_allocation": "Ridurre un altro importo match prima di selezionare questa allocazione.",
    "match_saved": "Partita salvata",
    "bank_transaction_matching_updated": "Bilancio corrispondente aggiornato.",
    "failed_to_save_match": "Non riuscito a salvare la partita",
    "unable_to_update_bank_transaction_match_items": "Non è possibile aggiornare gli elementi di corrispondenza delle transazioni bancarie.",
    "match_cleared": "Corrispondenza schiarita",
    "match_items_removed_for_this_transaction": "Elementi di corrispondenza rimossi per questa transazione.",
    "failed_to_clear_match": "Non riuscito a cancellare la partita",
    "unable_to_clear_match_items_for_this_transaction": "Non è possibile cancellare gli elementi di corrispondenza per questa transazione.",
    "bank_transaction": "Operazioni bancarie",
    "unknown_period": "Periodo sconosciuto",
    "trial_balance_snapshot": "Equilibrio di prova",
    "snapshot": "Istantanea",
    "unknown": "Sconosciuto",
    "unassigned_account": "Conto non firmato",
    "unable_to_update_task": "Non è possibile aggiornare l'attività",
    "notes_saved": "Note salvate",
    "unable_to_save_notes": "Incapace di salvare le note",
    "period_closed": "Periodo chiuso",
    "close_blocked_by_earlier_periods": "Chiudere bloccata dai periodi precedenti",
    "close_failed": "Chiudere il fallimento",
    "unable_to_close_the_period_please_try_again": "Non è possibile chiudere il periodo. Si prega di riprovare.",
    "period_locked": "Periodo chiuso",
    "complete_required_tasks_or_add_an_override_reason": "Completare le attività richieste o aggiungere una ragione di override.",
    "lock_failed": "Bloccaggio fallito",
    "unable_to_lock_the_period_please_try_again": "Incapace di bloccare il periodo. Si prega di riprovare.",
    "period_unlocked": "Periodo sbloccato",
    "unlock_failed": "Sblocco fallito",
    "unable_to_unlock_the_period_please_try_again": "Non è possibile sbloccare il periodo. Si prega di riprovare.",
    "period_reopened": "Periodo riaperto",
    "reopen_failed": "Riaprire il fallimento",
    "unable_to_reopen_the_period_please_try_again": "Incapace di riaprire il periodo. Si prega di riprovare.",
    "snapshot_queued": "In coda istantaneo",
    "close_pack_snapshot_is_running": "L'istantanea del pacchetto è in esecuzione.",
    "snapshot_failed": "Un'istantanea fallita",
    "optional_tasks": "Attività opzionali",
    "no_updates_yet": "Nessun aggiornamento",
    "lock_month": "Mese di blocco",
    "unlock_period": "Periodo di sblocco",
    "reopen_period": "Periodo di riapertura",
    "run_snapshot": "Esecuzione di un'istantanea",
    "balanced": "Equilibrio",
    "out_of_balance": "Escluso il saldo",
    "periods_generated": "Periodi generati",
    "unable_to_generate_periods": "Incapace di generare periodi.",
    "unable_to_generate_periods_2": "Incapace di generare periodi",
    "unable_to_load_snapshot": "Incapace di caricare istantanee",
    "current_period_is_locked_unlock_to_continue_closing": "Il periodo attuale è chiuso. Sbloccarsi per continuare a chiudere.",
    "loading_years": "Caricamento anni...",
    "generate_periods_for_selected_year": "Genera i periodi per l'anno selezionato",
    "unable_to_load_periods": "Incapace di caricare i periodi",
    "please_refresh_to_try_again": "Si prega di rinfrescare per riprovare.",
    "created": "Creato",
    "edit_invoice": "Modifica Fattura",
    "failed_to_load_layout_settings": "Non è riuscito a caricare le impostazioni del layout.",
    "billing_email_must_be_blank_or_a_valid_email_address": "L'e-mail di fatturazione deve essere vuota o un indirizzo email valido.",
    "accent_color_must_be_a_valid_hex_color": "Il colore di accento deve essere un colore HEX valido.",
    "footer_note_must_be_1000_characters_or_fewer": "Nota piè di pagina deve essere 1000 caratteri o meno.",
    "layout_saved_successfully": "Layout salvato con successo!",
    "failed_to_save_layout": "Non è riuscito a salvare il layout.",
    "save_layout": "Salvare il layout",
    "received": "Ricevuto.",
    "paid_via_direct_payment_2": "Pagato tramite pagamento diretto",
    "included_in_billing_run": "Incluso in Billing Run",
    "fully_applied": "Completamente applicato",
    "partially_applied": "Particolare applicazione",
    "enter_allocation_amounts": "Inserire gli importi di allocazione.",
    "allocations_exceed_available_credit": "Le assegnazioni superano il credito disponibile.",
    "credit_allocated": "Credito stanziato.",
    "unable_to_allocate_credit": "Incapace di assegnare il credito.",
    "credit_refund_recorded": "Rimborso di credito registrato.",
    "refund_payment_recorded": "Pagamento di rimborso registrato.",
    "configure_ar_control_and_payment_accounts_before_refunding": "Configurare i conti di controllo e pagamento AR prima del rimborso.",
    "credit_refund_not_allowed": "Rimborso di credito non consentito.",
    "refund_not_allowed": "Rimborso non consentito.",
    "cannot_refund_a_refund_payment": "Non può rimborsare un pagamento di rimborso.",
    "unable_to_record_refund": "Incapace di registrare il rimborso.",
    "source_navigation_unavailable": "Navigazione di origine non disponibile",
    "enter_a_valid_credit_amount": "Inserisci un importo di credito valido.",
    "credit_applied": "Credito applicato.",
    "unable_to_apply_credit": "Incapace di applicare il credito.",
    "credit_note": "Nota di credito",
    "on_account": "Sull'account",
    "allocated_payment": "Pagamento convenzionato",
    "linked_pos_sale": "Vendita POS Linked",
    "see_pos_transaction_detail": "Vedi dettaglio delle transazioni POS",
    "unapplying": "Scompigliato...",
    "unapply": "Non applichi",
    "open_originating_source": "Fonte d'origine aperta",
    "source_resolution_unavailable": "Risoluzione sorgente non disponibile",
    "view_statement": "Dichiarazione di vista",
    "reallocate_payment": "Reallocate il pagamento",
    "refund_credit_2": "Credito di rimborso",
    "submit_refund_payment": "Invia il pagamento del rimborso",
    "no_available_credit_to_apply": "Nessun credito disponibile per l'applicazione",
    "no_open_invoices_to_apply_credit_to": "Nessuna fattura aperta per applicare il credito",
    "apply_available_member_credit": "Applicare il credito socio disponibile",
    "unable_to_load_current_period": "Incapace di caricare il periodo corrente",
    "unable_to_load_close_checklist": "In grado di caricare la lista di controllo vicina",
    "unable_to_close_period": "Incapace di chiudere il periodo.",
    "unable_to_close_period_2": "Incapace di chiudere il periodo",
    "unable_to_lock_period": "Incapace di bloccare il periodo.",
    "unable_to_lock_period_2": "Incapace di bloccare il periodo",
    "unable_to_unlock_period": "Sbloccare il periodo",
    "unable_to_reopen_period": "Incapace di riaprire il periodo",
    "select_period": "Selezionare il periodo",
    "complete_required_tasks_or_provide_an_override_reason": "Completo compiti richiesti o fornire una ragione di override.",
    "required_tasks_must_be_completed_override_not_permitted": "I compiti richiesti devono essere completati (non consentiti di sovrascrivere).",
    "close_period": "Periodo di chiusura",
    "lock_period": "Periodo di chiusura",
    "adjusting": "Regolazione",
    "reversal": "Inversione",
    "year_end": "Fine anno",
    "accrual": "Abitazione",
    "member_accounts_receivable": "Conti dei soci",
    "billing_recurring_billing": "Fatturazione / Fatturazione ricorrente",
    "staff_selected": "Personale selezionato",
    "you_dont_have_permission_to_perform_this_action": "Non hai il permesso di eseguire questa azione.",
    "endpoint_not_deployed_route_missing": "Endpoint non schierato / percorso mancante.",
    "server_error_check_logs": "Errore del server — controlla i registri.",
    "failed_to_load_monthend_tasks": "Non è riuscito a caricare le attività di fine mese",
    "unable_to_load_tasks": "Incapace di caricare le attività",
    "failed_to_load_monthend_exceptions": "Non è riuscito a caricare le eccezioni di fine mese",
    "unable_to_load_exceptions": "Incapace di caricare eccezioni",
    "delete_this_task_template": "Eliminare questo modello di attività?",
    "delete_this_exception_policy": "Eliminare questa politica di eccezione?",
    "task_name_is_required": "Il nome dell'attività è richiesto",
    "task_templates_saved": "Modelli di attività salvati",
    "failed_to_save_task_templates": "Non riuscito a salvare i modelli di attività",
    "unable_to_save_task_templates": "Incapace di salvare i modelli di attività",
    "reason_is_required_for_exceptions": "La ragione è richiesta per le eccezioni",
    "exception_policies_saved": "Politiche di eccezione salvate",
    "failed_to_save_exception_policies": "Non riuscito a salvare le politiche di eccezione",
    "unable_to_save_exception_policies": "Incapace di salvare le politiche di eccezione",
    "walkin": "Camminare",
    "unposted": "Non contabilizzato",
    "review_post": "Recensione & post",
    "voided": "Voi stessi",
    "fix_repost": "Fissaggio & Repost",
    "view_issue": "Problematiche di visualizzazione",
    "this_receivable_is_sourcemanaged_and_must_be_corrected_from_its": "Questo credito è gestito dalla fonte e deve essere corretto dal flusso di lavoro originario o dal processo di posting.",
    "guest": "Ospite",
    "adhoc": "Ad-hoc",
    "unable_to_resolve_this_golf_booking_source": "Non è possibile risolvere questa fonte di prenotazione Golf.",
    "unable_to_resolve_this_racquet_booking_source": "Non è possibile risolvere questa fonte di prenotazione Racquet.",
    "unable_to_resolve_this_spa_booking_source": "Non è possibile risolvere questa fonte di prenotazione Spa.",
    "unable_to_resolve_this_fitness_booking_source": "Non è possibile risolvere questa fonte di prenotazione Fitness.",
    "unable_to_resolve_this_event_source": "Incapace di risolvere questa fonte di eventi.",
    "unable_to_resolve_this_room_reservation_source": "Non è possibile risolvere questa fonte di prenotazione della stanza.",
    "source_navigation_is_not_available_for_this_charge_yet": "La navigazione di origine non è ancora disponibile per questa carica.",
    "this_receivable_is_sourcemanaged_and_cannot_be_manually_posted_here": "Questo credito è gestito da fonti e non può essere inviato manualmente qui.",
    "unable_to_post_receivable": "Incapace di pubblicare crediti.",
    "unable_to_create_credit_note": "Incapace di creare una nota di credito.",
    "debtor_type": "Tipo di debito",
    "billing_run_2": "Fatturazione / Ciclo",
    "open_invoice_detail": "Dettaglio fattura aperta",
    "invoice_not_yet_generated": "Fattura non ancora generata",
    "void_allocation": "Distribuzione Void",
    "choose_open_member_invoice": "Scegli la fattura del socio aperto...",
    "save_draft_post_credit_note": "Salva bozza / Posta di credito Nota",
    "unable_to_enroll_member": "Incapace di iscriversi",
    "golf_green_fees": "Golf green fee",
    "golf_addons_caddie_hire": "Golf add-ons / noleggio caddie",
    "unmapped_charge": "Carica non mappata",
    "member_account": "Conto",
    "will_be_generated_during_next_billing_run": "Sarà generato durante la prossima corsa di fatturazione",
    "deferred_from_earlier_billing": "Deferito da fatturazione precedente",
    "move_back_to_this_statement": "Torna a questa dichiarazione",
    "next_billing_run": "Prossima corsa di fatturazione",
    "future_billing_run": "Futuro processo di fatturazione",
    "no_billable_items_are_currently_available_for_invoicing": "Attualmente non sono disponibili articoli fatturabili per la fatturazione.",
    "unable_to_preview_invoice": "In grado di visualizzare in anteprima la fattura",
    "download_failed": "Download non riuscito",
    "unable_to_generate_and_download_invoice": "Incapace di generare e scaricare la fattura",
    "unable_to_generate_and_send_invoice": "Incapace di generare e inviare la fattura",
    "invoice_generated_successfully_but_the_email_could_not_be_delivered": "Fattura generata con successo, ma l'e-mail non potrebbe essere consegnata.",
    "the_invoice_is_available_in_invoicing": "La fattura è disponibile in fatturazione.",
    "invoice_generated_and_emailed_successfully": "Fattura generata ed e-mail con successo.",
    "unable_to_generate_club_run": "Incapace di generare club run",
    "choose_a_valid_current_or_future_billing_run": "Scegli una corrente valida o una corsa di fatturazione futura.",
    "billing_run_updated": "La fatturazione viene aggiornata.",
    "unable_to_update_billing_run": "Non è possibile aggiornare la fatturazione",
    "unable_to_update_charge": "Non è possibile aggiornare la carica",
    "unable_to_load_dues_enrollments": "Incapace di caricare le registrazioni dei due",
    "billing_run_generated": "La fatturazione viene generata.",
    "unable_to_generate_recurring_billing_run": "Incapace di generare la corsa di fatturazione ricorrente",
    "unable_to_run_bulk_action": "Incapace di eseguire l'azione di massa",
    "recurring_billing_cannot_be_activated_until_a_dues_amount_greater_2": "La fatturazione ricorrente non può essere attivata fino a quando non viene inserito un importo pari a zero.",
    "choose_a_monthly_quarterly_or_annual_frequency_before_enrolling_this": "Scegliere una frequenza mensile, trimestrale o annuale prima di iscriversi a questo socio.",
    "unable_to_generate_invoice": "Incapace di generare fattura",
    "unable_to_load_statement_preview_please_try_again": "Non è possibile caricare l'anteprima della dichiarazione.",
    "unable_to_record_payments": "Incapace di registrare i pagamenti",
    "unable_to_save_settings_2": "Non è possibile salvare le impostazioni",
    "current_period_2": "Periodo attuale",
    "sending_2": "Invio…",
    "generate_send": "Genera e invia",
    "generate_club_run": "Generare Club Run",
    "current_run": "Corrente di corrente",
    "resolve_gl_mapping_warnings_before_generating_this_run": "Risolvere gli avvisi di mappatura GL prima di generare questa corsa.",
    "membership_dues": "Obbligo di iscrizione",
    "draft_invoice": "Progetto di fattura",
    "line_item": "Articolo di linea",
    "confirm_generate": "Confermare il gene",
    "generate_download": "Genera e scarica",
    "primary_charge": "Carico primario",
    "save_billing_run": "Salvare Billing Run",
    "chart_of_accounts_verified": "Grafico dei conti verificati",
    "tax_codes_verified": "Codici fiscali verificati",
    "dimensions_verified": "Dimensioni verificate",
    "revenue_mappings_verified": "Mapping delle entrate verificate",
    "payroll_mappings_verified": "Pagamenti verificati",
    "label_is_required": "L'etichetta è richiesta.",
    "label_must_include_letters_or_numbers": "L'etichetta deve includere lettere o numeri.",
    "that_label_creates_a_duplicate_key_try_a_slightly_different": "Quell'etichetta crea una chiave duplicata. Prova un'etichetta leggermente diversa.",
    "unable_to_save_the_revenue_mapping": "Incapace di salvare la mappatura delle entrate.",
    "unable_to_save_the_payroll_mapping": "Incapace di salvare la mappatura del libro paga.",
    "unable_to_apply_regional_accounting_defaults": "Incapace di applicare i di default della contabilità regionale.",
    "accounting_defaults_refreshed": "Le impostazioni predefinite sono aggiornate.",
    "payroll_defaults_refreshed": "Le impostazioni predefinite di paghe sono aggiornate.",
    "historical": "Storia",
    "final_checks_are_taking_a_moment": "I controlli finali stanno prendendo un momento...",
    "finalising_accounting_defaults_and_mappings": "Finalizzazione di default e mappature contabili...",
    "edit_gl_mapping": "Modifica GL Mapping",
    "new_gl_mapping": "Nuovo GL Mapping",
    "unable_to_load_yearend_assistant": "In grado di caricare Year-End Assistant",
    "unable_to_load_fiscal_years_right_now_please_refresh_and": "Incapace di caricare gli anni fiscali in questo momento. Si prega di rinfrescare e riprovare.",
    "yearend_is_blocked": "Anno di fine è bloccato",
    "resolve_all_blocker_checks_before_closing_this_fiscal_year": "Risolvere tutti i controlli di blocco prima di chiudere questo esercizio fiscale.",
    "unable_to_close_fiscal_year": "Incapace di chiudere l'esercizio fiscale",
    "please_review_blockers_and_try_again": "Si prega di rivedere i bloccanti e riprovare.",
    "billing_period": "Periodo di fatturazione",
    "not_billable": "Non fatturabile",
    "recurring": "Ripresa",
    "recurring_billing_run": "Corsa di fatturazione ricorrente",
    "direct_payment": "Pagamento diretto",
    "not_billable_voidedcancelled": "Non fatturabile: vuoto/cancellato",
    "need_to_collect": "Necessità di Raccogliere",
    "blocked_missing_revenue_mapping": "Bloccato: mappatura delle entrate mancanti",
    "manual_invoice": "Fatturazione manuale",
    "recurring_run": "Corsa ricorrente",
    "payroll_method_2": "Metodo di pagamento:",
    "impact": "Impatto:",
    "period_2": "Periodo:",
    "timesheet_cutoff_2": "Taglio del foglio di tempo:",
    "approval_deadline_2": "Termine per l'approvazione:",
    "pay_date_2": "Data di pagamento:",
    "employee_2": "Dipendente:",
    "method_2": "Metodo:",
    "receivable": "Accettabile:",
    "payment_2": "Pagamento:",
    "allocations": "Assegnazioni:",
    "gl_journal": "Giornale contabile:",
    "pos_sale_2": "Vendita POS:",
    "taxvat": "Tasse/ VAT :",
    "inventory_movement": "Movimento dell'inventario:",
    "credit_note_2": "Nota di credito #:",
    "amount_2": "Importo:",
    "invoice_3": "Fattura:",
    "posted_2": "Pubblicato:",
    "posted_at": "Pubblicato a:",
    "created_by": "Creato da:",
    "source_ref": "Rif. origine:",
    "gl_mapping_2": "Mappatura gL:",
    "payment_source": "Fonte di pagamento:",
    "payment_reference": "Riferimento di pagamento:",
    "issued_due": "Emessa / Due:",
    "revenue_gl_account": "Reddito gl conto:",
    "receivables_control": "Controllo crediti:",
    "cashbankcard_clearing": "Cancellazione di contanti/banca/carte:",
    "tax_code_3": "Codice fiscale:",
    "tax_rate_2": "Tasso d'imposta:",
    "vattax_amount": "VAT /Tax Importo:",
    "vat_payable_gl": "Conto IVA a debito:",
    "dimension_2": "Dimensione:",
    "allocation_status": "Stato di allocazione:",
    "created_posted": "Creato / Pubblicato:",
    "gl_journalbatch": "Giornale/lotto contabile:",
    "pos_payment": "Pagamento POS:",
    "voidrefundreversal": "Void/Rimborso/Reversal:",
    "skipped_items": "Oggetti saltati:",
    "warnings": "Avvertenze:",
    "panel": "Pannello",
    "balance_due_value0": "Bilancia dovuta: {value0}",
    "value0_avatar": "avatar {value0}",
    "value0_employees_value1": "{value0} dipendenti • {value1} %",
    "move_this_payroll_run_back_to_value0": "Spostare questo libro paga eseguire indietro a {value0}",
    "step_value0": "Fase {value0}",
    "value0_stage_value1_pay_date_value2": "{value0} stage • {value1} • Data di pagamento: {value2}",
    "affected_value0": "Colpevole: {value0}",
    "recommended_fix_value0": "Correzione consigliata: {value0}",
    "move_value0_department": "Spostare il reparto {value0}",
    "warning_value0_active_current_rates_overlap_payroll_runs_use_the": "Avvertenza: {value0} tassi correnti attivi si sovrappongono. Le corse di paghe utilizzano il più recente tasso efficace; il risparmio di un nuovo tasso attivo chiuderà le sovrapposizioni più vecchie.",
    "user_value0": "Utente: {value0}",
    "record_payroll_wage_expense_for_value0": "Costi salariali per il salario del salario del salario del record per {value0}",
    "create_payroll_clearing_liability_for_net_staff_payments_of_value0": "Creare responsabilità di compensazione del libro paga per i pagamenti del personale netto di {value0}",
    "paye_income_tax_value0": "Tassa di reddito PAYE: {value0}",
    "employee_national_insurance_value0": "Assicurazione nazionale dei dipendenti: {value0}",
    "employer_national_insurance_value0": "Assicurazione nazionale dei datori di lavoro: {value0}",
    "hmrc_total_value0": "HMRC totale: {value0}",
    "privana_assist_value0": "Assistenza privata: {value0}",
    "value0_adjustment_rows_available": "Sono disponibili {value0} righe di regolazione.",
    "value0_pay_date_value1": "{value0} • Data di pagamento: {value1}",
    "value0_of_value1_employees_complete": "{value0} di {value1} dipendenti completi",
    "value0_pay_value1": "{value0} • Paga {value1}",
    "journal_count_value0": "Rivista: {value0}",
    "primary_journal_value0": "Diario primario: {value0}",
    "duplicates_value0": "Duplicazioni: {value0}",
    "value0_new_eligible_employee_is_not_included_yet_recalculate_payroll": "{value0} nuovo dipendente ammissibile non è ancora incluso. Calcolare il libro paga per includerli.",
    "fix_action_value0": "Azione fissa: {value0}",
    "owner_value0_due_value1": "Proprietario: {value0} • Due: {value1}",
    "due_value0_source_value1": "Due: {value0} • Fonte: {value1}",
    "value0_detected_automatically_from_your_club_address": "{value0} rilevati automaticamente dall'indirizzo del club.",
    "last_refreshed_value0": "Ultimo aggiornamento: {value0}",
    "value0_enabled": "{value0} abilitato",
    "minimum_earnings_threshold_value0": "Soglia minima di orecchio ({value0} )",
    "remaining_capacity_value0": "Capacità di mantenimento: {value0}",
    "amount_must_be_between_0_and_value0": "L'importo deve essere compreso tra 0 e {value0} .",
    "finalized_value0_by_value1": "Finalizzato {value0} di {value1} .",
    "value0_selected": "{value0} selezionato",
    "select_transaction_value0": "Selezionare la transazione {value0}",
    "ref_value0": "Ref: {value0}",
    "detected_format_value0": "Formato rilevato: {value0}",
    "value0_more": " (+ {value0} in più)",
    "previewing_value0_of_value1_rows": "Anteprima {value0} di {value1} righe.",
    "step_value0_of_4": "Fase {value0} di 4",
    "actual_value0": "Attuale: {value0}",
    "budget_value0": "Bilancio: {value0}",
    "difference_value0": "Differenza: {value0}",
    "version_vvalue0": "Versione v {value0}",
    "value0_value1_to_value2": "{value0} · {value1} a {value2}",
    "value0_rows": "{value0} righe",
    "as_of_value0": "Al {value0}",
    "confidence_value0": "Confidenza {value0} %",
    "status_value0": "Stato: {value0}",
    "remaining_to_match_value0": "Rimanente al match: {value0}",
    "required_tasks_value0value1_complete": "Completi compiti richiesti {value0} / {value1}.",
    "optional_value0value1": "Opzionale {value0} / {value1}",
    "updated_value0_by_value1": "Aggiornato {value0} da {value1}",
    "staff_value0": "Personale {value0}",
    "reason_value0": "Motivo: {value0}",
    "by_value0": "Da {value0}",
    "close_value0_first": "Chiudere {value0} prima.",
    "manage_value0": "Gestisci {value0}",
    "generated_value0_value1": "Generazione {value0} {value1}",
    "fyvalue0": "FY {value0}",
    "fiscal_month_value0": "Fiscal Mese {value0}",
    "value0value1_required": "{value0} / {value1} richiesto",
    "value0value1_optional": "{value0} / {value1} opzionale",
    "sort_by_value0": "Ordina per {value0}",
    "invoice_value0": "Fatturato # {value0}",
    "value0_logo": "logo {value0}",
    "tax_amount_value0_at_value1": "Importo fiscale {value0} a {value1} .",
    "missing_output_vat_gl_account_used_by_value0_invoice_value1": "Uscita mancante VAT GL Account — utilizzato da {value0} fattura {value1} .",
    "lines_value0": "Linee: {value0}",
    "direct_payment_via_member_portalvalue0": "Pagamento diretto tramite Portale degli Stati soci {value0}",
    "account_details_value0": "Dettagli del conto: {value0}",
    "unapplied_credit_available_value0": "Credito non applicato disponibile: {value0}",
    "unapply_credit_value0_value1": "Credito senza applichi {value0} ({value1} )",
    "max_refundable_value0": "Max rimborsabile: {value0}",
    "account_value0": "Conto: {value0}",
    "applied_value0": "Applicato: {value0}",
    "value0_date_value1_due_value2": "# {value0} · Data {value1} · Due {value2}",
    "showing_value0value1_of_value2": "Mostrando {value0} – {value1} di {value2}",
    "value0_value1_payment_value2": "{value0} · {value1} · pagamento {value2}",
    "value0_value1_vat_value2_gross_value3": "{value0} · {value1} · VAT {value2} · lordo {value3}",
    "value0_value1_dr_value2_cr_value3": "{value0} · {value1} · Dr. {value2} · Cr {value3}",
    "generate_issued_invoices_for_value0_selected_members_with_active_recurring": "Generare fatture emesse per {value0} soci selezionati con modelli di ricorsi attivi? Questo non verrà inviato al GL.",
    "will_bill_value0_mapped_items": "Fattura: {value0} elemento mappato(i).",
    "will_skip_value0_unmapped_items": "Salterà: {value0} oggetti non mappati.",
    "key_value0": "(chiave: {value0})",
    "club_run_complete_value0_generated_value1_failed": "Corsa completa: {value0} generato, {value1} fallito.",
    "of_value0_members": "di {value0} soci",
    "period_value0_outstanding_value1": "Periodo: {value0} · Eccezionale: {value1}",
    "value0_lines": "{value0} linee",
    "value0_value1_lines": "{value0} · {value1} linee",
    "statement_preview_value0": "Anteprima dichiarazione: {value0}",
    "projected_for_value0": "Progetto per {value0}",
    "outstanding_value0": "Eccezionale {value0}",
    "value0_scheduled": "{value0} in programma",
    "billing_period_value0value1": "Periodo di fatturazione: {value0} {value1}",
    "total_billed_value0": "Totale fatturato: {value0}",
    "paid_value0": "Pagato: {value0}",
    "outstanding_value0_2": "Eccezionale: {value0}",
    "invoices_value0": "Fatture: {value0}",
    "this_will_create_payments_for_open_invoices_totalling_value0": "Ciò creerà pagamenti per fatture aperte per un totale di {value0} .",
    "sale_value0": "Vendita {value0}",
    "membership_type_value0": "Tipo di iscrizione: {value0} . ",
    "key_value0_2": "Chiave: {value0}",
    "count_value0": "Conte: {value0}",
    "blockers_value0": "Bloccanti: {value0}",
    "warnings_value0": "Avvertenze: {value0}",
    "passed_value0": "Passato: {value0}",
    "confidence_value0_2": "Confidenza: {value0}",
    "value0_passed_checks": "{value0} assegni passati",
    "value0_skipped_checks": "{value0} assegni",
    "close_fyvalue0": "Chiudere FY {value0}?",
    "receivables": "Crediti",
    "all_fiscal_periods_are_locked": "Tutti i periodi fiscali sono bloccati",
    "all_accounting_periods_in_the_fiscal_year_must_be_locked": "Tutti i periodi contabili nell'esercizio fiscale devono essere chiusi prima della fine dell'anno.",
    "period_control": "Controllo del periodo",
    "no_draft_invoices": "Nessun progetto di fatture",
    "draft_or_unposted_invoices_in_the_fiscal_year_must_be": "Il progetto o le fatture non inviate nell'esercizio fiscale devono essere pubblicate o annullate.",
    "transaction_completeness": "Completamento delle transazioni",
    "no_draft_ap_bills": "Nessuna bozza di bollette AP",
    "draft_ap_bills_in_the_fiscal_year_must_be_posted": "Il progetto di legge AP nell'anno fiscale deve essere pubblicato o annullato.",
    "no_draft_journals": "Nessuna redazione di diari",
    "journal_entries_in_draftunposted_status_must_be_posted_before_yearend": "Le voci di giornale nel progetto/stato non segnalato devono essere pubblicate prima della fine dell'anno.",
    "journals_are_balanced": "I giornali sono equilibrati",
    "total_debits_and_credits_must_match_for_each_journal_entry": "Gli addebiti e i crediti totali devono corrispondere per ogni voce della rivista nell'anno fiscale.",
    "control_accounts_configured": "Conti di controllo configurati",
    "required_controldefault_accounts_in_accounting_settings_must_be_configured": "Gli account di controllo/di default richiesti nelle Impostazioni di Accounting devono essere configurati.",
    "configuration": "Configurazione",
    "applicable_revenue_mappings_configured": "Mapping dei ricavi applicabili configurati",
    "applicable_active_revenue_mappings_must_have_required_gl_accounts": "Le mappe di entrate attive applicabili devono aver richiesto conti GL.",
    "bank_reconciliations_complete": "Riconciliazioni bancarie complete",
    "active_bank_accounts_should_be_reconciled_through_fiscal_year_end": "I conti bancari attivi dovrebbero essere riconciliati attraverso la fine dell'anno fiscale.",
    "banking_cash": "Bancario e Cash",
    "receivables_reviewed": "Recepibili esaminati",
    "open_receivables_overdue_as_of_fiscal_year_end_should_be": "I crediti aperti in ritardo rispetto alla fine dell'esercizio fiscale dovrebbero essere esaminati.",
    "review_items": "Articoli di revisione",
    "ap_aging_reviewed": "AP invecchiamento recensito",
    "overdue_ap_bills_as_of_fiscal_year_end_should_be": "Le bollette AP indebite a partire dall'estremità dell'esercizio fiscale dovrebbero essere esaminate.",
    "unapplied_payments_reviewed": "Pagamenti non applicati esaminati",
    "member_payments_with_unapplied_amounts_should_be_reviewed": "I pagamenti degli Stati soci con importi non applicati devono essere esaminati.",
    "clearing_accounts_reviewed": "Conti di compensazione esaminati",
    "clearing_account_balances_should_be_zeroed_at_fiscal_year_end": "La liquidazione dei conti dovrebbe essere annullata alla fine dell'esercizio fiscale.",
    "club_operations": "Operazioni Club",
    "not_applicable_for_this_clubmodule_configuration": "Non applicabile per questa configurazione club/modulo.",
    "all_fiscal_year_periods_must_be_locked": "Tutti i periodi di esercizio fiscale devono essere bloccati.",
    "review_periods": "Periodi di valutazione",
    "all_fiscal_year_periods_are_locked": "Tutti i periodi dell'anno fiscale sono bloccati.",
    "no_draft_or_unposted_invoices_remain": "Nessuna bozza o fatture non inviate rimane.",
    "no_draft_or_unposted_ap_bills_remain": "Nessuna bozza o le bollette AP non inviate rimangono.",
    "review_ap": "Recensione AP",
    "no_draft_or_unposted_journals_remain": "Non rimangono diari abbozzati o non inviati.",
    "review_gl": "Recensione GL",
    "journals_tables_are_unavailable_in_this_environment": "Le tabelle dei giornali non sono disponibili in questo ambiente.",
    "value0_journal_entries_are_unbalanced": "{value0} voci del diario sono sbilanciate.",
    "all_journals_are_balanced": "Tutte le riviste sono bilanciate.",
    "accounting_settings_table_unavailable": "Impostazioni di contabilità tabella non disponibile.",
    "missing_control_account_mappings_value0": "Mapping account di controllo mancante: {value0} .",
    "accounting_settings_2": "Impostazioni di contabilità",
    "required_control_accounts_are_configured": "Gli account di controllo richiesti sono configurati.",
    "value0_applicable_revenue_mappings_are_missing_gl_accounts": "{value0} entrate applicabili mappature sono mancanti conti GL.",
    "revenue_mappings_2": "Mapping delle entrate",
    "applicable_revenue_mappings_are_configured": "Sono configurate le mapping dei ricavi applicabili.",
    "bank_reconciliation_readiness_source_is_not_implemented_yet": "La fonte di prontezza di riconciliazione della banca non è ancora attuata.",
    "invoices_table_unavailable": "Tabella fatture non disponibile.",
    "value0_receivables_are_overdue_as_of_fiscal_year_end": "{value0} crediti sono in ritardo rispetto alla fine dell'anno fiscale.",
    "no_overdue_receivables_as_of_fiscal_year_end": "Nessun credito eccessivo a partire dalla fine dell'anno fiscale.",
    "ap_bills_table_unavailable": "Tavolo AP bollette non disponibile.",
    "value0_ap_bills_are_overdue_as_of_fiscal_year_end": "{value0} bollette AP sono in ritardo rispetto alla fine dell'anno fiscale.",
    "no_overdue_ap_bills_as_of_fiscal_year_end": "Non c'e' un'eccessiva bolletta dell'AP a partire dalla fine dell'anno fiscale.",
    "payments_table_unavailable": "La tabella dei pagamenti non è disponibile.",
    "value0_unapplied_member_payments_remain": "Rimangono {value0} pagamenti non applicati.",
    "no_unapplied_member_payments_remain": "Non rimangono pagamenti non applicati.",
    "clearing_account_balance_helper_is_not_available": "Cancellare l'aiuto del saldo del conto non è disponibile.",
    "value0_readiness_source_is_not_implemented_yet": "{value0} fonte di prontezza non è ancora implementata.",
    "value0_source_table_is_unavailable": "{value0} tabella di origine non è disponibile.",
    "value0_value1_records_need_posting_or_settlement_review": "{value0} {value1} record bisogno di postazione o regolamento recensione.",
    "open_module": "Modulo aperto",
    "value0_revenue_appears_settled_for_the_fiscal_year": "Per l'esercizio fiscale si registrano {value0} ricavi.",
    "value0_table_unavailable": "{value0} tavolo non disponibile.",
    "value0_records_are_still_draft_or_unposted": "{value0} record sono ancora abbozzati o non inviati.",
    "check_skipped_because_supporting_tables_are_unavailable_in_this_environment": "Controllare saltato perché i tavoli di supporto non sono disponibili in questo ambiente.",
    "paid_value0_bills_updated_value1": "Pagato {value0} · Bollette aggiornate: {value1}",
    "allocated_value0_unapplied_value1": "Legato {value0} · Non applicato {value1}",
    "value0_must_be_a_positive_number": "{value0} deve essere un numero positivo.",
    "value0_transactionvalue1_updated": "Operazioni aggiornate: {value0} .",
    "imported_value0_rows_skipped_value1_duplicates": "Importato {value0} righe. Abilitato {value1} duplicati.",
    "value0_has_been_closed": "{value0} è stato chiuso.",
    "value0_has_been_locked": "{value0} e' stato chiuso.",
    "maximum_refundable_amount_is_value0": "Importo massimo rimborsabile è {value0} .",
    "unable_to_resolve_this_value0_booking_source": "Incapace di risolvere questa fonte di prenotazione {value0}.",
    "fiscal_year_value0_closed": "Anno fiscale {value0} chiuso",
    "employment_details_could_not_be_saved": "I dettagli dell'occupazione non potrebbero essere salvati.",
    "pay_and_rate_details_could_not_be_saved": "I dati di pagamento e di tasso non potrebbero essere salvati.",
    "payment_details_could_not_be_saved": "I dettagli di pagamento non possono essere salvati.",
    "tax_ni_readiness_could_not_be_saved": "Tassa / Prontezza NI non poteva essere salvato.",
    "pension_details_could_not_be_saved": "I dettagli della pensione non potevano essere salvati.",
    "action_failed": "L'azione è fallita.",
    "confirmed": "confermato",
    "loading_2": "carico di carico",
    "images_must_be_5_mb_or_less": "Le immagini devono essere 5 MB o meno.",
    "tennis": "Tennis",
    "padel": "Padella",
    "pickleball": "Pallacanestro",
    "squash": "Squash.",
    "closed_2": "chiuso chiuso",
    "club_member": "socio del Club",
    "staff_member_3": "Membro del personale",
    "created_2": "creato",
    "units": "unità",
    "posted_3": "contabilizzato",
    "void_2": "vuoto",
    "error": "errore",
    "queued": "in coda",
    "matched_2": "abbinato",
    "approved": "approvato",
    "complete": "completo",
    "processing_2": "elaborazione del trattamento",
    "ready_2": "pronto",
    "too_large": "troppo grande",
    "uncategorized": "Non categorizzato",
    "primary_contact_2": "Contatto primario",
    "contract": "Contratto",
    "s": "- Sì.",
    "original_2": "originale originale",
    "reset": "reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset reset",
    "unknown_time": "tempo sconosciuto",
    "voicemail": "Voce",
    "polo": "Polo",
    "facilities_2": "Servizi",
    "weddings": "Matrimoni",
    "off": "Fuori di qui",
    "apply_uk_tax_defaults": "Applicare i default fiscali del Regno Unito",
    "unknown_2": "sconosciuto sconosciuto",
    "edit_2": "Modifica",
    "view_2": "vista panoramica",
    "extension": "Estensione",
    "unable_to_save_business_hours": "Incapace di risparmiare ore di lavoro",
    "unable_to_load_hold_audio": "Incapace di caricare tenere l'audio",
    "recording_policy": "Politica di registrazione",
    "ivr": "IVR",
    "ring_all": "Anello Tutto",
    "untitled_ivr": "IVR senza titolo",
    "untitled_queue": "Coda senza titolo",
    "queue": "Che cosa?",
    "value_2": "valore",
    "answered": "rispose:",
    "name_is_required": "Il nome è richiesto",
    "booked": "prenotato",
    "removed": "rimosso",
    "unchanged": "immutato invariato",
    "unable_to_resolve_attendee_pricing": "Non è possibile risolvere i prezzi dei partecipanti.",
    "guest_name_is_required_2": "Il nome dell'ospite è richiesto.",
    "guest_email_is_required": "L'e-mail degli ospiti è richiesta.",
    "guest_phone_is_required": "Il telefono degli ospiti è richiesto.",
    "for": "Per",
    "weddings_2": "matrimoni",
    "expires": "Scade il",
    "guest_4": "ospite",
    "rooms": "camere",
    "hotel_rooms": "Hotel / Camere",
    "front_desk_checkin_kiosk": "Banco anteriore Check-in Kiosk",
    "selected_room": "camera selezionata",
    "gross_payroll_amount": "Reddito lordo: {amount}",
    "variance_vs_previous_month_amount": "Varianza vs mese precedente: {amount}",
    "department_name": "Dipartimento: {name}",
    "employee_count_count": "Conto dei dipendenti: {count}",
    "percentage_of_payroll_percent": "Percentuale di retribuzione: {percent} %",
    "imported_draft_timesheets_count": "Fogli di tempo di progetto importati: {count} .",
    "payslips_portal_publish_complete_published_published_existing_already_published_skipped": "Il portale Payslips pubblica completo: {published} pubblicato, {existing} già pubblicato, {skipped} saltato perché nessun individuo PDF è disponibile.",
    "move_this_payroll_run_back_to_stage_finance_previews_may": "Spostare questo paghe eseguire indietro a {stage} ? Le anteprime finanziarie possono essere cancellate.",
    "payroll_defaults_refreshed_jurisdiction_jurisdiction_created_created_updated_updated_preserved": "Le impostazioni predefinite di paghe sono aggiornate. Giurisdizione: {jurisdiction} . Creato: {created} ; aggiornato: {updated} ; conservato: {preserved} ; reset: {reset} . Le personalizzazione sono conservate a meno che la regola selezionata non venga ripristinata.",
    "x_days_after_period_end": "X giorni dopo la fine del periodo",
    "resolve_open_blockers_before_posting_to_accounting": "Risolvere i bloccanti aperti prima di inviare alla contabilità.",
    "vat_gl_mappings_verified": "VAT GL mappature verificate",
    "preview_only_2": "anteprima solo",
    "current_period_3": "periodo corrente"
  },
  "paymentMethods": {
    "cash": "Contanti",
    "card": "Carta di carta",
    "bank_transfer": "Bonifico bancario",
    "check": "Assegno",
    "ach": "ACHETTO",
    "wire": "Bonifico bancario",
    "other": "Altro",
    "apple_pay": "Paga della mela",
    "google_pay": "Google Pay"
  },
  "errors": {
    "invalid_amount": "Inserire un importo superiore a zero.",
    "invalid_payment_amount": "Inserire un importo di pagamento valido superiore a zero.",
    "invalid_payment_method": "Selezionare un metodo di pagamento supportato.",
    "invalid_payload": "Controllare il club selezionato e il record contabile, quindi riprovare.",
    "forbidden": "Non hai il permesso di eseguire questa azione contabile.",
    "club_not_found": "Il club selezionato non è stato trovato. Selezionare nuovamente il club.",
    "receivable_not_found": "Questo credito non è disponibile. Aggiornare la cronologia del conto prima di riprovare.",
    "usage_charge_not_invoiced": "Questa tassa non è stata ancora fatturata. Verrà pagabile una volta che l'esecuzione di fatturazione genera una fattura.",
    "allocation_exceeds_balance": "L'allocazione supera il saldo in sospeso. Rifiutare il saldo e ridurre l'allocazione.",
    "allocation_exceeds_payment": "Le allocazioni superano l'importo del pagamento. Ridurre le assegnazioni prima di continuare.",
    "allocation_exceeds_credit": "Le allocazioni superano il credito disponibile. Rifiutare il saldo di credito e ridurre le allocazioni.",
    "allocation_exceeds_outstanding": "L'allocazione supera l'importo in essere. Rifiutare il saldo e ridurre l'allocazione.",
    "request": "Richiesta: {id}",
    "invalid_club_code": "Controllare il club selezionato e il record contabile, quindi riprovare.",
    "bank_transactions_import_failed": "La dichiarazione non poteva essere importata. Verificare il file e la mappatura delle colonne prima di riprovare.",
    "bank_import_preset_fetch_failed": "Non è disponibile la preimpostazione dell'importazione in banca. Recuperare o rivedere la mappatura della colonna manualmente.",
    "bank_import_preset_save_failed": "Non è disponibile la preimpostazione dell'importazione in banca. Recuperare o rivedere la mappatura della colonna manualmente.",
    "supplier_not_found": "Selezionare un fornitore disponibile prima di continuare.",
    "invalid_supplier": "Selezionare un fornitore disponibile prima di continuare.",
    "accounting_ap_payments_fetch_failed": "I pagamenti del fornitore non potrebbero essere caricati.",
    "accounting_supplier_statement_failed": "La dichiarazione del fornitore non poteva essere generata. Rivedere le date selezionate e riprovare.",
    "accounting_ap_bills_fetch_failed": "Le bollette del fornitore non potrebbero essere caricate. Rifiutare l'elenco prima di intraprendere ulteriori azioni.",
    "accounting_ap_ageing_fetch_failed": "L'invecchiamento del fornitore non potrebbe essere caricato. Rifiutare il rapporto di invecchiamento.",
    "accounting_ap_ageing_detail_failed": "L'invecchiamento del fornitore non potrebbe essere caricato. Rifiutare il rapporto di invecchiamento.",
    "ap_bill_missing_lines": "Aggiungere almeno una linea di fattura valida prima della pubblicazione.",
    "invalid_bill_lines": "Aggiungere almeno una linea di fattura valida prima della pubblicazione.",
    "ap_bill_create_failed": "La bolletta del fornitore non poteva essere creata. Verificare i campi e controllare una bolletta esistente prima di riprovare.",
    "accounting_ap_bill_create_failed": "La bolletta del fornitore non poteva essere creata. Verificare i campi e controllare una bolletta esistente prima di riprovare.",
    "ap_bill_not_found": "Una o più fatture del fornitore selezionate non sono disponibili. Aggiorna l'elenco e selezionali di nuovo.",
    "ap_bills_not_found": "Una o più fatture del fornitore selezionate non sono disponibili. Aggiorna l'elenco e selezionali di nuovo.",
    "invalid_bill_ids": "Una o più fatture del fornitore selezionate non sono disponibili. Aggiorna l'elenco e selezionali di nuovo.",
    "ap_bill_locked": "Questa fattura del fornitore non può essere modificata nel suo stato attuale. Rivedere la sua cronologia di pubblicazione e pagamento.",
    "invalid_bill_status": "Questa fattura del fornitore non può essere modificata nel suo stato attuale. Rivedere la sua cronologia di pubblicazione e pagamento.",
    "accounting_ap_bill_fetch_failed": "La bolletta del fornitore non poteva essere caricata.",
    "ap_bill_void_failed": "La bolletta del fornitore non poteva essere annullata. Verificare le sue allocazioni e lo stato di pubblicazione.",
    "ap_payment_create_failed": "Il pagamento del fornitore non poteva essere registrato. Controllare i pagamenti esistenti prima di riprovare.",
    "no_outstanding_balance": "Non c'è equilibrio eccezionale da risolvere. Rifiutare i record selezionati.",
    "invalid_allocation": "Verificare gli obiettivi e gli importi di allocazione selezionati prima di continuare.",
    "invalid_allocation_target": "Verificare gli obiettivi e gli importi di allocazione selezionati prima di continuare.",
    "ap_payment_not_found": "Questo pagamento non è disponibile. Aggiorna la cronologia dei pagamenti.",
    "payment_not_found": "Questo pagamento non è disponibile. Aggiorna la cronologia dei pagamenti.",
    "ap_refund_create_failed": "Il rimborso non può essere registrato. Controllare la cronologia dei pagamenti prima di riprovare.",
    "refund_payment_create_failed": "Il rimborso non può essere registrato. Controllare la cronologia dei pagamenti prima di riprovare.",
    "accounting_settings_fetch_failed": "Verificare le impostazioni contabili e i conti di controllo, entrate e pagamenti selezionati.",
    "invalid_accounting_settings_value": "Verificare le impostazioni contabili e i conti di controllo, entrate e pagamenti selezionati.",
    "invalid_accounting_settings_accounts": "Verificare le impostazioni contabili e i conti di controllo, entrate e pagamenti selezionati.",
    "invalid_fiscal_year_start_month": "Selezionare un mese fiscale-anno a partire da 1 a 12.",
    "tax_profile_fetch_failed": "La configurazione fiscale non poteva essere caricata o salvata. Rivedere le impostazioni fiscali del club e riprovare.",
    "tax_profile_update_failed": "La configurazione fiscale non poteva essere caricata o salvata. Rivedere le impostazioni fiscali del club e riprovare.",
    "tax_defaults_apply_failed": "La configurazione fiscale non poteva essere caricata o salvata. Rivedere le impostazioni fiscali del club e riprovare.",
    "tax_codes_fetch_failed": "L'operazione di codice fiscale non poteva essere completata. Verificare il codice fiscale e i suoi riferimenti prima di riprovare.",
    "tax_codes_create_failed": "L'operazione di codice fiscale non poteva essere completata. Verificare il codice fiscale e i suoi riferimenti prima di riprovare.",
    "tax_codes_update_failed": "L'operazione di codice fiscale non poteva essere completata. Verificare il codice fiscale e i suoi riferimenti prima di riprovare.",
    "tax_codes_delete_failed": "L'operazione di codice fiscale non poteva essere completata. Verificare il codice fiscale e i suoi riferimenti prima di riprovare.",
    "invalid_tax_rate": "Immettere un tasso di imposta valido senza modificare il trattamento fiscale previsto.",
    "invalid_effective_dates": "La data di fine effettiva non deve precedere la data di inizio effettiva.",
    "invalid_category": "Selezionare una categoria di imposta disponibile.",
    "tax_code_exists": "Questo codice fiscale esiste già. Scegli un codice unico.",
    "tax_code_not_found": "Questo codice fiscale non è disponibile. Rifiutare l'elenco dei codici fiscali.",
    "invoice_layout_fetch_failed": "Il layout della fattura non poteva essere caricato o salvato. Rivedere le sue impostazioni e riprovare.",
    "invoice_layout_save_failed": "Il layout della fattura non poteva essere caricato o salvato. Rivedere le sue impostazioni e riprovare.",
    "invalid_billing_email": "Inserisci un indirizzo e-mail di fatturazione valido o lascialo vuoto.",
    "invalid_accent_hex_color": "Inserire un colore di accento HEX valido.",
    "member_not_found": "L'account socio o socio non è disponibile. Aggiorna la selezione dei soci.",
    "member_account_not_found": "L'account socio o socio non è disponibile. Aggiorna la selezione dei soci.",
    "member_membership_type_missing": "Impostare un tipo di appartenenza per questo socio prima di iscriverli.",
    "membership_type_frequency_ambiguous": "Scegliere una frequenza di fatturazione esplicita durante l'iscrizione.",
    "membership_type_dues_required": "Inserire una quantità di due superiore a zero, o configurare i due di tipo di adesione.",
    "membership_type_frequency_required": "Selezionare una frequenza mensile, trimestrale o annuale prima di attivare la fatturazione ricorrente.",
    "membership_type_quarterly_dues_unsupported": "Immettere un importo trimestrale esplicito o utilizzare un termine mensile o annuale.",
    "missing_vat_gl_account": "Configurare l'account di output VAT GL per i codici fiscali interessati prima di inviare.",
    "journal_entry_create_failed": "Il diario non poteva essere creato. Controllare la storia di posting e mappature prima di riprovare.",
    "missing_recipient_email": "Impostare un indirizzo e-mail del destinatario prima di inviare la fattura.",
    "missing_resend_api_key": "La consegna via e-mail non è configurata. La fattura rimane disponibile; contattare un amministratore.",
    "statement_total_zero": "Non ci sono importi eccezionali fatturabili per questa affermazione. Rivedere il periodo selezionato.",
    "invoice_create_failed": "La fattura non potrebbe essere generata. Controllare l'elenco delle fatture prima di riprovare per evitare duplicazioni.",
    "generate_invoice_failed": "La fattura non potrebbe essere generata. Controllare l'elenco delle fatture prima di riprovare per evitare duplicazioni.",
    "recurring_billing_settings_fetch_failed": "Le impostazioni di fatturazione ricorrenti non potrebbero essere caricate o salvate. Rivedere le impostazioni e riprovare.",
    "recurring_billing_settings_update_failed": "Le impostazioni di fatturazione ricorrenti non potrebbero essere caricate o salvate. Rivedere le impostazioni e riprovare.",
    "recurring_billing_runs_fetch_failed": "L'esecuzione di fatturazione non poteva essere caricata. Rifiutare l'elenco di esecuzione o i dettagli.",
    "recurring_billing_run_detail_failed": "L'esecuzione di fatturazione non poteva essere caricata. Rifiutare l'elenco di esecuzione o i dettagli.",
    "run_not_found": "Questa corsa non è disponibile. Aggiorna la lista di esecuzione.",
    "payroll_run_not_found": "Questa corsa non è disponibile. Aggiorna la lista di esecuzione.",
    "invalid_payment_date": "Inserisci una data di pagamento valida.",
    "record_run_payments_failed": "I pagamenti di esecuzione non possono essere registrati. Verificare la cronologia dei pagamenti prima di riprovare.",
    "recurring_billing_templates_fetch_failed": "Le iscrizioni di fatturazione non potrebbero essere caricate o aggiornate. Aggiornare la selezione e riprovare solo gli elementi falliti.",
    "recurring_billing_enrollments_fetch_failed": "Le iscrizioni di fatturazione non potrebbero essere caricate o aggiornate. Aggiornare la selezione e riprovare solo gli elementi falliti.",
    "recurring_billing_enrollments_bulk_failed": "Le iscrizioni di fatturazione non potrebbero essere caricate o aggiornate. Aggiornare la selezione e riprovare solo gli elementi falliti.",
    "invalid_period": "Selezionare un periodo di fatturazione valido.",
    "invalid_billing_period": "Selezionare un periodo di fatturazione valido.",
    "recurring_billing_member_detail_fetch_failed": "L'anteprima di fatturazione socio non poteva essere caricato. Rifiutare la dichiarazione selezionata.",
    "recurring_billing_invoice_preview_failed": "L'anteprima di fatturazione socio non poteva essere caricato. Rifiutare la dichiarazione selezionata.",
    "recurring_billing_current_run_preview_failed": "L'anteprima di fatturazione socio non poteva essere caricato. Rifiutare la dichiarazione selezionata.",
    "generate_and_send_invoice_failed": "La generazione di fattura o la consegna non sono riusciti. Controlla la fatturazione e lo stato di consegna prima di riprovare.",
    "generate_club_run_failed": "Il giro di fatturazione del club non poteva finire. Verificare le fatture generate e i guasti per-socio prima di riprovare.",
    "recurring_billing_run_due_failed": "Il giro di fatturazione del club non poteva finire. Verificare le fatture generate e i guasti per-socio prima di riprovare.",
    "charge_cannot_change_billing_run": "Questa carica non può passare a un'altra corsa di fatturazione nel suo stato attuale.",
    "charge_not_found": "Questa tassa non è disponibile. Rifiuta la dichiarazione.",
    "charge_billing_run_update_failed": "Il posizionamento di fatturazione di questa carica non potrebbe essere aggiornato. Rifiutare la dichiarazione prima di riprovare.",
    "charge_exclude_failed": "Il posizionamento di fatturazione di questa carica non potrebbe essere aggiornato. Rifiutare la dichiarazione prima di riprovare.",
    "charge_defer_failed": "Il posizionamento di fatturazione di questa carica non potrebbe essere aggiornato. Rifiutare la dichiarazione prima di riprovare.",
    "charge_include_failed": "Il posizionamento di fatturazione di questa carica non potrebbe essere aggiornato. Rifiutare la dichiarazione prima di riprovare.",
    "confirmation_required": "Completare la conferma richiesta prima di continuare.",
    "recurring_template_validation_failed": "Rivedere il modello ricorrente, la quantità di due positivi, lo stato attivo e la frequenza di fatturazione.",
    "template_not_found": "Rivedere il modello ricorrente, la quantità di due positivi, lo stato attivo e la frequenza di fatturazione.",
    "template_not_active": "Rivedere il modello ricorrente, la quantità di due positivi, lo stato attivo e la frequenza di fatturazione.",
    "accounting_invoices_fetch_failed": "La fattura non poteva essere caricata o scaricata. Rifiutare l'elenco delle fatture e riprovare.",
    "accounting_invoice_fetch_failed": "La fattura non poteva essere caricata o scaricata. Rifiutare l'elenco delle fatture e riprovare.",
    "invoice_download_failed": "La fattura non poteva essere caricata o scaricata. Rifiutare l'elenco delle fatture e riprovare.",
    "invoice_not_found": "Questa fattura non è disponibile. Aggiorna l'elenco delle fatture.",
    "invoice_not_editable": "Questa fattura non può essere modificata nel suo stato attuale. Utilizzare il flusso di lavoro di note di credito o inversione esistente, se del caso.",
    "invalid_invoice_status": "Questa fattura non può essere modificata nel suo stato attuale. Utilizzare il flusso di lavoro di note di credito o inversione esistente, se del caso.",
    "missing_invoice_currency": "La fattura non ha valuta. Verificare la sua configurazione di origine prima di inviare.",
    "invoice_missing_lines": "Aggiungi linee di fattura valide prima della pubblicazione.",
    "missing_accounting_settings": "Completare i conti di controllo contabile richiesti e le mappe di reddito/paghe prima di inviare.",
    "missing_mappings": "Completare i conti di controllo contabile richiesti e le mappe di reddito/paghe prima di inviare.",
    "missing_tax_code_on_taxable_line": "Selezionare un codice fiscale efficace per ogni linea tassabile prima di inviare.",
    "invoice_amount_mismatch": "I totali delle fatture non corrispondono alle linee di origine. Rifiutare e rivedere le linee prima della pubblicazione.",
    "journal_not_balanced": "Debiti e crediti non si bilanciano. Verificare le linee di giornale e mappature prima di inviare.",
    "payroll_finance_preview_not_balanced": "Debiti e crediti non si bilanciano. Verificare le linee di giornale e mappature prima di inviare.",
    "refund_exceeds_allocated_amount": "Il rimborso supera l'importo rimborsabile. Rifiutare il pagamento e rivedere le sue allocazioni prima di ridurre il rimborso.",
    "refund_exceeds_total_refundable": "Il rimborso supera l'importo rimborsabile. Rifiutare il pagamento e rivedere le sue allocazioni prima di ridurre il rimborso.",
    "refund_exceeds_invoice_amount": "Il rimborso supera l'importo rimborsabile. Rifiutare il pagamento e rivedere le sue allocazioni prima di ridurre il rimborso.",
    "refund_exceeds_unapplied_amount": "Il rimborso supera l'importo rimborsabile. Rifiutare il pagamento e rivedere le sue allocazioni prima di ridurre il rimborso.",
    "invalid_bank_account": "Selezionare un conto bancario disponibile con la mappatura GL richiesta.",
    "payment_create_failed": "Il pagamento non poteva essere registrato. Verificare i pagamenti esistenti prima di riprovare.",
    "accounting_member_summary_failed": "I crediti non possono essere caricati. Aggiorna la lista dei crediti prima di continuare.",
    "receivables_summary_fetch_failed": "I crediti non possono essere caricati. Aggiorna la lista dei crediti prima di continuare.",
    "receivables_fetch_failed": "I crediti non possono essere caricati. Aggiorna la lista dei crediti prima di continuare.",
    "receivable_fetch_failed": "I crediti non possono essere caricati. Aggiorna la lista dei crediti prima di continuare.",
    "member_ar_backfill_failed": "Non è stato possibile caricare il conto socio. Aggiorna il conto e controlla la cronologia prima di continuare.",
    "member_ar_accounts_fetch_failed": "Non è stato possibile caricare il conto socio. Aggiorna il conto e controlla la cronologia prima di continuare.",
    "member_ar_summary_fetch_failed": "Non è stato possibile caricare il conto socio. Aggiorna il conto e controlla la cronologia prima di continuare.",
    "member_ar_account_resolve_failed": "Non è stato possibile caricare il conto socio. Aggiorna il conto e controlla la cronologia prima di continuare.",
    "member_ar_transactions_fetch_failed": "Non è stato possibile caricare il conto socio. Aggiorna il conto e controlla la cronologia prima di continuare.",
    "member_ar_open_invoices_fetch_failed": "Non è stato possibile caricare il conto socio. Aggiorna il conto e controlla la cronologia prima di continuare.",
    "source_not_found": "La transazione originaria non è disponibile. Verificare il riferimento sorgente o contattare un amministratore.",
    "source_resolve_failed": "La transazione originaria non è disponibile. Verificare il riferimento sorgente o contattare un amministratore.",
    "member_statement_fetch_failed": "L'estratto socio non può essere caricato o generato. Verifica l'intervallo di date e riprova.",
    "member_statement_generate_failed": "L'estratto socio non può essere caricato o generato. Verifica l'intervallo di date e riprova.",
    "invoice_not_allocatable": "La fattura o il credito selezionato non possono ricevere questa allocazione. Rifiutare il suo saldo e lo stato eccezionale.",
    "receivable_not_allocatable": "La fattura o il credito selezionato non possono ricevere questa allocazione. Rifiutare il suo saldo e lo stato eccezionale.",
    "invalid_invoice_ids": "La fattura o il credito selezionato non possono ricevere questa allocazione. Rifiutare il suo saldo e lo stato eccezionale.",
    "invoice_not_open": "La fattura o il credito selezionato non possono ricevere questa allocazione. Rifiutare il suo saldo e lo stato eccezionale.",
    "invalid_parent_payment": "Selezionare il pagamento originale eleggibile per questo rimborso.",
    "invoice_required": "Selezionare la fattura applicabile prima di creare la nota di credito.",
    "credit_note_requires_invoice": "Selezionare la fattura applicabile prima di creare la nota di credito.",
    "credit_note_exceeds_invoice_amount": "Il credito supera l'importo disponibile. Risparmiare la fattura o il saldo di credito e ridurre l'importo.",
    "credit_exceeds_available": "Il credito supera l'importo disponibile. Risparmiare la fattura o il saldo di credito e ridurre l'importo.",
    "credit_note_missing_lines": "Aggiungere almeno una linea valida di note di credito.",
    "credit_note_create_failed": "L'operazione della nota di credito è fallita. Rifiutare l'elenco delle note di credito e rivedere la fattura prima di riprovare.",
    "credit_notes_fetch_failed": "L'operazione della nota di credito è fallita. Rifiutare l'elenco delle note di credito e rivedere la fattura prima di riprovare.",
    "credit_note_fetch_failed": "L'operazione della nota di credito è fallita. Rifiutare l'elenco delle note di credito e rivedere la fattura prima di riprovare.",
    "credit_note_not_found": "La nota di credito selezionata o il credito non è disponibile. Aggiorna l'account.",
    "credit_not_found": "La nota di credito selezionata o il credito non è disponibile. Aggiorna l'account.",
    "invalid_credit_note_status": "Questa nota di credito non può essere utilizzata nel suo stato attuale. Rivedere la sua storia di post e applicazione.",
    "credit_note_void_not_allowed": "Questa nota di credito non può essere utilizzata nel suo stato attuale. Rivedere la sua storia di post e applicazione.",
    "credit_note_not_posted": "Questa nota di credito non può essere utilizzata nel suo stato attuale. Rivedere la sua storia di post e applicazione.",
    "credit_note_void_failed": "La nota di credito non poteva essere annullata. Verificare le sue applicazioni prima di riprovare.",
    "credit_application_create_failed": "L'applicazione di credito non può essere modificata come richiesto. Rifiutare il suo stato attuale prima di riprovare.",
    "credit_application_not_found": "L'applicazione di credito non può essere modificata come richiesto. Rifiutare il suo stato attuale prima di riprovare.",
    "credit_application_already_void": "L'applicazione di credito non può essere modificata come richiesto. Rifiutare il suo stato attuale prima di riprovare.",
    "credit_application_not_applied": "L'applicazione di credito non può essere modificata come richiesto. Rifiutare il suo stato attuale prima di riprovare.",
    "period_locked": "Questa data di pubblicazione rientra in un periodo chiuso o chiuso. Modificare la data o richiedere uno sblocco autorizzato.",
    "gl_period_locked": "Questa data di pubblicazione rientra in un periodo chiuso o chiuso. Modificare la data o richiedere uno sblocco autorizzato.",
    "locked_period": "Questa data di pubblicazione rientra in un periodo chiuso o chiuso. Modificare la data o richiedere uno sblocco autorizzato.",
    "period_closed": "Questa data di pubblicazione rientra in un periodo chiuso o chiuso. Modificare la data o richiedere uno sblocco autorizzato.",
    "payroll_request_failed": "La richiesta paghe non è riuscita. Aggiornare la corsa e rivedere il suo stato prima di riprovare.",
    "invalid_id": "Il record di paghe selezionato non è disponibile. Aggiorna la selezione.",
    "not_found": "Il record di paghe selezionato non è disponibile. Aggiorna la selezione.",
    "profile_not_found": "Il record di paghe selezionato non è disponibile. Aggiorna la selezione.",
    "department_not_found": "Il record di paghe selezionato non è disponibile. Aggiorna la selezione.",
    "name_required": "Inserire un nome prima di salvare.",
    "unsupported_payment_jurisdiction": "I dati di pagamento non sono supportati per la giurisdizione configurata. Rivedere le impostazioni del libro paga.",
    "replacement_reason_required": "Inserisci un motivo prima di sostituire i dettagli di pagamento.",
    "invalid_rate_type": "Scegliere un tipo o uno stato di tasso supportato prima di salvare.",
    "invalid_status": "Scegliere un tipo o uno stato di tasso supportato prima di salvare.",
    "invalid_verification_status": "Scegliere un tipo o uno stato di tasso supportato prima di salvare.",
    "payment_details_not_found": "Salvare i dati di pagamento prima di verificarli.",
    "timesheet_locked": "Questo foglio temporale è bloccato. Utilizzare il flusso di lavoro riaperto autorizzato prima della modifica.",
    "timesheet_lines_required": "Aggiungi linee di fogli di tempo valide o la spiegazione di zero ore richiesta.",
    "zero_hours_note_required": "Aggiungi linee di fogli di tempo valide o la spiegazione di zero ore richiesta.",
    "run_not_recalculable": "Questo paghe run non può essere modificato nel suo stato attuale. Rivedere il rollback autorizzato o riaprire le azioni.",
    "run_not_mutable": "Questo paghe run non può essere modificato nel suo stato attuale. Rivedere il rollback autorizzato o riaprire le azioni.",
    "payroll_not_editable": "Questo paghe run non può essere modificato nel suo stato attuale. Rivedere il rollback autorizzato o riaprire le azioni.",
    "payroll_locked": "Questo paghe run non può essere modificato nel suo stato attuale. Rivedere il rollback autorizzato o riaprire le azioni.",
    "payroll_period_id_required": "Selezionare un periodo di paghe aperto disponibile.",
    "period_not_found": "Selezionare un periodo di paghe aperto disponibile.",
    "period_not_open": "Selezionare un periodo di paghe aperto disponibile.",
    "duplicate_active_run": "Esiste già un funzionamento attivo per questo periodo. Aprire il run esistente invece di creare un duplicato.",
    "blocker_not_found": "Questo blocco o decisione non è più disponibile. Rifiutare la recensione paghe.",
    "decision_not_allowed": "Questo blocco o decisione non è più disponibile. Rifiutare la recensione paghe.",
    "provider_deductions_not_required": "Le deduzioni del fornitore non sono richieste in questa modalità paghe. Rivedere la fonte legale configurata.",
    "no_payroll_run_lines": "Rifiutare le linee dei dipendenti calcolate prima di salvare gli input legali.",
    "duplicate_payroll_run_line_id": "Rifiutare le linee dei dipendenti calcolate prima di salvare gli input legali.",
    "unknown_payroll_run_line_id": "Rifiutare le linee dei dipendenti calcolate prima di salvare gli input legali.",
    "legacy_run_level_statutory_totals": "I totali di legge del ciclo non sono cedolini dei dipendenti. Inserisci i valori per ciascun dipendente prima di generare i cedolini definitivi.",
    "statutory_inputs_stale": "Il libro paga è stato ricalcolato dopo che i valori legali sono stati salvati. Revisione e rientro degli ingressi legali dei dipendenti.",
    "payroll_run_not_review_stage": "Spostare il libro paga correre alla sua fase di revisione prima di entrare in valori legali.",
    "payroll_blockers_unresolved": "Risolvere i bloccanti del libro paga prima di passare alla fase successiva.",
    "run_has_blockers": "Risolvere i bloccanti del libro paga prima di passare alla fase successiva.",
    "employee_statutory_rows_missing": "PAYE completo, dipendente NI e datore di lavoro NI per ogni dipendente incluso prima di continuare.",
    "employee_statutory_row_missing": "PAYE completo, dipendente NI e datore di lavoro NI per ogni dipendente incluso prima di continuare.",
    "payroll_line_incomplete": "PAYE completo, dipendente NI e datore di lavoro NI per ogni dipendente incluso prima di continuare.",
    "employee_statutory_row_incomplete": "PAYE completo, dipendente NI e datore di lavoro NI per ogni dipendente incluso prima di continuare.",
    "payroll_line_final_values_missing": "PAYE completo, dipendente NI e datore di lavoro NI per ogni dipendente incluso prima di continuare.",
    "payslip_totals_do_not_reconcile": "I totali payslip non si conciliano con i paghe. Verificare i valori legali del dipendente e eseguire i totali.",
    "invalid_status_transition": "Questo cambio di fase paghe non è consentito. Rifiutare la corsa e utilizzare la sua azione successiva disponibile.",
    "finance_posting_required": "Inviare la rivista paghe alla contabilità prima di registrare il pagamento.",
    "gl_post_required": "Inviare la rivista paghe alla contabilità prima di registrare il pagamento.",
    "payroll_not_ready_to_lock": "Completa finanza posting, payables e il pagamento del personale prima di blocco paghe.",
    "provider_deductions_required": "Immettere i valori di legge forniti dal fornitore richiesto prima di continuare.",
    "payroll_already_posted": "paghe è già pubblicato. Verificare la rivista esistente e utilizzare le azioni inversali autorizzate dove disponibile.",
    "tenant_schema_out_of_date": "Il database del club non è pronto per questa operazione paghe. Contattare il supporto con la richiesta di riferimento.",
    "payslip_snapshot_locked": "Le istantanee payslip sono bloccate e non possono essere rigenerate silenziosamente.",
    "final_payslips_pdf_not_ready": "Genera i PDF finali individuali validi prima di pubblicare il portale del personale.",
    "invalid_calculation_mode": "Verificare la modalità di calcolo paghe, la frequenza e le date del calendario prima di salvare.",
    "invalid_payroll_frequency": "Verificare la modalità di calcolo paghe, la frequenza e le date del calendario prima di salvare.",
    "invalid_default_payment_day": "Verificare la modalità di calcolo paghe, la frequenza e le date del calendario prima di salvare.",
    "invalid_approval_deadline_days": "Verificare la modalità di calcolo paghe, la frequenza e le date del calendario prima di salvare.",
    "invalid_next_run_date": "Verificare la modalità di calcolo paghe, la frequenza e le date del calendario prima di salvare.",
    "accounting_reports_fetch_failed": "L'operazione di report non potrebbe essere completata. Rifiutare i report salvati e rivedere la configurazione.",
    "accounting_reports_create_failed": "L'operazione di report non potrebbe essere completata. Rifiutare i report salvati e rivedere la configurazione.",
    "accounting_reports_update_failed": "L'operazione di report non potrebbe essere completata. Rifiutare i report salvati e rivedere la configurazione.",
    "accounting_reports_delete_failed": "L'operazione di report non potrebbe essere completata. Rifiutare i report salvati e rivedere la configurazione.",
    "missing_budget_version": "Selezionare un budget e una versione disponibili prima di eseguire questo report.",
    "missing_budget_params": "Selezionare un budget e una versione disponibili prima di eseguire questo report.",
    "budget_not_found": "Selezionare un budget e una versione disponibili prima di eseguire questo report.",
    "report_not_found": "Questo rapporto non è disponibile o il suo tipo non è supportato. Selezionare un rapporto supportato.",
    "report_type_not_supported": "Questo rapporto non è disponibile o il suo tipo non è supportato. Selezionare un rapporto supportato.",
    "invalid_date_range": "Inserisci una data di inizio e di fine valida nell'ordine corretto.",
    "accounting_gl_month_end_tasks_fetch_failed": "La checklist di fine mese non poteva essere caricata. Rifiutare il periodo prima di continuare.",
    "invalid_entry_class": "Selezionare una classe di ingresso di giornale supportata per questa eccezione.",
    "member_receivables_balance_unresolved": "Il saldo di credito del socio non può essere risolto. Rifiutare l'account socio prima di assegnare un pagamento.",
    "payroll_payment_encryption_config_invalid": "Non è possibile elaborare in modo sicuro le coordinate bancarie per le paghe. Chiedi a un amministratore di verificare la configurazione della crittografia delle paghe prima di riprovare.",
    "payroll_payment_kms_client_unavailable": "Non è possibile elaborare in modo sicuro le coordinate bancarie per le paghe. Chiedi a un amministratore di verificare la configurazione della crittografia delle paghe prima di riprovare.",
    "payroll_payment_kms_key_not_configured": "Non è possibile elaborare in modo sicuro le coordinate bancarie per le paghe. Chiedi a un amministratore di verificare la configurazione della crittografia delle paghe prima di riprovare.",
    "payroll_payment_kms_data_key_failed": "Non è possibile elaborare in modo sicuro le coordinate bancarie per le paghe. Chiedi a un amministratore di verificare la configurazione della crittografia delle paghe prima di riprovare.",
    "payroll_payment_kms_decrypt_failed": "Non è possibile elaborare in modo sicuro le coordinate bancarie per le paghe. Chiedi a un amministratore di verificare la configurazione della crittografia delle paghe prima di riprovare.",
    "account_holder_name_required": "Inserisci il nome del titolare del conto bancario.",
    "invalid_sort_code": "Inserire un codice di selezione valido di sei cifre Regno Unito.",
    "invalid_account_number": "Inserisci un numero di conto bancario valido per lo schema di pagamento selezionato.",
    "invalid_routing_number": "Inserisci un numero di routing valido di nove cifre.",
    "account_number_required": "Inserisci il numero di conto corrente.",
    "invalid_account_type": "Scegli un tipo di conto bancario supportato.",
    "invalid_iban": "Inserire una valida IBAN .",
    "unsupported_payment_scheme": "Questo schema di pagamento non è supportato per la giurisdizione configurata del club. Recensione Impostazioni paghe.",
    "payment_file_decryption_not_wired_until_approved_run_generation": "La decrittografia del file bancario è disponibile solo durante la generazione di paghe-run approvata. Approva l'esecuzione prima di generare il file.",
    "invalid_billable_recurring_receivables_args": "Selezionare un club valido, socio e periodo di fatturazione, quindi ricaricare la dichiarazione.",
    "invalid_current_statement_args": "Selezionare un club valido, socio e periodo di fatturazione, quindi ricaricare la dichiarazione.",
    "tax_code_required": "Selezionare un codice fiscale per ogni linea tassabile prima di inviare.",
    "invalid_tax_code": "Un codice fiscale selezionato non è valido o non è disponibile per la data di pubblicazione. Rivedere le linee interessate e la configurazione di codice fiscale.",
    "unsupported_revenue_source": "Questa fonte di reddito non supporta la pubblicazione richiesta. Aprire la sua transazione di origine e rivedere il flusso di lavoro supportato.",
    "posting_source_not_found": "La transazione di origine per questo post non è stata trovata. Rifiutare il record di origine prima di riprovare.",
    "original_batch_not_found": "Il lotto di pubblicazione originale non è stato trovato. Verificare il diario di origine prima di richiedere un inversione."
  },
  "documents": {
    "invoice": "Fattura",
    "date": "Data {date}",
    "due": "A causa di {date}",
    "billedTo": "Fatturato a",
    "member": "Socio",
    "club": "Club Club",
    "description": "Descrizione",
    "quantity": "Q",
    "unit": "Unità",
    "total": "Totale",
    "charge": "Carico",
    "subtotal": "Subtotale",
    "tax": "Imposta",
    "amountDue": "Importo dovuto",
    "thankYou": "Grazie per i vostri affari!",
    "greeting": "Ciao {name},",
    "attached": "La vostra ultima fattura da {club} è allegata.",
    "ready": "La fattura di fatturazione ricorrente {number} è pronta.",
    "amount": "Importo: {amount}",
    "dueDate": "Data di scadenza: {date}",
    "contact": "Se hai domande, contatta {club} a {contact} .",
    "thanks": "Grazie.",
    "subject": "Fatturato da {club} – {number}",
    "subjectWithoutNumber": "La tua fattura da {club}",
    "unavailable": "Non disponibile",
    "draft": "BOZZA",
    "payslipPayslip": "Pagamenti",
    "payslipEmployee": "Dipendenti",
    "payslipReference": "Riferimento",
    "payslipJobtitle": "Titolo del lavoro",
    "payslipDepartment": "Dipartimento",
    "payslipPayrollrun": "Ciclo paghe",
    "payslipPayrollsourcereference": "paghe fonte/riferimento",
    "payslipPayment": "Pagamento",
    "payslipEarnings": "Guadagni",
    "payslipBasepaysalary": "Base pay / salario",
    "payslipOvertimepay": "Rimborso straordinario",
    "payslipHolidaypay": "Pagamenti di vacanza",
    "payslipSickpay": "Paga infernale",
    "payslipGrosspay": "Paga lorda",
    "payslipDeductions": "Deduzioni",
    "payslipPAYEIncomeTax": "PAYE Imposta sul reddito",
    "payslipEmployeeNationalInsurance": "Assicurazione nazionale dei lavoratori",
    "payslipEmployeePension": "Pensione dei dipendenti",
    "payslipOtherEmployeeDeductions": "Altre deduzioni dei dipendenti",
    "payslipTotalDeductions": "Deduzioni totali",
    "payslipNetpay": "Pagamenti netti",
    "payslipEmployercontributions": "Contributo dei datori di lavoro",
    "payslipEmployerNationalInsurance": "Assicurazione nazionale dei datori di lavoro",
    "payslipEmployerPension": "Pensione dei datori di lavoro",
    "payslipOtherEmployerCosts": "Altri costi del datore di lavoro",
    "payslipTotalEmployerContributions": "Totale dei contributi dei datori di lavoro",
    "payslipThisisyourpayslipfortheperiodshownabove": "Questo è il tuo payslip per il periodo indicato sopra.",
    "payslipPeriod": "Periodo di paga {start} a {end}",
    "payslipPayDate": "Data di pagamento {date}",
    "payslipBank": "Bonifico bancario fino a {last4}",
    "payslipTitle": "Cedolino {run}"
  },
  "lifecycle": {
    "included": "Incluso nel {run}",
    "paidVia": "Pagato tramite {source}",
    "billingRun": "Correre di fatturazione: {run}",
    "settledBy": "Stabilito da {source}"
  },
  "debtorTypes": {
    "member": "Socio",
    "guest": "Ospite",
    "ad_hoc": "Ad-hoc",
    "supplier": "Fornitore",
    "company": "Società"
  },
  "confirmations": {
    "yearEnd": "Ciò chiude l'anno fiscale e non può essere duplicato. Tipo {confirmation} da confermare."
  },
  "batch": {
    "memberResult": "I soci {member} : voci saltate: {skipped} ; voci mappate: {mapped} .",
    "failure": "socio {member}: {reason}",
    "recovery": "La revisione ha generato fatture e ogni fallimento del socio prima di riprovare."
  },
  "csv": {
    "column": "Colonna {number}",
    "parse": "I CSV non potevano essere analizzati. Controllare le quotazioni e i conteggi delle colonne.",
    "quotes": "Il CSV contiene citazioni non valide. Controllare la riga {row} .",
    "delimiter": "Il delimitatore CSV non poteva essere rilevato.",
    "fields": "Il conteggio del campo non corrisponde alle colonne nella riga {row} .",
    "read": "Il file CSV non poteva essere letto. Selezionare un file valido.",
    "date": "Voce {row}: valore della data non valida.",
    "description": "Voce {row}: descrizione mancante.",
    "amount": "Voce {row}: importo non valido."
  },
  "enums": {
    "accountType": {
      "asset": "Benefici",
      "liability": "Affidabilità",
      "equity": "Equità",
      "revenue": "Ricavi",
      "expense": "Spesa"
    },
    "period": {
      "open": "Apri",
      "closed": "Chiuso",
      "locked": "Bloccato",
      "ready": "Pronto",
      "blocked": "Bloccato",
      "pass": "Passato",
      "fail": "Non riuscito",
      "warning": "Avvertenza",
      "not_applicable": "Non applicabile"
    },
    "payment": {
      "received": "Ricevuto.",
      "paid": "Pagato",
      "pending": "In attesa",
      "failed": "Non riuscito",
      "completed": "Completato",
      "refunded": "Rimborsato",
      "partially_refunded": "Rimborso parziale",
      "void": "Annullato",
      "voided": "Voi stessi",
      "allocated": "Allocato",
      "unapplied": "Non applichi",
      "partially_applied": "Particolare applicazione",
      "fully_applied": "Completamente applicato"
    },
    "source": {
      "membership_dues": "Obbligo di iscrizione",
      "membership": "Iscrizione",
      "pos": "Ristorazione e bar",
      "dining": "Ristorazione e bar",
      "bar": "Ristorazione e bar",
      "events": "Eventi",
      "golf": "Golf",
      "spa": "Centro benessere",
      "fitness": "Fitness",
      "polo": "Polo",
      "marina": "Marina di Marina",
      "racquet": "Racchetta",
      "hotel": "Hotel",
      "rooms": "Hotel / Camere",
      "lessons": "Lezioni",
      "pro_shop": "Vendita al dettaglio / Pro Shop",
      "retail": "Vendita al dettaglio / Pro Shop",
      "weddings": "Matrimoni",
      "member_account": "Conto socio",
      "invoice": "Fattura",
      "charge": "Carico",
      "ad_hoc": "Ad-hoc",
      "supplier": "Fornitore",
      "member": "Socio",
      "guest": "Ospite",
      "payroll": "Pagamenti"
    },
    "frequency": {
      "weekly": "Settimanale",
      "fortnightly": "Pernottamento",
      "monthly": "Mensile",
      "quarterly": "Trimestrale",
      "annual": "Annuale",
      "annually": "Annualmente",
      "yearly": "Anno"
    },
    "payroll": {
      "draft": "Bozza",
      "review": "Recensione",
      "calculated": "Calcolato",
      "awaiting_approval": "Approvazione in attesa",
      "approved": "Approvazione",
      "posted": "Contabilizzato",
      "paid": "Pagato",
      "locked": "Bloccato",
      "ready": "Pronto",
      "active": "Attivo",
      "inactive": "Inattivo",
      "missing_details": "Dati mancanti",
      "on_hold": "In attesa",
      "leaver": "Lasciare",
      "verified": "Verificato",
      "unverified": "Non verificato",
      "pending": "In attesa",
      "missing": "Mancato",
      "not_ready": "Non pronto.",
      "preview_ready": "Anteprima pronto",
      "not_required": "Non richiesto",
      "enrolled": "Iscritti",
      "opted_out": "Optato fuori",
      "salary": "Salari",
      "hourly": "Ore",
      "casual": "Casuale",
      "contractor": "Contraente",
      "hybrid": "Salario + regolazioni",
      "submitted": "Inviato",
      "rejected": "Rifiuti",
      "regular": "Regolare",
      "overtime": "Straordinari",
      "holiday": "Vacanza",
      "sick": "Si'.",
      "training": "Formazione",
      "adjustment": "Regolazione",
      "checking": "Controllo",
      "savings": "Risparmio",
      "fixed_day_of_month": "Giorno fisso del mese",
      "last_day_of_month": "Ultimo giorno di mese",
      "last_working_day_of_month": "Ultimo giorno lavorativo del mese",
      "days_after_period_end": "Giorni dopo la fine del periodo"
    },
    "billing": {
      "not_enrolled": "Non iscritti",
      "enrolled": "Iscritti",
      "active": "Attivo",
      "paused": "In pausa",
      "unbilled": "Incandescente",
      "invoiced": "Fatturato",
      "draft": "Bozza",
      "pending": "In attesa",
      "issued": "Fascicolo",
      "posted": "Contabilizzato",
      "open": "Apri",
      "paid": "Pagato",
      "part_paid": "Parte pagata",
      "partially_paid": "Parzialmente pagato",
      "overdue": "Scaduto",
      "sent": "Inviato",
      "failed": "Non riuscito",
      "skipped": "Ignorato",
      "scheduled": "Programmato",
      "excluded": "Escluso",
      "deferred": "Deferito",
      "generated": "Generazione",
      "included_current": "Incluso nella corrente fatturazione",
      "included_future": "Incluso in futuro la corsa di fatturazione",
      "latest_dues_invoice_paid": "Ultimi debiti fattura pagato",
      "latest_dues_invoice_open": "Ultimi due fatture aperte",
      "latest_dues_invoice_overdue": "Ultimi due fatture in ritardo",
      "projected_not_generated": "Proiettato, non generato"
    },
    "bank": {
      "unmatched": "Senza eguali",
      "partially_matched": "Particolare corrispondenza",
      "matched": "Abbinamento",
      "reconciled": "Riconciliazione",
      "ignored": "Ignorato"
    },
    "reportStatus": {
      "draft": "Bozza",
      "open": "Aperto",
      "posted": "Contabilizzato",
      "paid": "Pagato",
      "partially_paid": "Parzialmente pagato",
      "void": "Annullato",
      "refunded": "Rimborsato",
      "unpaid": "Non pagato",
      "overdue": "Scaduto",
      "reconciled": "Riconciliazione",
      "pending": "In attesa",
      "approved": "Approvazione",
      "closed": "Chiuso"
    }
  },
  "match": {
    "supplier": "Fornitore: {name}",
    "member": "socio: {name}"
  },
  "payroll": {
    "pensionSummary": "Fornitore {provider} • Dipendente {employee} • Club {club}",
    "multiplier": "{value} x moltiplicatore",
    "periodRange": "{name} — {start} – {end}",
    "periodRangeWithPay": "{name} — {start} – {end} — Paga {pay}"
  },
  "glMemo": {
    "memberSale": "Punti vendita {sale} — {member}",
    "guestSale": "POS vendita {sale} — Ospite",
    "sale": "Vendita POS {sale}",
    "golf": "Servizio prenotazione Golf"
  },
  "validation": {
    "paymentRange": "L'importo deve essere compreso tra 0 e {amount} ."
  },
  "billing": {
    "itemCountOne": "{count} prodotto",
    "itemCountOther": "{count} articoli",
    "currentStatement": "Dichiarazione attuale ({period} )",
    "moveBack": "Torna a questa dichiarazione",
    "nextRun": "Prossima corsa di fatturazione",
    "futureRun": "Futuro processo di fatturazione",
    "deferredFrom": "Deferito da {period}",
    "deferredEarlier": "Deferito da fatturazione precedente",
    "mappingWarning": "Una tassa non ha mappatura dei ricavi (mapping key: {key} ). Configurare la mappatura prima della pubblicazione.",
    "warning": "Rivedere questo avviso di fatturazione prima di continuare."
  },
  "final": {
    "rows": "Righe",
    "schedule": "Calendario",
    "saveSettings": "Salvare le impostazioni",
    "required": "Obbligatorio",
    "yearReadiness": "{year} disponibilità"
  },
  "yearEnd": {
    "closedBy": "Fine anno chiuso {date} da {person}",
    "closed": "Fine anno chiuso su {date}"
  },
  "payrollExceptions": {
    "missing_calendar": {
      "title": "Calendario paghe mancante",
      "description": "Assegnare questo dipendente attivo a un calendario paghe."
    },
    "missing_rate": {
      "title": "Tasso attivo mancante",
      "description": "Aggiungere un tasso di paghe attivo che copre questo periodo di pagamento."
    },
    "profile_readiness": {
      "title": "Blocco di prontezza del profilo",
      "description": "Verificare i dati bancari, fiscali e pensioni del dipendente."
    },
    "missing_approved_timesheet": {
      "title": "Foglio di tempo approvato mancante",
      "description": "Approvare il foglio temporale del dipendente o rivedere la conferma consentita per questo periodo prima di procedere."
    },
    "invalid_rate": {
      "title": "Tasso di salario fisso non valido",
      "description": "Lo stipendio fisso e i profili ibridi hanno bisogno di un tasso di stipendio per il loro componente fisso."
    },
    "holiday_unpaid": {
      "title": "Orari di vacanza esclusi",
      "description": "Le attuali regole di pagamento non consentono il pagamento delle vacanze."
    },
    "sick_unpaid": {
      "title": "Ore di malattia escluse",
      "description": "Le attuali regole di pagamento non consentono la paga malata."
    },
    "missing_mapping": {
      "title": "Mancante paghe mappatura diario",
      "description": "Configurare account di debito e di credito per questo paghe costo o responsabilità in Impostazioni paghe."
    },
    "provider_deductions_required": {
      "title": "Ingressi normativi richiesti",
      "description": "Verificare e salvare gli importi dell'assicurazione nazionale per ogni dipendente prima dell'approvazione del PAYE e del dipendente/impiegato."
    },
    "employer_social_security_review": {
      "title": "Employer NI recensione richiesta",
      "description": "Verificare la configurazione del contributo del datore di lavoro prima che il libro paga possa procedere."
    }
  },
  "timesheets": {
    "missing": "Dipendenti a tempo determinato mancanti per questo periodo di pagamento: {count} .",
    "awaiting": "Le schede temporali inserite in attesa di approvazione per questo periodo di pagamento: {count} .",
    "overtime": "Gli straordinari sono concentrati per il periodo di pagamento selezionato.",
    "approved": "Tutti i fogli di tempo presentati sono approvati per il periodo di paghe selezionato."
  },
  "periods": {
    "closeEarlier": "Chiudere {periods} prima di chiudere {period} .",
    "earlierRequired": "I primi periodi di contabilità devono essere chiusi prima.",
    "fiscalMonth": "FY {year} Mese {month}"
  },
  "defaults": {
    "summary": "Giurisdizione: {jurisdiction} . Entrate, IVA, mapping paghe e conti di controllo verificati. Mapping IVA aggiornata: {tax} . Pagamenti politici recensiti: {policies} . Personalizzazione esistente conservata.",
    "uk": "Regno Unito",
    "us": "Stati Uniti",
    "region": "Regione del club paghe"
  },
  "portalCategories": {
    "membership": "Iscrizione",
    "dining": "Ristorazione e bar",
    "golf": "Golf",
    "spa": "Centro benessere",
    "racquet": "Racchetta",
    "fitness": "Fitness",
    "rooms": "Hotel / Camere",
    "events": "Eventi",
    "other": "Altre spese di conto"
  }
};
